import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalStorage } from 'ngx-store';
import { DragulaService } from 'ng2-dragula';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ServiceTypeAbbreviations } from '../service-type-abbreviations.enum';

// Models
import { Url, User } from '../../../model/users.model';
import { Run, RunDriver, RunEquipment, RunPlanActivity, RunRoute } from 'src/app/model/dispatch.model';

// Services
import { DispatchService } from '../../../services/dispatch.service';
import { DriversService } from '../../../services/drivers.service';
import { FleetPairingService } from '../../../services/fleet-pairing.service';
import { DriverTruckPairingService } from '../../../services/driver-truck-pairing.service';

@Component({
  selector: 'app-dispatchplanner',
  templateUrl: './dispatchplanner.component.html',
  styleUrls: ['./dispatchplanner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DispatchService, DriversService, DragulaService]
})
export class DispatchplannerComponent implements OnInit {
  @LocalStorage() url!: Url;
  @LocalStorage() user!: User;
  serviceTypeAbbreviations = ServiceTypeAbbreviations;

  //Boolean Declerations
  public spinner            : boolean = false;
  public loadSpinner        : boolean = false;
  public locationSpinner    : boolean = false;
  public failedToLoad       : boolean = false;
  public checkFilters       : boolean = true;
  public checkFleetFilters  : boolean = true;
  public checkTrailerFilters: boolean = true;
  public checkPairing       : boolean = true;
  public loadIndicator      : boolean = true;
  public check_JobType      : boolean = false;
  public viewBooking        : boolean = false;
  public mainloading        : boolean = false;
  public loadingIndicator   : boolean = false;
  public loadingRoute       : boolean = false;
  public isRouteApplicable  : boolean = true;
  public isChangeover       : boolean = false;
  public emptyActList       : boolean = false;
  public emptyDrvList       : boolean = false;
  public emptyTrkList       : boolean = false;
  public emptyTrlList       : boolean = false;
  public isD_available      : boolean = true;
  public isE_available      : boolean = true;
  public checkDateTime      : boolean = true;
  public checkWeekend       : boolean = true;
  public checkCollectRelease: boolean = true;
  public showdateOptions    : boolean = false;
  public showNotes          : boolean = false
  public collapse           : boolean = true;
  public collapseIconActivities : boolean = true;
  public collapseIconDrivers    : boolean = true;
  public collapseIconTrucks     : boolean = true;
  public collapseIconTrailers   : boolean = true;
  public showDetails            : boolean = false; 
  public showDetails2           : boolean = false; 
  public manifestSpinner  = [] //boolean 
  public showOtherWork    = [] //boolean 

  //Other Variable declerations
  public check_ServiceType   = 0; //0 - false, 1 - true, 2 - select correct service type
  public admin_user          = this.user.id;
  public fileStoragePath     = this.url.fileStorage;
  public dispatchNotes       = "Please take breaks as recommended and when required. Follow load restraint guidelines to secure your load and practice road safety at all times."
  public centerLat: number   = -33.395818;
  public centerLng: number   = 147.99444100000005;
  public userSettings       : any = {
    showSearchButton        : false,
    inputPlaceholderText    : 'Type key word on location to search',
    showCurrentLocation     : false
  };
  public actList           = [];
  public mapZoom: number   = 6;
  public positions         = [];
  public presetDrivers     = [];
  public presetEquipments  = [];
  public drivers           = [];
  public fleets            = [];
  public trucks            = [];
  public trailers          = [];
  public mapObj           : any;
  public mapLat;
  public mapLng;
  public pointdata        : any;
  public modalRef         : NgbModalRef;
  public folderPath       : string;
  public picfilePath      : string;
  public mapMarkers       : any;
  public driverLicenceClasses : string;   // Stores all drivers' licences
  public trailerErrors       : string = '';
  public warehouse_addresses = []
  

  //Forms
  addRouteForm                      : FormGroup;
  addTaskForm                       : FormGroup;
  addDispatchCategoryForm           : FormGroup;
  addRunplan                        : FormGroup;
  notesForm                         : FormGroup;
  excludedDatesForm                 : FormGroup;
  manifestExtraDetailsForm          : FormGroup;
  editSelectedGeofenceRadiusForm    : FormGroup;

  //modals
  @ViewChild('addNewRoute', { static: false }) addNewRoute: TemplateRef<any>;
  @ViewChild('addNewTask', { static: false }) addNewTask: TemplateRef<any>;
  @ViewChild('editNewTask', { static: false }) editNewTask: TemplateRef<any>;
  @ViewChild('taskExists', { static: false }) taskExists: TemplateRef<any>;
  @ViewChild('viewConnoteDetails', { static: false }) viewConnoteDetails: TemplateRef<any>;
  @ViewChild('connotePreset', { static: false }) connotePreset: TemplateRef<any>;
  @ViewChild('preDispatchModal', { static: false }) preDispatchModal: TemplateRef<any>;
  
  @ViewChild('driverModal', { static: false }) driverModal: TemplateRef<any>;
  @ViewChild('fleetModal', { static: false }) fleetModal: TemplateRef<any>;
  @ViewChild('dispatchResult', { static: false }) dispatchResult: TemplateRef<any>;
  @ViewChild('planSummary', { static: false }) planSummary: TemplateRef<any>;
  
  @ViewChild('updateManifestExtraDetails', { static: false }) updateManifestExtraDetails: TemplateRef<any>;
  @ViewChild('editselectedgeofence', { static: false }) editselectedgeofence: TemplateRef<any>;
  @ViewChild('deletePlanModal', { static: false }) deletePlanModal: TemplateRef<any>;

  @ViewChild('finalSortRT', { static: false }) finalSortRTModal: TemplateRef<any>;

  //filtering variables
  public JobType_List = [
    { id: 1, label: "Local" },
    { id: 2, label: "Linehaul" },
    { id: 4, label: "Tow Haul" },
    { id: 6, label: "PUD"} //new run_type
  ]

  public linehaul_Type = [
    {id: 1, name: "Full Truckload", alias: "ftl"},
    {id: 2, name: "Less-than Truckload", alias: "ltl"}
  ]

  public dg_types = [
    {id: 1, name: 'Packed'},
    {id: 2, name: 'Bulked'}
  ]

  public task_types = [
    {id: 3, name: 'Release'}, // only appears in edit
    {id: 4, name: 'Collect'}, // only appears in edit 
    {id: 5, name: 'Release & Collect (Changeover)'}, //Release & Collect
    {id: 9, name: 'Trailer Release'},
    {id: 10, name: 'Trailer Collect'},
    {id: 0, name: 'Trailer Release & Trailer Collect (PUD)'}
  ]

  //modal variables
  selectedConnote     : any;
  selectedActivity    : any;
  selectedTimeDate    : any;
  selectedRuns        : any;
  editAct_Temp        : any;
  currSelectedDriver  : any;
  currSelectedFleet   : any;
  selectedIndex       : any;
  selectedPreset      : any;
  final_route         : any;
  taskCount           : any;
  success_runs        : any;
  runIndexTrailer     : any;
  editMode            : boolean = false;
  
  job_Type            : number = 0;
  service_Type        : number = 0;
  taskReleaseCount    : number = 0;
  taskCollectCount    : number = 0;
  planCount           : number = 0;
  passedRunIndex      : number = 0;

  //Stores the full listings for dispatch
  public fullConnotes        = [];
  public fullTaskActivities  = [];
  public fullActivities      = [];
  public fulldrivers         = [];
  public fullfleets          = [];
  public fulltrucks          = [];
  public fulltrailers        = [];
  public addedTasks          = [];

  //Stores the filtered listings for dispatch
  public activitiesList      = [];
  public fleetList           = [];
  public driverList          = [];
  public trucksList          = [];
  public trailerList         = [];

  //multiple dispatch main array
  run_plan: Array<{
    run_type_id             : number;
    service_type_id         : number;
    check_trl_dups          : boolean;
    isStandardApplicable    : boolean;
    isLicenceApplicable     : boolean;
    isFleetTypeApplicable   : boolean;
    routeselected_id        : number;
    isRouteApplicable       : boolean;
    check_Driver            : boolean;
    check_Driver_Licence    : boolean;
    check_conflict_drv      : boolean;
    check_conflict_trk      : boolean;
    check_conflict_trl      : boolean;
    check_Truck             : boolean;
    check_regoExpiry        : boolean; //to check if rego expiry conflicts with activities
    check_regoTrailerExpiry : boolean; //to check if rego expiry conflicts with activities
    check_ServiceType       : number;
    checkAtrailer           : boolean;
    checkActivities         : boolean;
    checkER                 : boolean;
    checkLoad               : number; //change to number - 0 = false, 1 = true, 2 = warning to more than truckload
    checkChangeover         : boolean;
    checkTaskTime           : boolean;
    totalklms               : number;
    totaldrivinghours       : number;
    is_excluded_saturday    : number;
    is_excluded_sunday      : number;
    is_excluded_holiday_no  : number;
    excluded_holiday_dates  : any[];
    other_work_hour         : number;
    other_work_min          : number;
    other_rest_hours        : number;
    min_long_rest_hours     : number;
    min_short_rest_hours    : number;
    is_changeover           : boolean;
    manifest_changeover     : number; //is the paired run_plan index in current plan; default = null
    selectedPhases          : Array<{      //array to implement phases for changeover
      selectedActivities    : any[];
      selectedDriver        : any[];
      selectedFleet         : any[];
      selectedTrailer       : any[];
    }>;
    admin_notes             : string;
    dispatch_notes          : string;
    RTacts                  : any[];
  }> = []

  run_errors: Array<{
    timeError               : boolean;
    timeErrorString         : string;
    combinationError        : boolean;
    combinationErrorString  : string;
    startingError           : boolean;
    warehouseErrorString    : string;    //warehouse runtype exclusive
    warehouseError          : boolean;
    eq_warehouseString      : string;
    eq_warehouseError       : boolean;
    trailerErrors           : string;
    phaseCheck              : boolean,
    warehouseActivityCheck  : boolean,
    warehouseActivityError  : string,   //warehouse runtype exclusive end
  }> = []

  //Misc data declerations
  public routes              = []
  public run_actions         = [];
  public run_types           = [];
  public locations           = [];
  public service_types       = [];
  public states              = [];
  public run_statuses        = [];
  public connote_sites       = [];
  public driverListArray     = [];
  public driverPairings      = [];
  public trailerPairings     = [];
  public packaging_types     = [];
  public dg_licenses         = [];
  public dg_subsidiary_risks = [];
  public geofence_size_default: number = 0;

  //dispatchData declerations
  finalEquipments   : any;
  finalDrivers      : any;
  finalActivities   : any;
  finalTasks        : any;
  control_no        : string;
  linehaulType      : any;
  dispatch_jobType  : any;
  minimumHrs        : any;
  excluded_dates    : string;
  checkTime         : boolean;
  checkTime2        : boolean;
  control_noForm    : any;

  //Search Filters
  public showActivitySearch: boolean = false;
  public showDriverSearch: boolean = false;
  public showTruckSearch: boolean = false;
  public showTrailerSearch: boolean = false;
  public searchDriver: string = '';
  public searchActivity: string = '';
  public searchTruck: string = '';
  public searchTrailer: string = '';
  public keyActivity = [];
  public keyDriver = [];
  public keyTruck = [];
  public keyTrailer = [];

  constructor(private dispatchService: DispatchService, private driverService: DriversService, private fleetpairingService: FleetPairingService, private driverTruckPairingService: DriverTruckPairingService,
    private dragulaService: DragulaService, private modal: NgbModal, private fb: FormBuilder, private toastr: ToastrService, public router: Router) {

    this.dragulaService.dropModel("BOOKING_LIST").subscribe(args => { 
      this.selectedActivity = args.item;
    });

    this.dragulaService.drop("BOOKING_LIST").subscribe(args => {
      this.updateOnActivityDrop(this.selectedActivity);
      this.updateOnActivityPreset(this.selectedActivity);
    });

    this.dragulaService.dropModel("DRIVER_LIST").subscribe(args => {
      this.currSelectedDriver = args.item
    });

    this.dragulaService.drop("DRIVER_LIST").subscribe(args => {
      this.checkInfo('driver')
      this.getDriverAssignment('drop',0,0)
      this.getDriverPairings(this.currSelectedDriver)
    });

    this.dragulaService.dropModel("FLEET_LIST").subscribe(args => {
     this.currSelectedFleet = args.item
    });

    this.dragulaService.drop("FLEET_LIST").subscribe(args => {
      this.checkInfo('truck')
      this.getFleetAssignment('flt_drop', this.currSelectedFleet.id,0,0)
    });

    this.dragulaService.dropModel("TRAILER_LIST").subscribe(args => {
      this.currSelectedFleet = args.item
    });

    this.dragulaService.drop("TRAILER_LIST").subscribe(args => {
      this.checkInfo('trailer')
      if(args.target.id !== args.source.id){
        this.getFleetAssignment('trl_drop', this.currSelectedFleet.id,0,0)
        this.runIndexTrailer = args.target.id.charAt(args.target.id.length - 1);
        this.getTrailerPairings(this.currSelectedFleet)
      }
    });

    // Prevents an item in the TRAILER_LIST to be moved with .card-dashed class
    this.dragulaService.createGroup('TRAILER_LIST', {
      revertOnSpill: true,
      copy: (el, source) => {
        return source.id === 'trailer1_list';
      },
      copyItem: (item) => ({...item}),
      accepts: (el, target, source, sibling) => {
        // To avoid dragging from back to listing container
        return target.id !== 'trailer1_list';
      },
      moves: (el) => !el.classList.contains('card-dashed')
    });

    // Prevents an item in the FLEET_LIST to be moved with .card-dashed class
    this.dragulaService.createGroup('FLEET_LIST', {
      moves: (el) => !el.classList.contains('card-dashed')
    });

    // Prevents an item in the DRIVER_LIST to be moved with .card-dashed class
    this.dragulaService.createGroup('DRIVER_LIST', {
      moves: (el) => !el.classList.contains('card-dashed')
    });

    // Prevents an item in the BOOKING_LIST to be moved with .card-dashed class
    this.dragulaService.createGroup('BOOKING_LIST', {
      moves: (el) => !el.classList.contains('card-dashed')
    });

    this.dragulaService.createGroup('ROADTRAIN_LIST', {
      accepts: function (el, target, source, sibling) {
        return target.id === source.id;
      }    

    });
  }

  async ngOnInit(): Promise<void> {
    await this.getLocation()
    await this.getData();
    this.getPairing();
    this.getDriverLicenseClasses();
    this.initAddRouteForm();
    this.initAddTaskFormv2();
    this.runPlanForm(this.planCount);
    this.folderPath = this.url.fileStorage + '/drivers/';
  }

  /**
   * Initializes the form for adding a new route.
   */
  initAddRouteForm() {
    this.addRouteForm = this.fb.group({
      id                    : [''],
      klms                  : ['', Validators.required],
      description           : ['', Validators.required],
      start_state_id        : ['', Validators.required],
      end_state_id          : ['', Validators.required],
      changeover_state_id   : [''],
      created_by            : [this.admin_user],
      updated_by            : [null]
    });
  }

  /**
   * Initializes the form for adding a new task.
   */
  initAddTaskFormv2() {
    this.addTaskForm = this.fb.group({
      id              : [null],
      run_action_id   : ['', Validators.required],
      connote_id      : [''],
      connote         : [''],
      releasePoint    : this.initAddress(),
      collectPoint    : this.initAddress(),
      company_name    : [''],
      contact_name    : [''],
      contact_no      : [''],
      u_id            : [''],
      index           : [''], //for edit mode
      site_source     : [''],
      changeover      : [''], //for edit mode
      warehousing     : [''], //checks for warehousing
      createCollect   : [false],
    });

  }

  /**
   * Initializes and return a form group with address-related contents.
   * @returns The form group containing the address details.
   */
  initAddress(){
    let today: Date = new Date();
    let new_date = today.toISOString().substring(0,10);

    for(var i=1 ;i<=4;i++){
      var quarter_min = Math.ceil((today.getMinutes() / 15)) *15 +(i*15);
      var d2 = new Date(today.getTime() + (quarter_min - today.getMinutes()) *60000);
    }

    var hours = (d2.getHours()%24) -1;
    var minutes = d2.getMinutes();
    if (hours == -1) hours = 11;

    return this.fb.group({
      date            : [new_date],
      start_time      : [{hour: hours , minute: minutes}],
      end_time        : [{hour: hours , minute: minutes}],
      location_id     : [null],
      lat             : [''],
      long            : [''],
      street_no       : [''],
      street          : [''],
      city            : [''],
      suburb          : [''],
      state           : [''],
      postal_code     : [''],
      location_type   : ['other'], //default value
      location_type2   : ['other'], //default value
      locationString  : [''],
      state_id        : [''],
      geofence        : [{
          radius      : this.geofence_size_default,
          created_by  : this.admin_user
      }],
    })
  }

  /**
   * Get the action of the job.
   * @returns The selected run action.
   */
  getTaskType() { 
    const pmCtrl = (<any>this.addTaskForm).controls.run_action_id;
    return pmCtrl.value; 
  }

  /**
   * Gets the released connote location type (e.g. commercial/residential).
   * @returns The selected released connote location type.
   */
  getReleaseLocationType() { 
    const pmCtrl = (<any>this.addTaskForm).controls.releasePoint;
    const typeCtrl = pmCtrl.controls.location_type;
  
    return typeCtrl.value; 
  }

  /**
   * Gets the collected connote location type (e.g. commercial/residential).
   * @returns The selected collected connote location type.
   */
  getCollectLocationType() { 
    const pmCtrl = (<any>this.addTaskForm).controls.collectPoint;
    const typeCtrl = pmCtrl.controls.location_type2;
  
    return typeCtrl.value; 
  }

  /**
   * Initializes the form for other manifest details.
   */
  initManifestExtraDetailsForm(){
    this.manifestExtraDetailsForm = this.fb.group({
      index           : [''],
      excluded_dates  : [''],
      is_excludedsat  : [''],
      is_excludedsun  : [''],
      is_excludedhol  : [''],
      admin_notes     : [''],
      dispatch_notes  : [''],
    })
  }

  /**
   * Initializes the form for editing selected geofence radius.
   */
  initEditSelectedGeofenceRadiusForm() {
    this.editSelectedGeofenceRadiusForm = this.fb.group({
      run_index                 : [''],
      phase_index               : [''],
      site_index                : [''],
      radius                    : ['', [Validators.required, Validators.min(250)]],
      created_by                : [this.admin_user, Validators.required]
    })
  }

  /**
   * Initializes a new plan in the form.
   * @param planNum - The plan number.
   */
  public runPlanForm(planNum) {
    this.run_plan[planNum] = { //starting array for multiple dispatch
      run_type_id:             null,
      service_type_id:         null,
      check_trl_dups:          false,
      isStandardApplicable:    true,
      isLicenceApplicable :    true,
      isFleetTypeApplicable:   true,
      routeselected_id:        null,
      isRouteApplicable:       true,
      check_Driver:            true,
      check_Driver_Licence:    true,
      check_conflict_drv:      true,
      check_conflict_trk:      true,
      check_conflict_trl:      true,
      check_Truck:             true,
      check_regoExpiry:        false,
      check_regoTrailerExpiry: false,
      check_ServiceType:       0,
      checkAtrailer:           false,
      checkActivities:         true,
      checkER:                 true,
      checkLoad:               0,
      checkChangeover:         true,
      checkTaskTime:           true,
      totalklms:               0,
      totaldrivinghours:       0,
      is_excluded_saturday:    1,
      is_excluded_sunday:      1,
      is_excluded_holiday_no:  0,
      excluded_holiday_dates:  [],
      other_work_hour:         1 ,
      other_work_min:          30,
      other_rest_hours:        null,
      min_long_rest_hours:     null,
      min_short_rest_hours:    null,
      is_changeover:           false,
      manifest_changeover:     null,
      admin_notes:             null,
      dispatch_notes:          this.dispatchNotes,
      RTacts                  : [],
      selectedPhases: [{
        selectedActivities:  [],
        selectedDriver:      [],
        selectedFleet:       [],
        selectedTrailer:     [],
      }]
    }
    this.run_errors[planNum] = {
      timeError: false,
      timeErrorString:'',
      combinationError: false,
      combinationErrorString: '',
      startingError: false,
      warehouseErrorString: '',
      warehouseError: false, // driver errors on warehousing
      eq_warehouseString: '',
      eq_warehouseError: false, //equipment errors on warehousing
      trailerErrors: '',
      phaseCheck: true, //check if added phases has activities and trailers
      warehouseActivityCheck: false, //per phase activity checker
      warehouseActivityError: '', //per phase activity checker error string
    }

    this.showOtherWork[planNum] = true;
  }

  /**
   * Add a phase to the plan.
   * @param runIndex - The index of the run.
   */
  public addNewPhase(runIndex){
    let phaseCount = this.run_plan[runIndex].selectedPhases.length
    this.addPhaseForm(runIndex, phaseCount)
  }

  /**
   * Adds a new phase form to the plan.
   * @param runIndex - The index of the run.
   * @param phaseCount - The count of phases.
   */
  public addPhaseForm(runIndex, phaseCount){
    this.run_plan[runIndex].selectedPhases[phaseCount] = {
      selectedActivities:   [],
      selectedDriver:       [],
      selectedFleet:        [],
      selectedTrailer:      [],
    }
  }

  /**
   * Deletes a phase from the plan.
   * @param runIndex - The index of the run.
   * @param phaseIndex - The index of the phase to delete.
   */
  public deletePhase(runIndex, phaseIndex){

    this.run_plan[runIndex].selectedPhases[phaseIndex].selectedActivities.forEach(act => {
      if(act.isAddedTask == true){
        let taskIndex = this.addedTasks.findIndex(x=> x.u_id == act.u_id)
        if(taskIndex != undefined) this.addedTasks[taskIndex].order_number = 0;

        this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
        this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
        this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
      }
    });

    this.run_plan[runIndex].selectedPhases.splice(phaseIndex, 1);
    this.resetDispatch('dispatch_area_reset')
    this.updateJobService_filter();
    this.getAllActivities();
  }

  /**
   * Adds a new plan to the run plan array.
   */
  public addNewPlan() {
    let planCount = this.run_plan.length;
    this.runPlanForm(planCount)
  }

  /**
   * Deletes a plan from the run plan array.
   * @param index - The index of the plan to delete.
   */
  public deleteNewPlan(index) {
    //remove selected planner
    const changeover = this.run_plan[index].manifest_changeover;
    if(changeover != null || changeover != undefined){
      this.run_plan[changeover].manifest_changeover = null;
      this.run_plan[changeover].is_changeover = false;
    }

    this.run_plan[index].selectedPhases.forEach(phase =>{
      phase.selectedActivities.forEach(act => {
        if(act.isAddedTask == true){
          let taskIndex = this.addedTasks.findIndex(x=> x.u_id == act.u_id)
          if(taskIndex != undefined) this.addedTasks[taskIndex].order_number = 0;

          this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
          this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
          this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
        }
      });
    })

    this.run_plan.splice(index, 1);
    this.run_errors.splice(index, 1);
    this.showOtherWork.splice(index, 1)
    this.resetDispatch('dispatch_area_reset')
    this.updateJobService_filter();
    this.getAllActivities();
    this.modal.dismissAll();
  }

  // Modals Functions

  /**
   * Opens the modal for adding a new route.
   */
  public openRoutesModal() {
    this.initAddRouteForm();
    this.isChangeover = false;
    this.modal.open(this.addNewRoute, { backdrop: 'static', size: 'xs', });
  }

  /**
   * Opens the modal for adding a new task (activity).
   * @param row - The selected connote data.
   * @param run_index - The run index of the selected connote.
   * @param phase_index - The phase index of the selected connote.
   */
  public openTaskModal(row, run_index, phase_index) {
    this.locationSpinner = false;
    this.initAddTaskFormv2();
    this.editMode = false;
    this.checkWeekend = true;
    this.checkCollectRelease = true;
    this.control_noForm = row.control_no;
    this.selectedIndex = [run_index, phase_index, this.run_plan[run_index].run_type_id];
    this.selectedConnote = row.connote
    let pickups = row.connote.connote_sites.filter(x=>x.run_action_id == 1 || x.run_action_id == 10 || x.run_action_id == 14)
    let deliveries = row.connote. connote_sites.filter(x=>x.run_action_id == 2 || x.run_action_id == 9 || x.run_action_id == 15)
    if(pickups.length == 0){
      this.selectedTimeDate = {
        'set': 'no_pickup',
        'start': null,
        'end' : deliveries[0].opening_datetime

      }
    } else if(deliveries.length == 0){
      this.selectedTimeDate = {
        'set': 'no_delivery',
        'start': pickups[pickups.length-1]?.closing_datetime,
        'end' : null,
      }
    } else {
      this.selectedTimeDate = {
        'set': 'paired',
        'start': pickups[pickups.length-1]?.closing_datetime,
        'end' : deliveries[0].opening_datetime,
        'start_col': pickups[pickups.length-1]?.closing_datetime,
        'end_col': deliveries[0].opening_datetime
      }
    }
    this.checkDates();

    //task check removed
    this.addTaskForm.controls.index.setValue(run_index);
    this.addTaskForm.controls.site_source.setValue(row);

    this.modal.open(this.addNewTask, { backdrop: 'static', size: 'lg', centered: true });
  }

  /**
   * Opens the modal for updating a task (activity).
   * @param row - The selected connote data.
   * @param plan - The plan number of the selected connote.
   * @param phase - The phase number of the selected connote.
   * @param count - The index of the selected connote.
   */
  public editNewActivity(row, plan, phase, count){
    this.editMode = true;   this.showDetails = true;
    this.initAddTaskFormv2();
    this.selectedIndex = [plan, this.run_plan[plan].manifest_changeover, (row.u_id)?row.u_id:row.id];
    this.editAct_Temp = {id : row.connote_site_id}
    this.selectedActivity = [this.run_plan[plan].selectedPhases,[]];
    if(this.selectedIndex[1] != null && this.selectedIndex[1] != 'null') this.selectedActivity[1] = this.run_plan[this.selectedIndex[1]].selectedPhases;
    let d: Date = new Date(row.opening_datetime);
    let d2: Date = new Date(row.closing_datetime);

    for(var i=1 ;i<=4;i++){
      var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
      var quarter_min2 = Math.ceil((d2.getMinutes() / 15)) *15 +(i*15);
      var d_time = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
      var d_time2 = new Date(d2.getTime() + (quarter_min2 - d2.getMinutes()) *60000);
    }

    var hours = (d_time.getHours()%24) -1; var hoursb = (d_time2.getHours()%24) -1;
    var minutes = d_time.getMinutes(); var minutesb = d_time2.getMinutes();
    if (hours == -1) hours = 11; if (hoursb == -1) hoursb = 11;
  
    //start date time
     let testrow = {
      'id': row.id,
      'u_id': (row.isAddedTask)? row.u_id: '',
      'run_action_id': row.run_action_id,
      'index': [plan, phase, count],
      'changeover': this.run_plan[plan].manifest_changeover,
      'warehousing': (row.isAddedTask)? row.warehousing: '',
      releasePoint:{
        'start_time': {hour: hours , minute: minutes},
        'end_time': {hour: hoursb , minute: minutesb},
        'date': d.toISOString().substring(0,10),
        'location_id': row.location_id,
        'lat': row.location_lat,
        'long': row.location_lng,
        'street_no': row.location_street_no,
        'street': row.location_street,
        'city': row.location_city,
        'suburb': row.location_suburb,
        'state': row.state_abbrev,
        'state_id': row.state_id,
        'postal_code': row.location_postal,
      }
    }
    this.addTaskForm.patchValue(testrow);
    this.addTaskForm.controls.site_source.setValue(row);
    this.checkDatesEdit();
    this.modal.open(this.editNewTask, { backdrop: 'static', size: 'xl', centered: true });
  }

  /**
   * Opens a modal to confirm deletion of a plan.
   * @param run_index - The index of the plan to be deleted.
   */
  public openDeletePlanModal(run_index){
    this.selectedIndex = run_index;
    this.modal.open(this.deletePlanModal, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Opens a modal to show applied setup of the booked connote.
   * @param run_index - The index of the run plan to show presets for.
   */
  public openPresetModal(run_index) {
    this.selectedIndex = run_index
    this.modal.open(this.connotePreset, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Opens a modal to view connote details.
   * @param row - The data containing connote information.
   */
  public openViewConnoteModal(row) {
    this.selectedConnote = row.connote
    this.showPresets(row.connote_id)
    this.modal.open(this.viewConnoteDetails, { backdrop: 'static', size: 'xl', centered: true });
  }

  /**
   * Checks for Road Train configurations and opens the final sorting modal if applicable.
   */
  public openCheckRT(){
    this.run_plan.forEach((run, i:number) => {
      if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){
        let temp = this.getPlanActivities(i)
        run['RTacts'] = this.sortRoadTrain(temp);
      }
    });

    let roadTrainCount = this.run_plan.filter(x=> this.isServiceTypeMatch(x.service_type_id, ServiceTypeAbbreviations.RoadTrain)).length;
    if(roadTrainCount > 0){
      this.modal.open(this.finalSortRTModal, { backdrop: 'static', size: 'xs', centered: true });
    } else this.openPreDispatchModal();
    
  }

  /**
   * Opens the pre-dispatch modal after performing necessary calculations.
   */
  public async openPreDispatchModal() {
    this.modal.dismissAll();
    this.loadingIndicator = true;
    for (let i = 0; i < this.run_plan.length; i++) {
      await this.getTotalKlms(i);

      let temp, isActive = this.run_plan[i].selectedPhases[0].selectedDriver

      if(isActive.length == 2){
        if(isActive[0].driver_standard_id == 1) temp = "BFM 2 UP";
        else if(isActive[0].driver_standard_id == 2) temp = "AFM 2 UP";
        else if (isActive[0].driver_standard_id == 3) temp = "Standard Hours 2 UP";
      } else {
        if(isActive[0].driver_standard_id == 1) temp = "BFM SOLO";
        else if(isActive[0].driver_standard_id == 2) temp = "AFM SOLO";
        else if (isActive[0].driver_standard_id == 3) temp = "Standard Hours SOLO";
      }

      if( isActive[0].driver_standard_id != 4 || isActive[0].driver_standard_id != 5){
        const work_hours = this.run_plan[i].totaldrivinghours + this.run_plan[i].other_work_hour + (this.run_plan[i].other_work_min/60)
        let hours_data = { "total_work_hours": work_hours, "driver_standard": temp }

        await this.dispatchService.getMinimumRestHrs(hours_data).toPromise().then(data => {
          this.run_plan[i].min_short_rest_hours = data['minimum_short_rest'];
          this.run_plan[i].min_long_rest_hours = data['minimum_long_rest'];
          this.run_plan[i].other_rest_hours = data['other_rest'];
        })
      } else {
        this.run_plan[i].min_short_rest_hours = 0;
        this.run_plan[i].min_long_rest_hours = 0;
        this.run_plan[i].other_rest_hours = 0;
      }

    }
    if (this.taskCount > 0){
      this.modal.open(this.preDispatchModal, { backdrop: 'static', size: 'xs', centered: true });
      this.loadingIndicator = false;
    } else this.onSubmitDispatch();
  }

  /**
   * Opens a modal to update the geofence radius for a selected activity.
   * @param activity - The activity to edit the geofence for.
   * @param run_index - The index of the plan.
   * @param phase_index - The index of the phase within the plan.
   * @param siteIndex - The index of the site within the phase.
   */
  openSelectedGeofenceRadiusModal(activity, run_index, phase_index, siteIndex){
    this.initEditSelectedGeofenceRadiusForm();

    let patchData = {
      'run_index'   : run_index,
      'phase_index' : phase_index,
      'site_index'  : siteIndex,
      'radius'      : activity.connote ? activity.geofence.radius : activity.connote_site.geofence.radius,
      'created_by'  : activity.connote ? activity.geofence.created_by : activity.connote_site.geofence.created_by
    }
    this.editSelectedGeofenceRadiusForm.patchValue(patchData);
    this.modal.open(this.editselectedgeofence, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Open a modal to edit other manifest details.
   * @param runIndex The index of the plan to edit.
   */
  public openRunDetailsModal2(runIndex){
    this.passedRunIndex = runIndex;

    this.initManifestExtraDetailsForm();

    if(this.run_plan[runIndex].is_excluded_holiday_no == 1) this.showdateOptions = true; else this.showdateOptions = false;
    let sat, sun, holi, list=[], prevDates=[], currDates=[]; this.actList = [];
    
    this.run_plan[runIndex].selectedPhases.forEach(phase => {
      phase.selectedActivities.forEach(a => { list.push(a)});
    });
    if(list.length!=0){
      let from = new Date(list[0].opening_datetime);
      let to = new Date(list[list.length-1].closing_datetime);
      var day;

      for (day = from; day <= to; day.setDate(day.getDate() + 1)) {
        let temp = {
          "date": formatDate(day,'MM/dd/yyyy', 'en_US'),
          "value": false,
        }
        prevDates.push(temp.date); this.actList.push(temp);
      }
      if(day > to){
        let lastdate = formatDate(day,'MM/dd/yyyy', 'en_US')
        let destinationdate = formatDate(to,'MM/dd/yyyy', 'en_US')
        if(lastdate == destinationdate){
          let temp = {
            "date": formatDate(day,'MM/dd/yyyy', 'en_US'),
            "value": false,
          }
          prevDates.push(temp.date); this.actList.push(temp);
        }
      }
    }

    this.run_plan[runIndex].excluded_holiday_dates.forEach(el => { currDates.push(el.date) });
    if(currDates.length != 0 && JSON.stringify(prevDates) === JSON.stringify(currDates)) this.actList = this.run_plan[runIndex].excluded_holiday_dates;

    if(this.run_plan[runIndex].is_excluded_saturday == 1) sat = true; else sat = false;
    if(this.run_plan[runIndex].is_excluded_sunday == 1) sun = true; else sun = false;
    if(this.run_plan[runIndex].is_excluded_holiday_no == 1) holi = true; else holi = false;
    if(this.actList.length == 0) holi = false;
    
    const patchData = {
      'index'         : runIndex,
     
      'is_excludedsat': sat,
      'is_excludedsun': sun,
      'is_excludedhol': holi,
      'excluded_dates': this.actList,

      'admin_notes'   : this.run_plan[runIndex].admin_notes,
      'dispatch_notes': this.run_plan[runIndex].dispatch_notes,
    }

    this.manifestExtraDetailsForm.patchValue(patchData);
    this.modal.open(this.updateManifestExtraDetails, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Opens a modal to view driver information.
   * @param driver The driver object.
   * @param source The source of the driver information
   * @param index The index of the driver in the list.
   * @param phase The phase number of the plan.
   */
  public openDriverModal(driver, source, index, phase){
    this.currSelectedDriver = driver
    if(!driver['current_assignments']) this.getDriverAssignment(source, index, phase); else this.spinner = false;
    this.modal.open(this.driverModal, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Opens a modal to view the fleet information.
   * @param equipment The fleet object.
   * @param source The source of the fleet information.
   * @param index The index of the fleet in the list.
   * @param phase The phase number of the plan.
   */
  openEquipmentModal(equipment, source, index, phase){
    this.currSelectedFleet = equipment;
    if(!equipment['current_assignments']) this.getFleetAssignment(source, equipment.id, index, phase); else this.spinner = false;
    this.modal.open(this.fleetModal, { backdrop: 'static', size: 'xs', centered: true });
  }

  /**
   * Opens a modal to show a summary of the created plan/s
   */
  openSummary(){
    this.modal.open(this.planSummary, { backdrop: 'static', size: 'xl', centered: true });
  }
  // End of modals

  // Check Modals

  /**
   * Checks if there are any added tasks for the selected connote.
   * @returns True if there are added tasks, false otherwise.
   */
  public checkAddedTasks(){
    if(this.addedTasks.length != 0 && this.selectedConnote != undefined){
      let count = this.addedTasks.filter(x=>x.connote_id == this.selectedConnote.id).length
      if (count != 0) return true; return false;
    } else return false;
  }

  /**
   * Checks if there are any excluded dates (i.e. holidays) created for submission.
   * @returns True if there are added tasks, false otherwise
   */
  checkExDates_Submit(){
    let trueCount = 0

    this.actList.forEach(check => { if(check.value == true) trueCount++; });
    if(this.showdateOptions == true){
      if(trueCount!=0) return true; else return false;
    } else return true;
  }

  /**
   * Toggles the display of date options based on "On Holidays" checkbox.
   */
  checkEx_Dates(){
    let value = this.manifestExtraDetailsForm.get('is_excludedhol').value;
    if(value == true) this.showdateOptions = true; else this.showdateOptions = false;
  }

  /**
   * Checks if the route validations for changeover jobs are met.
   * @returns True if route validations are met, false otherwise.
   */
  public checkRouteValidations() {
    let value = this.addRouteForm.get('changeover_state_id').value
    if (this.isChangeover == true) {
      if (value) return true; else return false;
    } else return true
  } //end checkRouteValidations

  /**
   * Did not use this in the planner. Is this obsolete?
   */
  public checkTrailers() {
    this.run_plan.forEach(run=>{
      let check_trailer = [], t_check;
      for (let i = 0; i < run.selectedPhases.length; i++) {
        var occurrences = run.selectedPhases[i].selectedTrailer.filter(function (val) {
          return val.fleet_subtype_id === 4; //checks how many A trailers in dispatch area
        }).length;
        if (occurrences > 1) check_trailer[i] = true; else check_trailer[i] = false;
    }
    t_check = check_trailer[0]
    check_trailer.forEach(check => {
      if(t_check == true || check == true){
        t_check = true
      } else t_check = false;
    });
    if (t_check == true) run.checkAtrailer = true; else run.checkAtrailer = false; //more than 1 trailer 
    if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)) run.checkAtrailer = false; //remain false if it's a road train
    });
  } //end checkTrailers

  /**
   * Performs checks based on the type of information (driver, truck, trailer).
   * @param type The type of information to check.
   */
  public checkInfo(type){
    switch(type){
      case 'driver':{
        this.run_plan.forEach(run=>{
          var expiry = 0, check_drv = [], ex_check, d_check; let driv_count = 0;
          for (let i = 0; i < run.selectedPhases.length; i++) {
            const driver_length = run.selectedPhases[i].selectedDriver.length;
            driv_count = driv_count + driver_length;
            if(i == 0){
              if(driver_length == 0) check_drv[i] = true;
              else if(driver_length != 0 && driver_length <=2 ) check_drv[i] = true; else check_drv[i] = false
            } else {
              if(driver_length >= 3 ) check_drv[i] = false; else check_drv[i] = true
            }
            expiry = expiry + run.selectedPhases[i].selectedDriver.filter( x=> x.is_expired == 1).length;
          }

          // Check for expired licence of Drivers
          expiry > 0 ? run.check_Driver_Licence = false : run.check_Driver_Licence = true;

          d_check = check_drv[0]
          check_drv.forEach(check => {
            if(d_check == false || check == false) d_check = false; else d_check = true;
          });
          if (d_check == false) run.check_Driver = false; else run.check_Driver = true;
          if(run.run_type_id == 6){ //warehouse check
            if(driv_count > 2) run.check_Driver = false; else run.check_Driver = true;
          } 
        });
        break;
      } case 'truck':{
        this.run_plan.forEach(run=>{
          run.check_regoExpiry = false;
          var check_trk = [], tr_check, activities = []; let trk_count = 0
          for (let i = 0; i < run.selectedPhases.length; i++) {
            const truck_length = run.selectedPhases[i].selectedFleet.length;
            trk_count = trk_count + truck_length;
            if(i == 0){
              if(truck_length == 0) check_trk[i] = true;
              else if(truck_length == 1) check_trk[i] = true; else check_trk[i] = false;
            } else {
              if(truck_length >= 2) check_trk[i] = false; else check_trk[i] = true;
            }
            run.selectedPhases[i].selectedActivities.forEach(el => {activities.push(el);});
          }

          if(run.selectedPhases[0].selectedFleet.length != 0 && run.selectedPhases[0].selectedActivities.length != 0){
             let due_date = new Date(run.selectedPhases[0].selectedFleet[0].rego_due_date)
             if(due_date < new Date(activities[0].opening_datetime) && due_date < new Date(activities[activities.length-1].closing_datetime)){
                run.check_regoExpiry = true;
             } else run.check_regoExpiry = false;
          }
          tr_check = check_trk[0]
          check_trk.forEach(check => { 
            if(!tr_check|| !check) tr_check = false; else tr_check = true;
          });

          if (!tr_check) run.check_Truck = false; else run.check_Truck = true;
          if(run.run_type_id == 6){ //warehouse check
            if(trk_count > 1) run.check_Truck = false; else run.check_Truck = true;
          }
        })
        this.checkPairings();
        break;
      } case 'trailer':{
        this.run_plan.forEach(run=>{
          run.check_regoTrailerExpiry = false;
          var trls = [], check_trailer = [], t_check,  activities = [], expiry_check = [];
          for (let i = 0; i < run.selectedPhases.length; i++) {
            var occurrences = run.selectedPhases[i].selectedTrailer.filter(function (val) {
              return val.fleet_subtype_id === 4; //checks how many A trailers in dispatch area
            }).length;
            if (occurrences > 1) check_trailer[i] = true; else check_trailer[i] = false;

            run.selectedPhases[i].selectedActivities.forEach(el => {activities.push(el);});
            run.selectedPhases[i].selectedTrailer.forEach(el => {trls.push(el);});

            //check expiry
            if(run.selectedPhases[i].selectedTrailer.length != 0 && run.selectedPhases[i].selectedActivities.length != 0){
              let checkrego = [];
              run.selectedPhases.forEach((phase, count:number)=>{
                phase.selectedTrailer.forEach((trl, i:number) => {
                  let due_date = new Date(trl.rego_due_date)
                   if(due_date < new Date(activities[0].opening_datetime) && due_date < new Date(activities[activities.length-1].closing_datetime)){
                    checkrego[i] = true;
                   } else checkrego[i] = false;
                });

                let check = checkrego[0];
                checkrego.forEach(el => { (el||check)? check = true: check = false;});
                (check)? expiry_check[count] = true: expiry_check[count] = false;
              })
            }
          }

          //for checking duplicates (PUD only - changed added 06/09/2022)
          if(run.run_type_id != 6){
            const lookup = trls.reduce((a, e) => {
              a[e.id] = ++a[e.id] || 0;
              return a;
            }, {});
            if(trls.filter(e => lookup[e.id]).length > 0) run.check_trl_dups = true; else run.check_trl_dups = false;
          } else run.check_trl_dups = false;

          t_check = check_trailer[0]
          check_trailer.forEach(check => {
            (t_check||check)? t_check = true: t_check = false;
          });
          if (t_check) run.checkAtrailer = true; else run.checkAtrailer = false; //more than 1 trailer 
          if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)) run.checkAtrailer = false; //remain false if it's a road train
          let t_expiry = expiry_check.filter(function (val) { return val == true;}).length;
          if (t_expiry > 0) run.check_regoTrailerExpiry = true; else run.check_regoTrailerExpiry = false;
        });
        break;
      } default: break;
    }
  }
  // End of Check Modals

  // Dispatch other functions

  /**
   * Saves the geofence radius for a specific activity.
   * @param value The geofence radius value and associated connote activity details.
   */
  saveSelectedGeofenceRadius(value){
    this.run_plan[value.run_index].selectedPhases[value.phase_index].selectedActivities[value.site_index].geofence.radius = value.radius;
    this.run_plan[value.run_index].selectedPhases[value.phase_index].selectedActivities[value.site_index].geofence.created_by = value.created_by;
    this.modal.dismissAll();
  }

  /**
   * Saves the other manifest details.
   * @param value The other manifest details' object.
   */
  saveManifestExtraDetails(value){
    // Saving notes
    this.run_plan[value.index].admin_notes = value.admin_notes;
    this.run_plan[value.index].dispatch_notes = value.dispatch_notes;

    // Saving excluded dates
    let sat, sun, holi;

    if( value.is_excludedsat == true) sat = 1; else sat = 0;
    if( value.is_excludedsun == true) sun = 1; else sun = 0;
    if( value.is_excludedhol == true) holi = 1; else holi = 0;
    if(holi == 0) this.actList = [];

    this.run_plan[value.index].is_excluded_saturday   = sat;
    this.run_plan[value.index].is_excluded_sunday     = sun;
    this.run_plan[value.index].is_excluded_holiday_no = holi;
    this.run_plan[value.index].excluded_holiday_dates = this.actList;
    this.modal.dismissAll();
  }

  /**
   * Toggles the selection of dates based on "On Holidays" checkbox. 
   * @param i The index of the date to toggle.
   */
  toggledates(i){
    if(this.actList[i].value == false){
      this.actList[i].value = true
    } else this.actList[i].value = false
  }

  /**
   * Did not use this in the planner. Is this obsolete?
   */
  updatePlan(job_type, service_type) {
    if (job_type == 1)
      this.run_plan[this.run_plan.length - 1].routeselected_id = null;

    this.run_plan[this.run_plan.length - 1].run_type_id = job_type.id;
    this.run_plan[this.run_plan.length - 1].service_type_id = service_type.id;
  }

  /**
   * Updates the route for a specific plan.
   * @param runIndex The index of the plan
   * @param route The route object.
   */
  updatePlanRoute(runIndex, route) {
    this.run_plan[runIndex].routeselected_id = route.id;
  }
  // End of Dispatch other functions

  //DISPATCH FILTERS

  /**
   * Updates the plan filters based on the job type and service type.
   * @param index The index of the plan to update.
   */
  public updateCategory_filter(index) {
    this.job_Type = this.run_plan[index].run_type_id;
    this.service_Type = this.run_plan[index].service_type_id;
    this.run_plan[index].check_ServiceType = 0;

    if (this.job_Type != null && this.service_Type != null) {
      if (this.job_Type == 1) { //Local & does not require route
          this.run_plan[index].isRouteApplicable = true;
          this.run_plan[index].routeselected_id = null;
        if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.ATrailer) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BTrailer)) {
          this.run_plan[index].check_ServiceType = 2;
        } else this.run_plan[index].check_ServiceType = 0;

        if (this.run_plan[index].check_ServiceType == 0) {
          this.loadSpinner = true;
          this.resetDispatch('dispatch_area_reset')
          this.updateJobService_filter();
          this.getAllActivities();
        }
      } else {
        if (this.job_Type == 4)
          if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMOnly) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMOnly)) this.run_plan[index].check_ServiceType = 0; else this.run_plan[index].check_ServiceType = 2;

        if (this.run_plan[index].check_ServiceType == 0) {
          this.loadSpinner = true;
          this.resetDispatch('dispatch_area_reset')
          this.updateJobService_filter();
          this.getAllActivities();
        } 
      }
    }

    if(this.job_Type != null && this.service_Type != null){
      console.log('jobtype: ', this.job_Type, ', serviceType:', this.service_Type);
    }
  }

  /**
   * Updates the job and service type filters and refreshes the dispatch workspace.
   */
  public updateJobService_filter() {
    this.trucks = [], this.trailers = []
    let drivers = []; this.check_ServiceType = 0;

    this.trucks = this.fulltrucks.filter(data => {
      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.UTE)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.Rigid) 
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne4P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMOnly)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMOnly)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne8P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne14P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TenPalletRigid)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne6P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne10P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.EightTonne12P)
        || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne12P)) { //ute & rigids
        this.trailerList = [];

        if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.UTE) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.Rigid)) { //ute
          return (this.service_Type == data.fleet_type_id || data.fleet_type_id == 2); //UTE & Rigid can be used
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne4P)) { //2T4P -- All rigids can be used
          return this.service_Type == data.fleet_type_id;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMOnly)) { //Semi Prime Movers
          return data.fleet_subtype_id == 1;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMOnly)) { //BDBL Prime Movers
          return data.fleet_subtype_id == 2;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne8P)) { //6T8P
          return data.fleet_subtype_id == 7 || data.fleet_subtype_id == 8;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne14P)) { //12T14P
          return data.fleet_subtype_id == 8;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TenPalletRigid)) { //10PR
          return data.fleet_subtype_id == 10;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne6P)) { //2T6P
          return data.fleet_subtype_id == 11;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne10P)) { //6T10P
          return data.fleet_subtype_id == 12;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.EightTonne12P)) { //8T12P
          return data.fleet_subtype_id == 13;
        } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne12P)) { //12T12P
          return data.fleet_subtype_id == 14;
        }
      }

      if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMWithTrailers)){ //Semi PM with Trailer
        this.trailerList = this.fulltrailers;
        return data.fleet_subtype_id == 1
      }

      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMWithTrailers) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithATrailer)) { //BDBL with A Trailer Only
        this.trailers = this.fulltrailers.filter(data2 => { return data2.fleet_subtype_id == 4 });
        this.trailerList = this.trailers;
        return data.fleet_subtype_id == 2 || data.fleet_subtype_id == 3
      }

      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithBTrailer)) { // BDBL with B Trailer Only
        let trailers = this.fulltrailers.filter(data2 => { return data2.fleet_subtype_id == 5 });
        this.trailerList = trailers;
        return data.fleet_subtype_id == 2 || data.fleet_subtype_id == 3
      }

      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithTrailers)) { // BDBL with trailers A and B Trailers
        this.trailerList = this.fulltrailers;
        return data.fleet_subtype_id == 2
      }

      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.RoadTrain)) { //Road Train
        this.trailerList = this.fulltrailers;
        return data.fleet_subtype_id == 3
      }
    });

    if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.ATrailer) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BTrailer)) { //trailers only
      let trailers = this.fulltrailers.filter(data2 => {
        if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.ATrailer)) return data2.fleet_subtype_id == 4; else return data2.fleet_subtype_id == 5
      });
      this.trailerList = trailers;
      this.trucks = [];
    }
    console.log("driver licence", this.driverLicenceClasses);
    
    drivers = this.fulldrivers.filter(data => {
      if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.UTE) || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.Rigid)) { //ute
        return data.driver_license_name == this.driverLicenceClasses[0]['name'] 
          || data.driver_license_name == this.driverLicenceClasses[1]['name'] 
          || data.driver_license_name == this.driverLicenceClasses[2]['name'] 
          || data.driver_license_name == this.driverLicenceClasses[3]['name'] 
          || data.driver_license_name == this.driverLicenceClasses[4]['name'] 
          || data.driver_license_name == this.driverLicenceClasses[5]['name'];
      } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne4P) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne8P) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne14P)
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TenPalletRigid)
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwoTonne6P)
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SixTonne10P)
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.EightTonne12P)
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.TwelveTonne12P)) { //Rigids
          return data.driver_license_name == this.driverLicenceClasses[1]['name']
            || data.driver_license_name == this.driverLicenceClasses[2]['name'] 
            || data.driver_license_name == this.driverLicenceClasses[3]['name'] 
            || data.driver_license_name == this.driverLicenceClasses[4]['name'] 
            || data.driver_license_name == this.driverLicenceClasses[5]['name'];
      } else if (this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMOnly) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMWithTrailers) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMOnly) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithTrailers) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.RoadTrain) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
          || this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithBTrailer)) {
          return data.driver_license_name == this.driverLicenceClasses[4]['name'] 
            || data.driver_license_name == this.driverLicenceClasses[5]['name'];
      }

    });

    if (this.job_Type == 2 || this.job_Type == 3) this.trucksList = this.trucks; //Linehaul & Emptyrun
    if (this.job_Type == 4) this.trailerList = []; //Tow Haul
    if (this.job_Type == 5) this.trucks = [], this.driverList = []; //Trailer Hire

    this.driverListArray = drivers; //holds filtered array from categories before driver test check
    this.trucksList = this.trucks;
    this.trailers = this.trailerList;
    this.complianceFilter();
  } //end updateService_filter

  /**
   * Filters and checks activities list based on the current run plan area.
   */
  public activitiesFilterChecking(){
    let act_filter = this.activitiesList
    this.run_plan.forEach(run => {
      run.selectedPhases.forEach(phase => {
        if(phase.selectedActivities.length !=0){
          phase.selectedActivities.forEach(act => {
            if(act.isAddedTask == true){
              let temp =  act_filter.find(x =>x.u_id === act.u_id);
              if (temp != undefined) {
                  let index =  act_filter.findIndex(x =>x.u_id === act.u_id)
                  act_filter.splice(index, 1)
                }
            } else {
              let temp = act_filter.find(x => x.id == act.id)
              if (temp != undefined) {
                let index =  act_filter.findIndex(x => x.id == act.id)
                act_filter.splice(index, 1)
              }
            }
          });
        }
      })
    });
    this.activitiesList = act_filter;
  }

  /**
   * Updates the route filter for a specific plan.
   * @param index The index of the plan to update.
   */
  public updateRoute_filter(index) {
    let route = this.routes.find(x => x.id === this.run_plan[index].routeselected_id);
    let startroute = [], finalroute = [];

    this.updatePlanRoute(index, route);
    for (let i = 0; i < this.fullConnotes.length; i++) {
      let act = this.fullConnotes[i].connote_sites
      let first = act[0];
      let last = act[act.length - 1];
      if (route.changeover_state_id == null) {
        let tempArray = this.activitiesList.filter(x => x.connote_id == this.fullConnotes[i].id)
        if (first.state_id == route.start_state_id && (last.state_id == route.end_state_id) || (last.is_tba == true)) {
          tempArray.forEach(el => {
            startroute.push(el)
          });
        } else {
          tempArray.forEach(el => {
            finalroute.push(el)
          });
        }
      } else {
        let tempArray = this.activitiesList.filter(x => x.connote_id == this.fullConnotes[i].id)
        let changeover = tempArray.find(x => x.run_action_id == 3 || x.run_action_id == 4)
        if (first.run_action_id == 1 && last.run_action_id == 2 && changeover != undefined) {
          if (first.state_id == route.start_state_id && last.state_id == route.end_state_id && changeover.state_id == route.changeover_state_id) {
            tempArray.forEach(el => { startroute.push(el) });
          } else {
            tempArray.forEach(el => { finalroute.push(el) });
          }
        } else if (first.run_action_id == 1 && last.run_action_id == 3) {
          if (first.state_id == route.start_state_id && last.state_id == route.changeover_state_id) {
            tempArray.forEach(el => { startroute.push(el) });
          } else {
            tempArray.forEach(el => { finalroute.push(el) });
          }
        } else if (first.run_action_id == 4 && last.run_action_id == 2) {
          if (first.state_id == route.changeover_state_id && last.state_id == route.end_state_id) {
            tempArray.forEach(el => { startroute.push(el) });
          } else {
            tempArray.forEach(el => { finalroute.push(el) });
          }
        } else {
          tempArray.forEach(el => { finalroute.push(el) });
        }
      }
    }

    finalroute.forEach(row => { startroute.push(row); });
    this.activitiesList = startroute;

    let drivers = [], tempdrivers = [];
    this.driverList.forEach(d => {
      if (d.last_work.length > 0) {
        if (route.start_state_id == d.last_work[0].state_id) {
          drivers.push(d)
        } else tempdrivers.push(d)
      } else tempdrivers.push(d)
    });

    this.driverList = drivers;
    tempdrivers.forEach(element => {
      this.driverList.push(element)
    });

    let trucks = [], temptrucks =[];
    this.trucksList.forEach(d => {
      if (d.last_location.length > 0) {
        if (route.start_state_id == d.last_location[0].state_id) {
          trucks.push(d)
        } else temptrucks.push(d)
      } else temptrucks.push(d)
    });

    this.trucksList = trucks;
    temptrucks.forEach(element => {
      this.trucksList.push(element)
    });

    let trailer = [], temptrailer =[];
    this.trailerList.forEach(d => {
      if (d.last_location.length > 0) {
        if (route.start_state_id == d.last_location[0].state_id) {
          trailer.push(d)
        } else temptrailer.push(d)
      } else temptrailer.push(d)
    });

    this.trailerList = trailer;
    temptrailer.forEach(element => { this.trailerList.push(element) });

  } //end updateRoute_filter

  /**
   * Applies compliance filters to drivers, trucks, and trailers.
   */
  public complianceFilter() {
    let complete_dlist = this.driverListArray;
    let complete_trklist = this.trucks;
    let complete_trllist = this.trailers;

    if (this.checkFilters == true) {
      this.driverList = complete_dlist.filter(data => data.driver_test == 1);
    } else this.driverList = complete_dlist;

    if (this.checkFleetFilters == true) {
      this.trucksList = complete_trklist.filter(data => data.is_expired == 0);
    } else this.trucksList = complete_trklist;

    if (this.checkTrailerFilters == true) {
      this.trailerList = complete_trllist.filter(data => data.is_expired == 0);
    } else this.trailerList = complete_trllist;

    this.run_plan.forEach(run => { //checks for duplicates
      run.selectedPhases.forEach(phases =>{
        if(phases.selectedDriver.length !=0){
          phases.selectedDriver.forEach(drv => {
            let temp = this.driverList.find(x => x.id == drv.id)
            if (temp != undefined) {
              let index =  this.driverList.findIndex(x => x.id == drv.id)
              this.driverList.splice(index, 1)
            }
          });
        }
        if(phases.selectedFleet.length !=0){
          phases.selectedFleet.forEach(trk =>{
            let temp = this.trucksList.find(x => x.id == trk.id)
            if (temp != undefined) {
              let index =  this.trucksList.findIndex(x => x.id == trk.id)
              this.trucksList.splice(index, 1)
            }
          });
        }
      });
    });

    this.driverList.length != 0 ? this.emptyDrvList = true : this.emptyDrvList = false;
    this.trucksList.length != 0 ? this.emptyTrkList = true : this.emptyTrkList = false;
    this.trailerList.length != 0 ? this.emptyTrlList = true : this.emptyTrlList = false;
  }
  //END OF DISPATCH FILTERS

  //SUBMIT FUNCTIONS

  /**
   * Handles the submission of creating a task.
   * @param task The task data submitted from the form.
   */
  onSubmitTaskForm(task){
    if(!this.editMode){ //Add Task
      this.selectedActivity = task.site_source;

      (this.selectedIndex[2] == 6 || task.run_action_id == 0)? task['warehousing'] = true: task['warehousing'] =false;

      if(task.run_action_id == 5){ //changeover
        task.run_action_id = 3;
        this.pushTask(task, 'addtask');
        task.run_action_id = 4;
        this.pushTask(task, 'changeover');
      } else if(task.run_action_id == 0){ //warehousing
        for (let i = 0; i < 2; i++) {
          if(i==0){
            task.run_action_id = 9;
            this.pushTask(task, 'addtask');
            task.run_action_id = 10;
            this.pushTask(task, 'addtask');
          } else {
            task.run_action_id = 9;
            this.pushTask(task, 'warehouse');
            task.run_action_id = 10;
            this.pushTask(task, 'warehouse');
          }
        }
      } else this.pushTask(task, 'addtask'); //default

      if(task.run_action_id == 9 && task.createCollect == true){ //create TC
        task.run_action_id = 10;
        this.pushTask(task, 'addtask');
      }

    } else { //Update
        this.pushTask(task, 'update');
    }

    this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
    this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
    this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
    this.modal.dismissAll();
    this.autoSetLocation(this.selectedIndex[0]);
  }

  /**
   * Pushes a task to the appropriate list based on the type.
   * @param row The task row to push.
   * @param type The type of push operation.
   */
  pushTask(row, type){

    let stateinfo, newActivity, order = 0, run = this.selectedIndex[0], phase = this.selectedIndex[1]; let message ="", presetLocation;
    var action = this.run_actions.find(x => x.id == row.run_action_id); let index = row.index;

    let rel_start = row.releasePoint.date + ' ' + row.releasePoint['start_time'].hour + ":" + row.releasePoint['start_time'].minute + ":00";
    let col_start = row.collectPoint.date + ' ' + row.collectPoint['start_time'].hour + ":" + row.collectPoint['start_time'].minute + ":00";
    
    if(type!='changeover') order = null;   
    if (type != 'update') {
      let u_id = ((Math.random() * 100) + 1).toFixed(0); //set unique u_id
      
      if(type != 'warehouse'){
        presetLocation = this.locations.find(x=>x.id == row.releasePoint.location_id) //saving address to warehouse array
        stateinfo = this.states.find(x => x.id == row.releasePoint.state_id)
      } else {
        presetLocation = this.locations.find(x=>x.id == row.collectPoint.location_id) //saving address to warehouse array
        stateinfo = this.states.find(x => x.id == row.collectPoint.state_id)
      }

      //added warehouse_addresses from db, saving from added tasks removed
      newActivity = {
        id                : '',
        u_id              : u_id, //unique id aside from isAddedTask to help distinguish newly added task
        isAddedTask       : true,
        isRun_Plan        : false,
        opening_datetime  : type != 'warehouse'? rel_start: col_start,
        closing_datetime  : type != 'warehouse'? rel_start: col_start,
        warehousing       : row.warehousing,
        connote_site      : row.site_source,
        order_number      : order,
        run_action        : action.label,
        run_action_id     : Number(row.run_action_id),
        connote_site_id   : (this.selectedActivity.isRunPlan)? this.selectedActivity.plan_connote_site_id: this.selectedActivity.id,
        run_type_id       : row.site_source.run_type_id,
        connote           : row.site_source.connote,
        company_name      : row.site_source.company_name,
        connote_id        : row.site_source.connote_id,
        contact_email     : (row.site_source.contact_email!=undefined)? row.site_source.contact_email: '',
        contact_name      : (row.site_source.contact_name!=undefined)? row.site_source.contact_name: '',
        contact_no        : (row.site_source.contact_no!=undefined)? row.site_source.contact_no: '',
        control_no        : row.site_source.connote.control_no,
        location_city     : type != 'warehouse'? row.releasePoint.city: row.collectPoint.city,
        location_id       : type != 'warehouse'? row.releasePoint.location_id: row.collectPoint.location_id,
        location_lat      : type != 'warehouse'? row.releasePoint.lat: row.collectPoint.lat,
        location_lng      : type != 'warehouse'? row.releasePoint.long: row.collectPoint.long,
        location_postal   : type != 'warehouse'? row.releasePoint.postal_code: row.collectPoint.postal_code,
        location_street   : type != 'warehouse'? row.releasePoint.street: row.collectPoint.street,
        location_street_no: type != 'warehouse'? row.releasePoint.street_no: row.collectPoint.street_no,
        location_suburb   : type != 'warehouse'? row.releasePoint.suburb: row.collectPoint.suburb,
        state_id          : type != 'warehouse'? row.releasePoint.state_id: row.collectPoint.state_id,
        state_abbrev      : stateinfo.abbreviation,
        state_name        : stateinfo.name,
        created_at        : '',
        updated_at        : '',
        geofence          : {
          'radius'      : this.geofence_size_default,
          'created_by'  : this.admin_user
        },
      }
    }

    if(type == 'update'){
      newActivity = row.site_source;

      let stateinfo = this.states.find(x => x.id === row.releasePoint.state_id)
      newActivity['index'] = row.index;
      newActivity.opening_datetime  = rel_start;
      newActivity.closing_datetime  = rel_start;
      newActivity.location_id       = row.releasePoint.location_id;
      newActivity.location_city     = row.releasePoint.city
      newActivity.location_lat      = row.releasePoint.lat
      newActivity.location_lng      = row.releasePoint.long
      newActivity.location_postal   = row.releasePoint.postal_code
      newActivity.location_street   = row.releasePoint.street
      newActivity.location_street_no= row.releasePoint.street_no
      newActivity.location_suburb   = row.releasePoint.suburb
      newActivity.state_abbrev      = (row.releasePoint.state_id != null)? stateinfo.abbreviation: ''
      newActivity.state_id          = row.releasePoint.state_id
    }

    if (newActivity.location_id != null && newActivity.is_tba == true) newActivity.is_tba = false;

    switch(type){
      case 'addtask': {
        this.run_plan[run].selectedPhases[phase].selectedActivities.push(newActivity)
        this.addedTasks.push(newActivity)
        console.log('['+type+'] '+ newActivity.run_action);
        break;
      } case 'changeover':{
        newActivity.opening_datetime = col_start;
        newActivity.closing_datetime = col_start;

        this.activitiesList.push(newActivity)
        this.addedTasks.push(newActivity)
        for (let i = 0; i < this.run_plan[run].selectedPhases[phase].selectedActivities.length; i++) {
          if((this.run_plan[run].selectedPhases[phase].selectedActivities[i].run_action_id == 2 || this.run_plan[run].selectedPhases[phase].selectedActivities[i].run_action_id == 15) 
            && this.run_plan[run].selectedPhases[phase].selectedActivities[i].connote_id == newActivity.connote_id){
              this.activitiesList.push(this.run_plan[run].selectedPhases[phase].selectedActivities[i]);
              this.run_plan[run].selectedPhases[phase].selectedActivities.splice(i, 1);
          }
        }
        console.log('['+type+'] '+ newActivity.run_action)
        break;
      } case 'warehouse':{
        this.run_plan[run].selectedPhases[phase].selectedActivities.push(newActivity);
        this.addedTasks.push(newActivity);
        console.log('['+type+'] '+ newActivity.run_action)
        break;
      } case 'update':{
        if(newActivity.isAddedTask == true){
          let indx = this.addedTasks.findIndex(x=>x.u_id == newActivity.u_id);
          this.addedTasks.splice(indx, 1);
          this.addedTasks.push(newActivity);
        }

        this.run_plan[index[0]].selectedPhases[index[1]].selectedActivities.splice(index[2], 1, newActivity);
        let action = (newActivity.isRunPlan)? newActivity.run_action_label: newActivity.run_action;
        console.log('['+type+'] '+ action)
        message = "Task - " + action+ " for " + newActivity.control_no + " added.";
        break;
      } default: break;
    }
    
    if(type != 'update'){
      message = "Task - " + newActivity.run_action+ " for " + newActivity.control_no + " added.";
    }
    this.toastr.success('', message, {
      timeOut: 2000,
      positionClass: 'toast-top-right',
      progressBar: true
    });
  }

  /**
   * Gets the final data for a plan.
   * @param run The run plan to get final data for.
   */
  async getFinalData(run) {
    let trl_ord_num, roadTrain_order = 1, arrayTemp = [], drivers = [], fleets = [], activities = []
    let index = 1, changeover_index = run.manifest_changeover;
    run.selectedPhases.forEach((phase, count:number) => {
      phase.selectedDriver.forEach((element, i:number) => { //driver
        let plan, changeover;
        if(count == 0){
          plan = 1; changeover = 0;
        } else { plan = 0; changeover = 1; }
        
        let temp: RunDriver = {
          id            : null,
          driver_id     : element.id,
          run_event_id  : null,
          run_id        : null,
          is_two_up     : i,
          is_active     : 1,
          created_at    : '',
          updated_at    : '',
          is_planned    : plan,
          is_changeover : changeover,
        }
        drivers.push(temp)
      });

      phase.selectedFleet.forEach(element => { //truck
        let plan, changeover;
        if(count == 0){
          plan = 1; changeover = 0;
        } else { plan = 0; changeover = 1; }

        let temp: RunEquipment = {
          id            : null,
          run_id        : null,
          equipment_id  : element.id,
          run_event_id  : null,
          gross_weight  : null,
          axle1         : null,
          axle2         : null,
          axle3         : null,
          axle4         : null,
          axle5         : null,
          axle6         : null,
          axle7         : null,
          is_active     : (count == 0)?1: 0,
          created_at    : '',
          updated_at    : '',
          is_planned    : plan,
          is_changeover : changeover,
          is_trailer    : 0,
          is_truck      : 1,
          trailer_order_number: 0,
          phase_order_number : 1 //default
        }
        fleets.push(temp)
      });

      let start_order;
      
      if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.BDoublePMWithBTrailer) || this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.SemiPMWithTrailers)) start_order = 1; else start_order = 2; //if BDPM + B only
      phase.selectedTrailer.forEach(element => { //trailers
        let order, status;

        if(run.run_type_id == 6){
            (count == 0)? status = 1: status = 0;
        } else status = 1;

        if(element.fleet_subtype_id == 4) {
          order = 1
        } else {
          order = start_order;
          trl_ord_num = trl_ord_num + 1;
        }
        let temp: RunEquipment = {
          id            : null,
          equipment_id  : element.id,
          run_id        : null,
          run_event_id  : null,
          gross_weight  : null,
          axle1         : null,
          axle2         : null,
          axle3         : null,
          axle4         : null,
          axle5         : null,
          axle6         : null,
          axle7         : null,
          is_active     : status,
          created_at    : '',
          updated_at    : '',
          is_planned    : 1,
          is_changeover : 0,
          is_trailer    : 1,
          is_truck      : 0,
          trailer_order_number: (!this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain))? order: roadTrain_order,
          phase_order_number : (run.run_type_id == 6 || this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain))? count+1: 1
        }
        
        if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)) roadTrain_order++; //iterate trailer order for road train

        fleets.push(temp)
      });

      if(!this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){ //isolate road train trailers
        phase.selectedActivities.forEach(element => { //activities
          let site_id, final_id;
          if (element.isAddedTask == true) {
            final_id = null;
            site_id = element.connote_site_id;
            delete element.connote_site.connote;
          } else if (element.isRunPlan == true ){
            final_id = element.plan_id;
            site_id = element.plan_connote_site_id;
          } else {
            final_id = null;
            site_id = element.id;
          }
          let temp: RunPlanActivity = {
            id              : final_id,
            run_id          : null,
            connote_id      : element.connote_id,
            run_action_id   : element.run_action_id,
            connote_site_id : site_id,
            order_number    : index,
            location_id     : element.location_id,
            start_datetime  : element.opening_datetime,
            end_datetime    : element.closing_datetime,
            created_by      : this.admin_user,
            updated_by      : null,
            created_at      : '',
            updated_at      : '',
            connote_site    : element.connote_site,
            geofence        : element.geofence,
            phase_order_number : (run.run_type_id == 6)? count+1: 1 //default
          }
          index++; activities.push(temp)
        });
      }

    });

    if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){
      run.RTacts.forEach(element => {
        let site_id, final_id;
        if (element.isAddedTask == true) {
          final_id = null;
          site_id = element.connote_site_id;
          delete element.connote_site.connote;
        } else if (element.isRunPlan == true ){
          final_id = element.plan_id;
          site_id = element.plan_connote_site_id;
        } else {
          final_id = null;
          site_id = element.id;
        }
        let temp: RunPlanActivity = {
          id              : final_id,
          run_id          : null,
          connote_id      : element.connote_id,
          run_action_id   : element.run_action_id,
          connote_site_id : site_id,
          order_number    : index,
          location_id     : element.location_id,
          start_datetime  : element.opening_datetime,
          end_datetime    : element.closing_datetime,
          created_by      : this.admin_user,
          updated_by      : null,
          created_at      : '',
          updated_at      : '',
          connote_site    : element.connote_site,
          geofence        : element.geofence,
          phase_order_number : element.phase_order_number //default
        }
        index++; activities.push(temp)
      });
    }

    if(changeover_index != null){
      //gets trailers from paired plan
      let pairedInfo = this.run_plan[changeover_index].selectedPhases[0]
      let trl_ord_num = 2;
      pairedInfo.selectedTrailer.forEach(element => {
        let order
        if(element.fleet_subtype_id == 4) {
          order = 1
        } else {
          order = trl_ord_num;
          trl_ord_num = trl_ord_num + 1;
        }
        let temp: RunEquipment = {
          id            : null,
          equipment_id  : element.id,
          run_id        : null,
          run_event_id  : null,
          gross_weight  : null,
          axle1         : null,
          axle2         : null,
          axle3         : null,
          axle4         : null,
          axle5         : null,
          axle6         : null,
          axle7         : null,
          is_active     : 0,
          created_at    : '',
          updated_at    : '',
          is_planned    : 0,
          is_changeover : 1,
          is_trailer    : 1,
          is_truck      : 0,
          trailer_order_number: order,
          phase_order_number : 1 //default
        }
        fleets.push(temp)
      });
    }

    this.finalDrivers = drivers; //final driver
    this.finalEquipments = fleets; //final equipments
    this.finalActivities = (this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain))? this.sortRoadTrain(activities): activities; //final activities
    this.finalActivities.forEach(a => {arrayTemp.push(a.connote_id)});
    arrayTemp = arrayTemp.filter((element, i) => i === arrayTemp.indexOf(element))

    if(this.finalActivities.filter(x=>x.location_id == null || x.location_id == '').length > 0) {
      run.run_type_id != 1? run.totalklms = this.routes.find(x=> x.id == run.routeselected_id).klms: run.total_klms = 0;
    }

    if(arrayTemp.length > 1 || run.totalklms >= 500.00){
      this.control_no = null;
    } else this.control_no = run.selectedPhases[0].selectedActivities[0].control_no;

    let typeID = 0
    if(run.run_type_id == 2){
      run.selectedPhases.forEach(phases => {
        phases.selectedActivities.forEach(el => {
          if(el.run_type_id == 3) typeID++;
        });
      });

      if(typeID == this.finalActivities.length) this.dispatch_jobType = 3;
      else if (typeID != this.finalActivities.length) this.dispatch_jobType = 2;
    } else if(run.run_type_id == 6){ this.dispatch_jobType = 6;
    } else this.dispatch_jobType = run.selectedPhases[0].selectedActivities[0].run_type_id;

    let n = [], finaldates = run.excluded_holiday_dates.filter(obj => obj.value == true);
    if(finaldates.length > 0){
      finaldates.forEach(d => {
        d.date = formatDate(d.date, 'yyy/MM/dd', 'en_US')
        n.push(d.date)
      });
  
      this.excluded_dates = n.join(', ');
    } else this.excluded_dates = null

  }

  /**
   * Submits the created plan/s.
   */
  async onSubmitDispatch() {
    this.loadingIndicator = true;
    let getChangeover = [], allrun_list = [],
    finalRun_test = { 'runs': {
      'run':[], 'changeover':[], }   ,'trigger' :'dispatch'
    }

    this.modal.dismissAll();
    this.run_plan.forEach((run, index:number) => {
      let tba=0, other_work =  (run.other_work_hour + (run.other_work_min/60)).toFixed(2);
      let test, departure, pickups, arrival;
      this.getFinalData(run);

      if(run.checkLoad == 1) this.linehaulType = 1; else this.linehaulType = 2;
      if(this.finalActivities.filter(x=>x.location_id == '' || x.location_id == null).length > 0) tba = 1;
      
      if(run.manifest_changeover != null){ // getting pickups for changeover
        pickups = this.finalActivities.filter(obj => obj.run_action_id == 1 || obj.run_action_id == 10 || obj.run_action_id == 14)
        departure = pickups[pickups.length -1].end_datetime;
      } else {
        pickups = this.finalActivities.filter(obj => obj.run_action_id == 1 || obj.run_action_id == 4 || obj.run_action_id == 5 || obj.run_action_id == 10 || obj.run_action_id == 14)
        if(pickups[0].run_action_id == 5){
          departure = pickups[0].start_datetime
        } else if(pickups[0].run_action_id == 14){
          departure = pickups[0].end_datetime
        } else departure = pickups[pickups.length -1].end_datetime;
      }

      //for getting arrival time - linehaul/empty run/local with planned
      if(this.finalActivities[0].run_action_id != 5){ //not local start
        let trip_time =( run.totaldrivinghours + parseFloat(other_work) + run.min_long_rest_hours
             + run.min_short_rest_hours + run.other_rest_hours)* 60// * 60; convert to mins
        let start_trip = new Date(departure)
        arrival = new Date(start_trip.getTime() + trip_time*60000);
      } else arrival = departure;

      if(run.manifest_changeover !=null){
        test = {
          'changeover_index': run.manifest_changeover, //index of paired
          'plan_index'      : index, //original index
          'run'             : null,
          }
        }

      const dispatchData: Run = {
          id                      : null,
          uuid                    : null,
          control_no              : this.control_no,
          run_type_id             : this.dispatch_jobType,
          service_type_id         : run.service_type_id,
          linehaul_type           : this.linehaulType,
          activities              : this.finalActivities,
          equipments              : this.finalEquipments,
          drivers                 : this.finalDrivers,
          is_released             : 0,
          has_tba                 : tba,
          run_routes_id           : run.routeselected_id,
          total_klms              : run.totalklms,
          total_driving_hours     : run.totaldrivinghours,
          total_work_hours        : run.totaldrivinghours + parseFloat(other_work),
          other_work_hours        : parseFloat(other_work),
          min_long_rest_hours     : run.min_long_rest_hours,
          min_short_rest_hours    :  run.min_short_rest_hours,
          other_rest_hours        : run.other_rest_hours,
          departure_date          : formatDate(departure, 'yyy-MM-dd', 'en-US'),
          departure_time          : formatDate(departure, 'HH:mm:ss', 'en-US'),
          arrival_date            : formatDate(arrival, 'yyy-MM-dd', 'en-US'),
          arrival_time            : formatDate(arrival, 'HH:mm:ss', 'en-US'),
          is_excluded_saturday    : run.is_excluded_saturday,
          is_excluded_sunday      : run.is_excluded_sunday,
          is_excluded_holiday_no  : run.is_excluded_holiday_no,
          excluded_holiday_dates  : this.excluded_dates,
          run_status_id           : 1,
          admin_notes             : run.admin_notes,
          driver_notes            : '',
          dispatch_notes          : run.dispatch_notes,
          created_by              : this.admin_user,
          updated_by              : null,
          created_at              : '',
          updated_at              : '',
          changeover_run_id       : '',
          finish_done             : false
      }

      allrun_list.push(dispatchData);
      if(test != undefined){
        test.run = dispatchData;
        getChangeover.push(test)
      } else finalRun_test.runs.run.push(dispatchData);
    });
    for (let i = 0; i < getChangeover.length; i++) {
      let pairArray = []
      let paired = getChangeover.find(x=> x.changeover_index == getChangeover[i].plan_index);
      if(paired != undefined){
        pairArray[0] = getChangeover[i].run;
        pairArray[1] = paired.run;
        let p_index = getChangeover.findIndex(x=> x.changeover_index == getChangeover[i].plan_index);
        getChangeover.splice(p_index,1); i--;
        finalRun_test.runs.changeover.push(pairArray)
      }
    }
    await this.dispatchService.createRuns(finalRun_test).toPromise().then(data => {
      this.success_runs = data['new_runs'];
      if (data['error'] == false) {
        if (this.addedTasks.length != 0) this.saveActivities();
        
        while(this.run_plan.length) this.run_plan.pop();    
        this.planCount = 1;
        
        this.modal.open(this.dispatchResult, { backdrop: 'static', size: 'xs', centered: true });
        this.loadingIndicator = false;
      } 
    }).catch(data =>{
      if(data['error_message'] == null){
        this.toastr.error('Please try again', 'There was a problem upon your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }else if(data['error_message'] == ' '){
        this.toastr.error('Please try again', 'There was a problem upon your dispatch.', {
          timeOut: 4000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }else{
        this.toastr.error('Please try again', data["error_message"], {
          timeOut: 4000, positionClass: 'toast-top-full-width', progressBar: true
        });
      }
    });
  }

  /**
   * Save new activities created during dispatch.
   */
  async saveActivities() {
    let newTasks = { 'activities': [] }
    this.addedTasks.forEach(element => {
      delete element.connote_site.connote;
      if (element.order_number == 0) {
        let temp: RunPlanActivity = {
          id              : null,
          run_id          : null,
          connote_id      : element.connote_id,
          run_action_id   : element.run_action_id,
          connote_site_id : element.connote_site_id,
          order_number    : 0,
          location_id     : element.location_id,
          start_datetime  : element.opening_datetime,
          end_datetime    : element.closing_datetime,
          created_by      : this.admin_user,
          updated_by      : null,
          created_at      : '',
          updated_at      : '',
          connote_site    : element.connote_site,
          geofence        : element.geofence,
          phase_order_number : (element.warehousing)? 0: 1 //default
        }
        newTasks.activities.push(temp)
      }
    })
    this.finalTasks = newTasks;
    console.log('saving ' +this.finalTasks.length + ' tasks');
    if (this.finalTasks.activities.length != 0) {
      await this.dispatchService.createNewActivities(this.finalTasks).toPromise().then(data => {
        if (data['error'] == false) {
          this.resetDispatch('clear_newTasks')
        }
      })
    }
  }

  /**
   * Submits a new route.
   * @param row The route data to submit.
   */
  async onSubmitRoutes(row) {
    this.loadingRoute = true;
    let newRoute: RunRoute = row;
    await this.dispatchService.createRoute(newRoute).toPromise().then(data => {
      if (data['error'] != true) {
        this.toastr.success('', data["message"], {
          timeOut: 4000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        this.getData();
        this.modal.dismissAll();
      } else {
        this.toastr.error('', data["error_message"], {
          timeOut: 4000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    }).catch(response => {
      this.toastr.error("Please try again.", "There was a problem with creating new route.", {
        timeOut: 4000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    setTimeout(() => { this.loadingRoute = false; }, 700);
  }
  //END OF SUBMIT FUNCTIONS

  /**
   * Gets all activities for the current plan.
   */
  async getAllActivities() {
    let tempList = [];
    console.time('get activities');
    await this.dispatchService.getActivitiesv2(this.job_Type).toPromise().then(async data => {
      this.fullConnotes = data['connotes'];

      this.fullConnotes.sort(function(a,b){
        var dateA = new Date(b.created_at).valueOf(), dateB = new Date(a.created_at).valueOf()
        return dateA - dateB || b.id - a.id});

       //filter by service type
      // if service type = null, then still add to list
      tempList = this.fullConnotes.filter(data => {
        if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.SemiPMWithTrailers)){
          return this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.SemiPMWithTrailers) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.ATrailer) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BTrailer) 
            || data.linehaul_type_id == 2
        }if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithTrailers)){ //BDBLs 
          return this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithTrailers) 
            || data.run_type_id == 2 
            && (this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
              || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithBTrailer)) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.ATrailer) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BTrailer) 
            || data.linehaul_type_id == 2
        } else if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.RoadTrain)){ //Road Train
          return this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.RoadTrain) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithTrailers) 
            || data.run_type_id == 2 
            && (this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
              || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithBTrailer)) 
            || data.linehaul_type_id == 2
        } if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithATrailer)){ //BDBL A
          return this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.ATrailer)
            || data.linehaul_type_id == 2
        } if(this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.BDoublePMWithBTrailer)){ //BDBL B
          return this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BDoublePMWithBTrailer) 
            || this.isServiceTypeMatch(data.service_type_id, ServiceTypeAbbreviations.BTrailer) 
            || data.linehaul_type_id == 2
        } else return this.getAbbreviationById(data.service_type_id) == this.getAbbreviationById(this.service_Type) 
          || data.linehaul_type_id == 2 
          || data.service_type_id == null
        })

        this.fullConnotes = tempList
        
        if(this.job_Type == 6){
          await this.dispatchService.getActivityTasks_warehouse(this.service_Type).toPromise().then(data => {
            this.fullTaskActivities = data['new_tasks_without_run'];
            setTimeout(() => { this.loadSpinner = false; }, 700);
          })
        } else {
          await this.dispatchService.getActivityTasks(this.job_Type).toPromise().then(data => {
            this.fullTaskActivities = data['new_tasks_without_run'];
            setTimeout(() => { this.loadSpinner = false; }, 700);
          })
        }

      })

    if (this.fullTaskActivities.length > 0) {
      this.fullTaskActivities.forEach(task => {
        let connote = this.fullConnotes.find(x => x.id == task.plan_connote_id)
        let connoteIndex = this.fullConnotes.findIndex(x => x.id == task.plan_connote_id)
        if (connote != undefined) {
          let check = connote.connote_sites.find(x=>{return (x.id == task.plan_connote_site_id && x.run_action === task.run_action_label)})
          if(check != undefined){
            let index = connote.connote_sites.findIndex(x=>{ return x.id == task.plan_connote_site_id && x.run_action == task.run_action_label})
            task['curr_connote_site'] =  this.fullConnotes[connoteIndex].connote_sites[index]
            this.fullConnotes[connoteIndex].connote_sites.splice(index,1)
          }

          task['id']                = task.plan_id;
          task['connote_id']        = task.plan_connote_id;
          task['company_name']      = task.site_company_name;
          task['control_no']        = connote.control_no;
          task['run_type_id']       = connote.run_type_id;
          task['linehaul_type']     = connote.linehaul_type_id;
          task['location_id']       = task.plan_location_id;
          task['opening_datetime']  = task.plan_start_datetime;
          task['closing_datetime']  = task.plan_end_datetime;
          task['service_option']    = connote.service_option;
          task['isAddedTask']       = false;
          task['isRunPlan']         = true;
          task['connote']           = connote;
          task['geofence']          = {
            "radius" : this.geofence_size_default,
            "created_by" : this.admin_user
          };
          task['run_action_id'] = this.run_actions.find(x=>x.label == task.run_action_label).id
            
          this.fullConnotes[connoteIndex].connote_sites.push(task);
        }
      });
    }

    if (this.fullConnotes.length > 0) {
      let list = [];
      this.fullConnotes.forEach(con => {
        let temp = con.connote_sites
        if (temp.filter(obj => obj.location_id == null)!=undefined) con['delivery_tba']= true; else con['delivery_tba']= false;

        //adding added task
        let tasks = this.addedTasks.filter(x=>x.connote_id == con.id);
        if(tasks.length > 0){
          tasks.forEach(e => { if(e.order_number != null) con.connote_sites.push(e);});
          con.connote_sites.sort(function(a,b){
            var dateA = new Date(b.opening_datetime).valueOf(), dateB = new Date(a.opening_datetime).valueOf()
            return dateB - dateA || a.id - b.id
          });
        }

        for (let i = 0; i < temp.length; i++) {
          temp[i]['company_name'] = con.company_name;

          if (!temp[i]['isRunPlan'] && !temp[i]['isAddedTask']) {
            temp[i]['company_name']    = con.company_name;
            temp[i]['control_no']      = con.control_no;
            temp[i]['run_type_id']     = con.run_type_id;
            temp[i]['linehaul_type']   = con.linehaul_type_id;
            temp[i]['service_option']  = con.service_option;
            temp[i]['isAddedTask']     = false;
            temp[i]['isRunPlan']       = false;
            temp[i]['tba']             = con['delivery_tba'];
            temp[i]['connote']         = con;
            temp[i]['geofence']          = {
              "radius" : this.geofence_size_default,
              "created_by" : this.admin_user
            };
          }
          (temp[i].location_id == null)? temp[i]['is_tba'] = true: temp[i]['is_tba'] = false;
          list.push(temp[i])
        }

        if(con.dg_type_id != null && con.dg_type_id != 0){
          con['dg_type'] = this.dg_types.find(x=>x.id == con['dg_type_id']).name
        } else con['dg_type'] = null;

        if(con.dg_class_id != null && con.dg_class_id != 0){
          let license = this.dg_licenses.find(x=>x.id == con['dg_class_id'])
          con['dg_class'] = license.name+': '+license.description
        } else con['dg_class'] = null;

        let dg_sub = this.dg_subsidiary_risks.filter(x=>x.connote_id == con.id)
        if(dg_sub.length > 0){
         let temp = []
          dg_sub.forEach(sub => {
            sub['name'] = this.dg_licenses.find(x=>x.id == sub['dg_class_id']).name
            sub['description'] = this.dg_licenses.find(x=>x.id == sub['dg_class_id']).description
            temp.push(sub)
          });
          con['dg_subsidiary_risks'] = temp;
        }else con['dg_subsidiary_risks'] = []
      });
      this.connote_sites = list;
      this.fullActivities = this.connote_sites;
      this.activitiesList = this.connote_sites;
      this.emptyActList = false;
    } else this.activitiesList = []; this.emptyActList = true;

    this.activitiesFilterChecking();
    this.updateSearch('activity');
    console.timeEnd('get activities');
  }


  /**
   * Moves an item around the dispatch area based on specified type
   * @param id The ID of the item to move.
   * @param run_index The index of the plan.
   * @param phase_index The index of the phase.
   * @param index The index of the item in its current list.
   * @param type The type of item being moved.
   */
  public moveItem(id: number, run_index: number, phase_index:number, index: number, type: string) {
    const planCurrIndex = run_index
    const planPhaseIndex = phase_index
    switch (type) {
      case 'activities': {
        let temp = this.activitiesList.find(x => x.id == id);
        if(this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x=>x.connote_id == temp.connote_id && x.id != temp.id) == undefined){
          if(this.run_plan[planCurrIndex].selectedPhases[0].selectedDriver.length ==0) this.getPresets(temp.connote_id, planCurrIndex, planPhaseIndex);
        } 
        this.activitiesList.splice(index, 1);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(temp);
        this.checkInfo('truck'); this.checkInfo('trailer');
        this.autoSetLocation(run_index);
        break;
      } case 'return_activities': {
        let temp = this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x => x.id == id);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.splice(index, 1);
        this.activitiesList.push(temp);
        this.autoSetLocation(run_index);
        this.checkInfo('truck'); this.checkInfo('trailer');
        break;
      } case 'add_task':{
        let temp = this.activitiesList.find(x => x.u_id == id);
        temp.order_number = null;
        this.activitiesList.splice(index, 1);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(temp);
        this.autoSetLocation(run_index);
        break;
      } case 'return_task':{
        let temp = this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x => x.u_id == id);
        temp.order_number = 0;
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.splice(index, 1);
        this.activitiesList.push(temp);
        let temp2 = this.fullActivities.find(x => x.u_id == id)
        if(temp2 == undefined){
          this.fullActivities.push(temp);
        }
        this.autoSetLocation(run_index);
        break;
      } case 'remove_task': {
        let temp = this.addedTasks.findIndex(x => x.u_id == id)
        this.addedTasks.splice(temp, 1)

        let temp2 = this.fullActivities.findIndex(x => x.u_id == id)
        this.fullActivities.splice(temp2, 1)
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.splice(index, 1);
        this.autoSetLocation(run_index);
        break;
      } case 'remove_task2': {
        let temp = this.addedTasks.findIndex(x => x.u_id == id)
        this.addedTasks.splice(temp, 1)
        this.activitiesList.splice(index, 1);

        let temp2 = this.fullActivities.findIndex(x => x.u_id == id)
        this.fullActivities.splice(temp2, 1)
        this.autoSetLocation(run_index);
        break;
      } case 'connote': {
        let activity = this.fullActivities.find(x => x.id == id);
        if(this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x=>x.connote_id == activity.connote_id) == undefined){
          if(this.run_plan[planCurrIndex].selectedPhases[0].selectedDriver.length ==0) this.getPresets(activity.connote_id, planCurrIndex, planPhaseIndex);
        } 
       
        let temp = this.fullActivities.filter(data => { return data.connote_id == activity.connote_id; });
        temp.forEach(el => {
          let test = []
          if (el.isRunPlan == true) {
            this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
              test = phase.selectedActivities.find(x => x.plan_id == el.plan_id)
            });
            if (test == undefined) {
              var newArray = this.activitiesList.findIndex(x => x.plan_id == el.plan_id);
              this.activitiesList.splice(newArray, 1);
              this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
            }
          } else {
            if(el.isAddedTask == false){
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.id == el.id)
              });
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.id == el.id);

            } else {
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.u_id == el.u_id)
              });
              el.order_number = null;
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.u_id == el.u_id);
            }

            this.activitiesList.splice(newArray, 1);
            this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
          }
        });
        this.checkInfo('truck'); this.checkInfo('trailer');
        this.autoSetLocation(run_index);
        break;
      } case 'connote2': { // added task
        let activity = this.fullActivities.find(x => x.u_id == id);
        if(this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x=>x.connote_id == activity.connote_id) == undefined){
          if(this.run_plan[planCurrIndex].selectedPhases[0].selectedDriver.length ==0) this.getPresets(activity.connote_id, planCurrIndex, planPhaseIndex);
        } 
       
        let temp = this.fullActivities.filter(data => { return data.connote_id == activity.connote_id; });
        temp.forEach(el => {
          let test = []
          if (el.isRunPlan == true) {
            this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
              test = phase.selectedActivities.find(x => x.plan_id == el.plan_id)
            });
            if (test == undefined) {
              var newArray = this.activitiesList.findIndex(x => x.plan_id == el.plan_id);
              this.activitiesList.splice(newArray, 1);
              this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
            }
          } else {
            if(el.isAddedTask == false){
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.id == el.id)
              });
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.id == el.id);

            } else {
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.u_id == el.u_id)
              });
              el.order_number = null;
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.u_id == el.u_id);
            }

            this.activitiesList.splice(newArray, 1);
            this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
          }
        });
        this.checkInfo('truck'); this.checkInfo('trailer');
        this.autoSetLocation(run_index);
        break;
      } case 'view_connote': {
        let temp = this.activitiesList.filter(data => { return data.connote_id == id; });//this uses connote id from selected connote not activity connote_id
        if(this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.find(x=>x.connote_id == temp[0].connote_id) == undefined){
          if(this.run_plan[planCurrIndex].selectedPhases[0].selectedDriver.length ==0) this.getPresets(temp[0].connote_id, planCurrIndex, planPhaseIndex);
        } 
        temp.forEach(el => {
          let test = []
          if (el.isRunPlan == true) {
            this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
              test = phase.selectedActivities.find(x => x.plan_id == el.plan_id)
            });
            if (test == null) {
              var newArray = this.activitiesList.findIndex(x => x.plan_id == el.plan_id);
              this.activitiesList.splice(newArray, 1);
              this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
            }
          } else {
            if(el.isAddedTask == false){
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.id == el.id)
              });
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.id == el.id);

            } else {
              this.run_plan[this.run_plan.length - 1].selectedPhases.forEach(phase => {
                test = phase.selectedActivities.find(x => x.u_id == el.u_id)
              });
              if (test == null) var newArray = this.activitiesList.findIndex(x => x.u_id == el.u_id);
            }

            this.activitiesList.splice(newArray, 1);
            this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedActivities.push(el);
          }
        });
        this.modal.dismissAll();
        this.autoSetLocation(run_index);
        break;
      } case 'drivers': {
        let temp = this.fulldrivers.find(x => x.id == id);
        this.driverList.splice(index, 1);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedDriver.push(temp);
        this.getDriverPairings(temp);
        this.currSelectedDriver = temp
        this.getDriverAssignment('planner', planCurrIndex, planPhaseIndex)
        this.checkInfo('driver')
        break;
      } case 'p_drivers': {
        let temp = this.fulldrivers.find(x => x.id == id);
        temp.paired_onPlan=false;
        this.driverList.splice(index, 1);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedDriver.push(temp);
        this.currSelectedDriver = temp
        this.checkPairings();
        this.getDriverAssignment('planner', planCurrIndex, planPhaseIndex)
        this.checkInfo('driver')
        break;
      } case 'return_drivers': {
        let temp = this.fulldrivers.find(x => x.id == id);
        temp['assignmentConflict'] = false;
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedDriver.splice(index, 1);
        this.driverList.push(temp);
        this.checkInfo('driver')
        break;
      } case 'trucks': {
        let temp = this.trucksList.find(x => x.id == id);
        if(temp != undefined){
          this.trucksList.splice(index, 1);
          this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedFleet.push(temp);
          this.getFleetAssignment('flt_planner', id, planCurrIndex, planPhaseIndex)
          this.checkInfo('truck')
          this.checkPairings();
        }
        break;
      } case 'return_trucks': {
        let temp = this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedFleet.find(x => x.id == id);
        temp['assignmentConflict'] = false;
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedFleet.splice(index, 1); this.trucksList.push(temp);
        this.checkInfo('truck')
        break;
      } case 'trailers': {
        let temp = this.trailerList.find(x => x.id == id);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedTrailer.push(temp);
        this.runIndexTrailer = planCurrIndex;
        this.getTrailerPairings(temp)
        this.getFleetAssignment('trl_planner', id, planCurrIndex, planPhaseIndex)
        this.checkInfo('trailer')
        break;
      } case 'p_trailers': {
        let temp = this.trailerList.find(x => x.id == id);
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedTrailer.push(temp);
        this.getFleetAssignment('trl_planner', id, planCurrIndex, planPhaseIndex)
        this.checkInfo('trailer')
        this.checkPairings();
        break;
      } case 'return_trailers': {
        let temp = this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedTrailer.find(x => x.id == id);
        temp['assignmentConflict'] = false;
        this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedTrailer.splice(index, 1);
        this.checkInfo('trailer')
        this.checkPairings();
        break;
      } case 'dup_equipment':{
        let temp = this.run_plan[planCurrIndex].selectedPhases[planPhaseIndex].selectedTrailer.find(x => x.id == id);
        this.run_plan[index].selectedPhases[planPhaseIndex].selectedTrailer.push(temp);
        break;
      } default: { break; }
    }
    this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
    this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
    this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
  } //end moveItem

  // Pairing and Presets

  /**
   * Retrieves preset data for a specific connote
   * @param connote_id The ID of the connote
   * @param run_index The index of the plan
   * @param phase_index The index of the phase
   */
  async getPresets(connote_id, run_index, phase_index) {
    this.manifestSpinner[run_index] = true;
    await this.dispatchService.getPresets(connote_id).toPromise().then(data => {
      this.presetDrivers = data['preset_drivers'];
      this.presetEquipments = data['preset_equipments']
    })
    setTimeout(() => { this.manifestSpinner[run_index] = false; }, 50);

    if (this.presetDrivers.length > 0) {
      for (let i = 0; i < this.presetDrivers.length; i++) {
        if ((this.run_plan[run_index].selectedPhases[phase_index].selectedDriver.find(el => el.id == this.presetDrivers[i].id)) != undefined) this.presetDrivers[i]['c_driver'] = 2; //2 - already in dispatch area
        else if ((this.driverList.find(el => el.id == this.presetDrivers[i].id)) == undefined) this.presetDrivers[i]['c_driver'] = 1; // 0 - available; 1 - not available in list
        else this.presetDrivers[i]['c_driver'] = 0;
      }
    }
    if (this.presetEquipments.length > 0) {
      for (let i = 0; i < this.presetEquipments.length; i++) {
        if (this.presetEquipments[i].fleet_subtype_id != 4 && this.presetEquipments[i].fleet_subtype_id != 5) { //trucks
          if ((this.run_plan[run_index].selectedPhases[phase_index].selectedFleet.find(el => el.id == this.presetEquipments[i].id)) != undefined) this.presetEquipments[i]['c_equipment'] = 2; //2 - already in dispatch area
          else if ((this.trucksList.find(el => el.id == this.presetEquipments[i].id)) == undefined) this.presetEquipments[i]['c_equipment'] = 1; // 0 - available; 1 - not available in list
          else this.presetEquipments[i]['c_equipment'] = 0;
        } else { //trailers
          if ((this.run_plan[run_index].selectedPhases[phase_index].selectedTrailer.find(el => el.id == this.presetEquipments[i].id)) != undefined) this.presetEquipments[i]['c_equipment'] = 2; //2 - already in dispatch area
          else if ((this.trailerList.find(el => el.id == this.presetEquipments[i].id)) == undefined) this.presetEquipments[i]['c_equipment'] = 1; // 0 - available; 1 - not available in list
          else this.presetEquipments[i]['c_equipment'] = 0;
        }
      }
    }

    let count_d = 0 , count_e = 0;
    if (this.presetDrivers.length != 0 || this.presetEquipments.length != 0) {
      this.selectedConnote = this.fullConnotes.find(x => x.id == connote_id);

      this.presetDrivers.forEach(d => { if (d.c_driver == 1 || d.c_driver == 2) count_d++;});
      if (count_d != this.presetDrivers.length) this.isD_available = true; else this.isD_available = false;

      this.presetEquipments.forEach(d => {if (d.c_equipment == 1 || d.c_equipment == 2) count_e++;});
      if (count_e != this.presetEquipments.length) this.isE_available = true; else this.isE_available = false;
      this.openPresetModal(run_index);
    }
  }

  public setPresets(run_index) {
    this.modal.dismissAll();
    this.spinner = true;
    console.log('adding preset to run plan #',run_index + 1);
    for (let i = 0; i < this.presetDrivers.length; i++) {
      let index1 = this.driverList.findIndex(x => x.id === this.presetDrivers[i].id);
      if (this.presetDrivers[i].c_driver == 0) {
        this.moveItem(this.presetDrivers[i].id, run_index, 0, index1, 'p_drivers')
      }
    }
    
    for (let i = 0; i < this.presetEquipments.length; i++) {
      if (this.presetEquipments[i].fleet_subtype_id != 4 && this.presetEquipments[i].fleet_subtype_id != 5) { //trucks
        let index3 = this.trucksList.findIndex(x => x.id == this.presetEquipments[i].id);
        if (this.presetEquipments[i].c_equipment == 0) {
          this.moveItem(this.presetEquipments[i].id, run_index, 0, index3, 'trucks');
        }
      } else { //trailers
        let index3 = this.trailerList.findIndex(x => x.id == this.presetEquipments[i].id);
        if (this.presetEquipments[i].c_equipment == 0) {
          this.moveItem(this.presetEquipments[i].id, run_index, 0, index3, 'p_trailers');
        }
      }
    }
    setTimeout(() => { this.spinner = false; }, 50);
  }

  async showPresets(connote_id) {
    this.spinner = true;
    await this.dispatchService.getPresets(connote_id).toPromise().then(data => {
      this.presetDrivers = data['preset_drivers'];
      this.presetEquipments = data['preset_equipments']
    })
    setTimeout(() => { this.spinner = false; }, 50);
  }

  isServiceTypeHidden(serviceTypeId, index) {
    const run_type = this.run_plan[index].run_type_id;

    switch (run_type){
      case 1:
        return [ServiceTypeAbbreviations.UTE,
            ServiceTypeAbbreviations.Rigid, 
            ServiceTypeAbbreviations.TwoTonne4P, 
            ServiceTypeAbbreviations.SemiPMOnly, 
            ServiceTypeAbbreviations.SemiPMWithTrailers, 
            ServiceTypeAbbreviations.BDoublePMOnly, 
            ServiceTypeAbbreviations.BDoublePMWithTrailers, 
            ServiceTypeAbbreviations.SixTonne8P, 
            ServiceTypeAbbreviations.TwelveTonne14P, 
            ServiceTypeAbbreviations.BDoublePMWithATrailer, 
            ServiceTypeAbbreviations.BDoublePMWithBTrailer, 
            ServiceTypeAbbreviations.TenPalletRigid,
            ServiceTypeAbbreviations.TwoTonne6P,
            ServiceTypeAbbreviations.SixTonne10P,
            ServiceTypeAbbreviations.EightTonne12P,
            ServiceTypeAbbreviations.TwelveTonne12P,]
          .every(abbreviation => !this.isServiceTypeMatch(serviceTypeId, abbreviation));
      case 2:
        return [ServiceTypeAbbreviations.SemiPMWithTrailers, 
            ServiceTypeAbbreviations.BDoublePMWithTrailers, 
            ServiceTypeAbbreviations.RoadTrain, 
            ServiceTypeAbbreviations.BDoublePMWithATrailer, 
            ServiceTypeAbbreviations.BDoublePMWithBTrailer,
            ServiceTypeAbbreviations.TwelveTonne14P,
            ServiceTypeAbbreviations.TwelveTonne12P]
          .every(abbreviation => !this.isServiceTypeMatch(serviceTypeId, abbreviation));
      case 5:
        return [ServiceTypeAbbreviations.ATrailer, ServiceTypeAbbreviations.BTrailer]
          .every(abbreviation => !this.isServiceTypeMatch(serviceTypeId, abbreviation));
      case 4:
        return [ServiceTypeAbbreviations.SemiPMOnly, ServiceTypeAbbreviations.BDoublePMOnly]
          .every(abbreviation => !this.isServiceTypeMatch(serviceTypeId, abbreviation));
      case 6:
        return this.isServiceTypeMatch(serviceTypeId, ServiceTypeAbbreviations.ATrailer) ||
          this.isServiceTypeMatch(serviceTypeId, ServiceTypeAbbreviations.BTrailer) ||
          this.isServiceTypeMatch(serviceTypeId, ServiceTypeAbbreviations.RoadTrain);
      default:
        return false;
    }
  }

  /**
   * Checks if the service type matches the expected abbreviation based on service type ID
   * @param serviceTypeId The service type ID to check
   * @param expectedAbbreviation The expected abbreviation to compare with
   * @returns True if the service type matches the expected abbreviation, false otherwise
   */
  isServiceTypeMatch(serviceTypeId: number, expectedAbbreviation: string){
    const abbreviation = this.getAbbreviationById(serviceTypeId);
  
    if (abbreviation) {
      return abbreviation === expectedAbbreviation;
    }

    return false;
  }

  /**
   * Retrieves the abbreviation of a service type based on its service type ID
   * @param serviceTypeId The service type ID for which to retrieve the abbreviation
   * @returns The abbreviation of the service type, or undefined if not found
   */
  getAbbreviationById(serviceTypeId: number){
    const matchingServiceType = this.service_types.find(record => record.id === serviceTypeId);
  
    if (matchingServiceType) {
      return matchingServiceType.abbreviation;
    }
  
    return undefined;
  }

  checksToggle(type) {
    switch(type){
      case 'drv': {
        (this.checkFilters == true)? this.checkFilters = false: this.checkFilters = true;
        break;
      } case 'trk': {
        (this.checkFleetFilters == true)? this.checkFleetFilters = false: this.checkFleetFilters = true;
        break;
      } case 'trl': {
        (this.checkTrailerFilters == true)? this.checkTrailerFilters = false: this.checkTrailerFilters = true;
        break;
      }
    }
    this.complianceFilter();
  }

  pairingToggle(){
    if (this.checkPairing == true) {
      this.checkPairing = false;
    } else this.checkPairing = true;
    this.checkPairings();
  }

  async getPairing(){ //function for driver/fleet pairing
    await this.fleetpairingService.getPairs().toPromise().then(data => {
      console.time('getPairing load time');
      console.log('Getting pairings...')
      this.trailerPairings = data;
      this.getFleetList();
    });
  }

  public getTrailerPairings(trailer){
    if(this.checkPairing == true && trailer.paired_fleet != null){
        let run_index, phase_index, d_index
          this.run_plan[this.runIndexTrailer].selectedPhases.forEach((phase, index:number)=>{  
            if(phase.selectedTrailer.find(x => x.id == trailer.id) != undefined){
              d_index = phase.selectedTrailer.findIndex(x => x.id == trailer.id)
              run_index = this.runIndexTrailer; phase_index = index;
            }
          })
        // }
        let pair = this.trailerList.find(x=>x.id == trailer.paired_fleet)
        if(pair != undefined){
          let trailer_index = this.trailerList.findIndex(x=>x.id == trailer.paired_fleet)
          let paircheck = this.run_plan[run_index].selectedPhases[phase_index].selectedTrailer.find(x=>x.id == trailer.paired_fleet)

          if(paircheck==undefined){
            this.run_plan[run_index].selectedPhases[phase_index].selectedTrailer[d_index].paired_onPlan = true;
            this.moveItem( trailer.paired_fleet, run_index, phase_index, trailer_index, 'p_trailers');
          }
        }
      this.checkPairings();
    }
  }
  
  public getDriverPairings(driver){
    if(this.checkPairing == true && driver.paired_fleet != null){
      let check_list = this.driverList.find(x=>x.id == driver.id);
      if(check_list == undefined){
        let run_index, phase_index, d_index
        for (let i = 0; i < this.run_plan.length; i++) {
          this.run_plan[i].selectedPhases.forEach((phase, index:number)=>{  
            if(phase.selectedDriver.find(x => x.id == driver.id) != undefined){
              d_index = phase.selectedDriver.findIndex(x => x.id == driver.id)
              run_index = i; phase_index = index;
            } 
          })
        }
        let pair = this.trucksList.find(x=>x.id == driver.paired_fleet)
        if(pair != undefined){
          let truck_index = this.trucksList.findIndex(x=>x.id == driver.paired_fleet)
          this.run_plan[run_index].selectedPhases[phase_index].selectedDriver[d_index].paired_onPlan = true;
          this.moveItem( driver.paired_fleet, run_index, phase_index, truck_index, 'trucks');
        }
      } else {
        let index = this.driverList.findIndex(x=>x.id == driver.id)
        this.driverList[index].paired_onPlan = false;
      }
      this.checkPairings();
    }
  }

  public checkPairings(){ //checks if driver who has a paired fleet is both in run plan
    const runCount = this.run_plan.length
    for (let i = 0; i < runCount; i++) {
      this.run_plan[i].selectedPhases.forEach(phase=> {
        phase.selectedDriver.forEach(drv => {
          if(drv.paired_fleet != null){
            let fleet = phase.selectedFleet.find(x=>x.id == drv.paired_fleet)
            fleet != undefined? drv.paired_onPlan = true: drv.paired_onPlan = false;
          }
        });
        phase.selectedFleet.forEach(trk => {
          if(trk.paired_driver_id !=null){
            let driver = phase.selectedDriver.find(x=>x.id == trk.paired_driver_id)
            driver != undefined? trk.paired_onPlan = true: trk.paired_onPlan = false;
          } 
        })
        phase.selectedTrailer.forEach(trl=>{
          if(trl.paired_fleet != null){
            let fleet = phase.selectedTrailer.find(x=>x.id == trl.paired_fleet)
            fleet != undefined? trl.paired_onPlan = true: trl.paired_onPlan = false;
          }
        })
      });
    }
  }
  //End of Pairing and Presets

  public updateOnActivityPreset(row){
    if(this.activitiesList.find(x => x.id == row.id) == undefined){
      for (let i = 0; i < this.run_plan.length; i++) {
        this.run_plan[i].selectedPhases.forEach((phase, index:number) => {
          if(phase.selectedActivities.find(x => x.id == row.id) != undefined){
            if (phase.selectedActivities.find(x => x.connote_id == row.connote_id && x.id != row.id) == undefined){
              if(this.run_plan[i].selectedPhases[0].selectedDriver.length == 0) this.getPresets(row.connote_id, i, index);
            }

            //here?
            this.autoSetLocation(i);
          }
        });
      }
      if(!row.isAddedTask){
        let index = this.fullActivities.findIndex(x=>x.id == row.id)
        this.fullActivities.splice(index, 1);
      }  
    } else {
      let i1, i2;
      if(!row.isAddedTasks){
        i1 = this.activitiesList.findIndex(x=>x.id == row.id);
        i2 = this.fullActivities.findIndex(x=>x.id == row.id)
      } else {
        i1 = this.activitiesList.findIndex(x=>x.u_id == row.u_id);
        i2 = this.fullActivities.findIndex(x=>x.u_id == row.u_id)
      }

      if(i1 != -1 && i2 == -1) this.fullActivities.push(row);
    }
  }

  public updateOnActivityDrop(row){
    if (this.activitiesList.length == 0)
      this.emptyActList = false

    if (row.u_id) {
      let actTarget = this.activitiesList.find(x => x.u_id == row.u_id);
    if (actTarget == undefined) {
        this.addedTasks.forEach(act => { if (act.u_id == row.u_id) act.order_number = null; });
      } else if (actTarget != undefined) {
        this.addedTasks.forEach(act => { if (act.u_id == row.u_id) act.order_number = 0; });
      }
    }

    this.checkInfo('truck'); this.checkInfo('trailer');
    this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
    this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
    this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
  }

  public async getDriverAssignment(source, r_idx, p_idx){
    this.spinner = true;
    let assignments = [], filteredAssignments = [], sortedArray = []

    await this.dispatchService.getDriverDispatchAssignments(this.currSelectedDriver.id).toPromise().then(data=>{
      assignments = data['current_assignments']
      if(assignments.length !=0){
        assignments.forEach(r => {
          let location = this.locations.find(x => x.id == r.run_plan_location_id)
          if(location != undefined){
            let state = this.states.find(x=> x.id == location?.state_id)?.abbreviation
            var location_full = (location.street_no != null ? location.street_no: '') +' '+ location?.street +' '+ location?.suburb +', '+ state
            r["location_full"] = location_full
          } else r["location_full"] = 'Location TBA';
        });

        //grouping activities by run
        assignments.forEach(el => {sortedArray.push(el.run_id); });
        sortedArray = sortedArray.filter((element, i) => i === sortedArray.indexOf(element))
        sortedArray.forEach((sorted, i:number)=>{
          let arr = {'id': null , 'control_no':'', status:null, 'act':[]};
          arr.id = sorted;
          assignments.forEach(el => { if(el.run_id== sorted) arr.act.push(el); });
          arr.act.sort(function(a,b){
            var dateA = new Date(b.run_plan_start_datetime).valueOf(), dateB = new Date(a.run_plan_start_datetime).valueOf()
            return dateB - dateA || a.id - b.id
          });
          arr.control_no = arr.act[0].run_control_no;
          arr.status = arr.act[arr.act.length-1].run_status
          filteredAssignments.push(arr);
        })

        const lastAct = filteredAssignments.length-1
        const will_finish = filteredAssignments[lastAct].act[filteredAssignments[lastAct].act.length-1].run_plan_end_datetime;

        if(source == 'drop'){
          let idx; 
          for (let i = 0; i < this.run_plan.length; i++) {
            this.run_plan[i].selectedPhases.forEach((phase, index:number)=>{  
              if(phase.selectedDriver.find(x => x.id == this.currSelectedDriver.id) != undefined){
              idx = phase.selectedDriver.findIndex(x=>x.id == this.currSelectedDriver.id)
              r_idx = i; p_idx = index;
              }
            })
          }
          
          if(r_idx!=null && p_idx!=null && idx!=null){
            this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['current_assignments'] = filteredAssignments
            this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['willFinish'] = will_finish
            this.updateOnDriverAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx], r_idx, p_idx, idx);
          } else {
            idx = this.driverList.findIndex(x=>x.id == this.currSelectedDriver.id)
            this.driverList[idx]['assignmentConflict'] = false;
          }

        } else if(source == 'list'){
          let idx = this.driverList.findIndex(x=>x.id == this.currSelectedDriver.id)
          this.driverList[idx]['current_assignments'] = filteredAssignments
          this.driverList[idx]['willFinish'] = will_finish
        } else if(source == 'planner'){
          let idx = this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver.findIndex(x=>x.id == this.currSelectedDriver.id)
          this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['current_assignments'] = filteredAssignments
          this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['willFinish'] = will_finish
          this.updateOnDriverAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx], r_idx, p_idx, idx)
        }
      }
    });
    setTimeout(() => { this.spinner = false; }, 500);
  }

  async updateOnDriverAssignment(drv, r_idx, p_idx, idx){
    let activities = [], formattedStartDate, formattedEndDate
    this.run_plan[r_idx].selectedPhases.forEach(phase=>{ phase.selectedActivities.forEach(act => { activities.push(act)}); })

    if(drv.current_assignments && activities.length != 0){
      formattedStartDate = activities[0].opening_datetime
      formattedEndDate = activities[activities.length-1].closing_datetime;
      
      let result = await this.dispatchService.assignmentConflict_v2(drv.current_assignments, formattedStartDate, formattedEndDate)
      if(result == true){
        this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['assignmentConflict'] = true;
      } else this.run_plan[r_idx].selectedPhases[p_idx].selectedDriver[idx]['assignmentConflict'] = false;
    }
  }

  public async getFleetAssignment(source, id, r_idx, p_idx){
    this.spinner = true;
    let assignments = [], filteredAssignments = [], sortedArray = []
    await this.dispatchService.getEquipmentDispatchAssignments(id).toPromise().then(data=>{
      assignments = data['current_assignments_fleet']
      if(assignments.length !=0){
        assignments.forEach(r => {
          let location = this.locations.find(x => x.id == r.run_plan_location_id)
          if(location != undefined){
            let state = this.states.find(x=> x.id == location?.state_id)?.abbreviation
            var location_full = (location.street_no != null ? location.street_no: '')+' '+ location?.street +' '+ location?.suburb +', '+ state
            r["location_full"] = location_full
          } else r["location_full"] = 'Location TBA';
        });

        
        //grouping activities by run
        assignments.forEach(el => {sortedArray.push(el.run_id); });
        sortedArray = sortedArray.filter((element, i) => i === sortedArray.indexOf(element))
        sortedArray.forEach((sorted, i:number)=>{
          let arr = {'id': null , 'control_no':'', status:null, 'act':[]};
          arr.id = sorted;
          assignments.forEach(el => { if(el.run_id== sorted) arr.act.push(el); });
          arr.act.sort(function(a,b){
            var dateA = new Date(b.run_plan_start_datetime).valueOf(), dateB = new Date(a.run_plan_start_datetime).valueOf()
            return dateB - dateA || a.id - b.id
          });
          arr.control_no = arr.act[0].run_control_no;
          arr.status = arr.act[arr.act.length-1].run_status
          filteredAssignments.push(arr);
        })

        const lastAct = filteredAssignments.length-1
        const will_finish = filteredAssignments[lastAct].act[filteredAssignments[lastAct].act.length-1].run_plan_end_datetime;
        if(source == 'flt_drop'){
          let idx; 
          for (let i = 0; i < this.run_plan.length; i++) {
            this.run_plan[i].selectedPhases.forEach((phase, index:number)=>{  
              if(phase.selectedFleet.find(x => x.id == id) != undefined){
              idx = phase.selectedFleet.findIndex(x=>x.id == id)
              r_idx = i; p_idx = index;
              }
            })
          }
          
          if(r_idx!=null && p_idx!=null && idx!=null){
            this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['current_assignments'] = filteredAssignments
            this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['willFinish'] = will_finish
            this.updateOnFleetAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx], r_idx, p_idx, idx, 'truck')
          } else {
            idx = this.fleetList.findIndex(x=>x.id == id)
            this.fleetList[idx]['assignmentConflict'] = false;
          }

        } else if(source == 'trl_drop'){
          let idx; 
          for (let i = 0; i < this.run_plan.length; i++) {
            this.run_plan[i].selectedPhases.forEach((phase, index:number)=>{  
              if(phase.selectedTrailer.find(x => x.id == id) != undefined){
              idx = phase.selectedTrailer.findIndex(x=>x.id == this.currSelectedFleet.id)
              r_idx = i; p_idx = index;
              }
            })
          }
          
          if(r_idx!=null && p_idx!=null && idx!=null){
            this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['current_assignments'] = filteredAssignments
            this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['willFinish'] = will_finish
            this.updateOnFleetAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx], r_idx, p_idx, idx,'trailer')
          } else {
            idx = this.trailerList.findIndex(x=>x.id == this.currSelectedFleet.id)
            this.trailerList[idx]['assignmentConflict'] = false;
          }
        } else if(source == 'flt_list'){
          let idx = this.fleetList.findIndex(x=>x.id == id)
          this.fleetList[idx]['current_assignments'] = filteredAssignments
          this.fleetList[idx]['willFinish'] = will_finish
        } else if(source == 'flt_planner'){
          let idx = this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet.findIndex(x=>x.id == id)
          this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['current_assignments'] = filteredAssignments
          this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['willFinish'] = will_finish
          this.updateOnFleetAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx], r_idx, p_idx, idx, 'truck')
        }else if(source == 'trl_list'){
          let idx = this.trailerList.findIndex(x=>x.id == id)
          this.trailerList[idx]['current_assignments'] = filteredAssignments
          this.trailerList[idx]['willFinish'] = will_finish
        } else if(source == 'trl_planner'){
          let idx = this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer.findIndex(x=>x.id == id)
          this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['current_assignments'] = filteredAssignments
          this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['willFinish'] = will_finish
          this.updateOnFleetAssignment(this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx], r_idx, p_idx, idx,'trailer')
        }
      }
    });
    setTimeout(() => { this.spinner = false; }, 500);
  }

  async updateOnFleetAssignment(row, r_idx, p_idx, idx, type:string){
    let activities = [], formattedStartDate, formattedEndDate
    this.run_plan[r_idx].selectedPhases.forEach(phase=>{ phase.selectedActivities.forEach(act => { activities.push(act)}); })

    switch(type){
      case 'truck':{
        if(row.current_assignments && activities.length != 0){
          formattedStartDate = activities[0].opening_datetime
          formattedEndDate = activities[activities.length-1].closing_datetime;
          
          let result = await this.dispatchService.assignmentConflict_v2(row.current_assignments, formattedStartDate, formattedEndDate)
          if(result == true){
            this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['assignmentConflict'] = true;
          } else this.run_plan[r_idx].selectedPhases[p_idx].selectedFleet[idx]['assignmentConflict'] = false;
        } 
        break;
      } case 'trailer':{
        if(row.current_assignments && activities.length != 0){
          formattedStartDate = activities[0].opening_datetime
          formattedEndDate = activities[activities.length-1].closing_datetime;
          
          let result = await this.dispatchService.assignmentConflict_v2(row.current_assignments, formattedStartDate, formattedEndDate)
          if(result == true){
            this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['assignmentConflict'] = true;
          } else this.run_plan[r_idx].selectedPhases[p_idx].selectedTrailer[idx]['assignmentConflict'] = false;
        }
        break;
      } default: break;
    }
    setTimeout(() => { this.spinner = false; }, 1500);
  }

  public sortRoutes() {
    for (let i = 0; i < this.routes.length; i++) {
      let start = this.states.find(x => x.id == this.routes[i].start_state_id)
      let end = this.states.find(x => x.id == this.routes[i].end_state_id)
      let changeover = this.states.find(x => x.id == this.routes[i].changeover_state_id)
      if (changeover != undefined) {
        this.routes[i]['full_route'] = start.name + ' (' + start.abbreviation + ') - ' + changeover.name + ' (' + changeover.abbreviation + ') - ' + end.name + ' (' + end.abbreviation + ')'
      } else {
        this.routes[i]['full_route'] = start.name + ' (' + start.abbreviation + ') - ' + end.name + ' (' + end.abbreviation + ')'
      }
    }
    this.routes.sort((a, b) => a.description < b.description ? 1 : -1);
  } //end sortRoutes

  public isRouteChangeover() {
    if (this.isChangeover == false) {
      this.isChangeover = true;
    } else this.isChangeover = false;
  }

  public setChangeoverEdit(changeoverIndex){ //inverted setChangeover
    console.log('set changeover in edit form', changeoverIndex)
    //setting main run plan's manifest changeover
    let runIndex = this.selectedIndex[0];
    this.run_plan[runIndex].manifest_changeover = changeoverIndex;
    
    //displaying changeover plan to edit form
    if(changeoverIndex == null || changeoverIndex == 'null'){
      this.selectedActivity[1] = []; this.selectedIndex[1] = null;
      this.run_plan[runIndex].is_changeover = false;
      this.run_plan[runIndex].checkChangeover = true;

    } else {
      this.run_plan[runIndex].is_changeover = true; this.selectedIndex[1] =  parseInt(changeoverIndex);
      this.selectedActivity[1] = this.run_plan[changeoverIndex].selectedPhases;
      this.run_plan[runIndex].manifest_changeover = parseInt(changeoverIndex);
    } 
    //call setChangeover
    this.setChangeover(runIndex);
  }

  public setChangeover(runIndex){
    this.run_plan[runIndex].is_changeover = true;
    if(this.run_plan[runIndex].manifest_changeover.toString() == 'null'){
      this.run_plan[runIndex].manifest_changeover = null;
      this.run_plan[runIndex].is_changeover = false;
      this.run_plan[runIndex].checkChangeover = true;
    }

    let changeoverIndex = this.run_plan[runIndex].manifest_changeover;
    for (let i = 0; i < this.run_plan.length; i++) {
      if(changeoverIndex == null){
        if(this.run_plan[i].manifest_changeover == runIndex)
          this.run_plan[i].manifest_changeover = null;
          this.run_plan[i].is_changeover = false;
          this.run_plan[i].checkChangeover = true;
        }
        
        if(this.run_plan[i].manifest_changeover == changeoverIndex && runIndex != i){
          this.run_plan[i].manifest_changeover = null;
          this.run_plan[i].is_changeover = false;
          this.run_plan[i].checkChangeover = true;
        }
      }
      
      if(changeoverIndex != null ){
      this.run_plan[changeoverIndex].manifest_changeover = runIndex;
      this.run_plan[changeoverIndex].is_changeover = true;
      }
  }

  //GET SERVICES
  async getData() {
    console.log('Getting Data')
    await this.dispatchService.getDispatchMiscData().toPromise().then(data => {
      this.service_types   = data['service_types'];
      this.run_actions     = data['run_actions'];
      this.run_types       = data['run_types'];
      this.states          = data['states'];
      this.routes          = data['state_routes'];
      this.run_statuses    = data['run_statuses'];
      this.packaging_types = data['packaging_types'];
      this.dg_licenses     = data['dg_licenses'];
      this.dg_subsidiary_risks = data['dg_subsidiary_risks'];
      this.geofence_size_default = data['geofence_default'];
      this.warehouse_addresses = data['warehouse_sites'];
    })
    console.log("serv type", this.service_types);
    
    this.sortRoutes();
  }

  async getLocation(){
    await this.dispatchService.getDispatchLocationData().toPromise().then(data => {
      this.locations = data['locations'];
    })
    setTimeout(() => { this.locationSpinner = false; }, 500);
  }

  public getDriverLicenseClasses() {
    this.driverService.getDriverLicenseClasses().subscribe(data => {
      this.driverLicenceClasses = data["license_classes"];
    })
  }

  async getDriverList() {
    let driverlist =[]
    let currdate = new Date();
    await this.dispatchService.getDrivers().toPromise().then(data => {
      driverlist = data["drivers"];
      console.log('Driver List retrieved.')
      driverlist.sort((a,b) => a.first_name.localeCompare(b.first_name));
      driverlist.forEach(el => {
        let is_paired = this.driverPairings.find(x=>x.driver_id == el.id)
        if(is_paired != undefined){
          let temp = this.fleetList.find(x=> x.id == is_paired.fleet_id);
          if(temp!=undefined){
            let t_index = this.fleetList.findIndex(x=> x.id == is_paired.fleet_id);
            this.fleetList[t_index]['paired_driver_id'] = el.id;
            this.fleetList[t_index]['paired_driver'] = el.first_name + ' ' + el.last_name;
            el['paired_rego'] = temp.rego;
          } else el['paired_rego'] = null;
          el['paired_fleet'] = is_paired.fleet_id;
        }else {
          el['paired_fleet'] = null;
          el['paired_rego'] = null;
        }
        el['current_assignments'] = null;
        el['assignmentConflict'] = false;
        el['paired_onPlan'] = false;
        el['isLicenceApplicable'] = true;
        let l_date = new Date(el.license_expiry);
        (l_date > currdate) ? el['is_expired'] = 0 : el['is_expired'] = 1;
      });
      this.gettruckandtrailers();
      this.driverListArray = driverlist;
      this.fulldrivers = driverlist;

      //filter
      if (this.checkFilters == true) {
        this.driverList = driverlist.filter(data => data.driver_test == 1);
      } else this.driverList = driverlist;
    })
  }

  async getFleetList() {
    await this.dispatchService.getEquipments().toPromise().then(data => {
      this.fleets = data["equipments"];
      this.fleetList = this.fleets;
      this.fullfleets = this.fleetList;
      console.log('Fleet List retrieved.')
      
      this.driverTruckPairingService.getPairs({perPage:-1}).subscribe(async data => {
        this.driverPairings = data;
        await this.getDriverList();
      });
    })
  }

  gettruckandtrailers(){
    let currdate = new Date();
    console.log('sorting truck and trailers..');
      for (let i = 0; i < this.fleetList.length; i++) {
        if (this.fleetList[i].fleet_type_id == 4) {
          this.fleetList[i]['paired_onPlan'] = null;
          this.fleetList[i]['paired_driver'] = null;
          let paired = this.trailerPairings.find(x => x.fleet_id == this.fleetList[i].id)
          if(paired !=undefined){ //may be paired with multiple fleets in future updates
            let temp = this.fleets.find(x=>x.id == paired.pairs[0])
            if(temp != undefined){
              this.fleetList[i]['paired_fleet'] = paired.pairs[0];
              this.fleetList[i]['paired_rego'] = temp.rego
            }
          } else {
            paired = this.trailerPairings.find(x => x.pairs[0] == this.fleetList[i].id)
            if(paired != undefined){
              let temp = this.fleetList.find(x=>x.id == paired.fleet_id)
              if(temp != undefined){
                this.fleetList[i]['paired_fleet'] = paired.fleet_id;
                this.fleetList[i]['paired_rego'] = temp.rego
              }
            } else {
              this.fleetList[i]['paired_fleet'] = null;
              this.fleetList[i]['paired_rego'] = null;
            }
          }

          this.trailerList.push(this.fleetList[i])
        } else {
          this.fleetList[i]['isTypeApplicable'] = true 
          this.fleetList[i]['paired_fleet'] = null; 
          this.trucksList.push(this.fleetList[i]);
        }
        
        //rego expiry
        let l_date = new Date(this.fleetList[i].rego_due_date);
        (l_date > currdate) ? this.fleetList[i]['is_expired'] = 0 : this.fleetList[i]['is_expired'] = 1;
      }
      this.fulltrailers = this.trailerList;
      this.fulltrucks = this.trucksList;
      this.trucks = this.trucksList
      this.trailers = this.trailerList
      this.complianceFilter();
      console.log("Get dispatch data finished.");
      console.timeEnd('getPairing load time');
      this.mainloading = true;
      this.loadingIndicator = false; 
  }

  async getTotalKlms(run_index){
    let activities = this.getPlanActivities(run_index);

    if(this.isServiceTypeMatch(this.run_plan[run_index].service_type_id, ServiceTypeAbbreviations.RoadTrain)){
      activities = this.run_plan[run_index].RTacts;
    }
    
    if(activities.length > 1){
      if(activities.filter(x=>x.location_id == null).length > 0){
        let route = this.routes.find(x=>x.id == this.run_plan[run_index].routeselected_id)

        if(route != undefined && route.start_state_id == activities[0].state_id){
          await this.dispatchService.getMinimumRestHrsKlms(route.klms).toPromise().then(data => {
            this.run_plan[run_index].totalklms = route.klms;
            this.run_plan[run_index].totaldrivinghours = data['total_driving_hours']
            console.log('TBA minimum rest hours: ' + route.klms)
          })
        } else {
          this.run_plan[run_index].totaldrivinghours = 0;
          this.run_plan[run_index].totalklms = 0;
        }
      } else {
        let t_klms = 0.00, t_dhours = 0.00, act_pairs = []
        const pickups = activities.filter(obj => obj.run_action_id == 1)
        let prev_info = activities[0], count = 0
        for (let i = 0; i < activities.length; i++) {
          let curr_info = activities[i];
          if(prev_info.id != curr_info.id || prev_info.u_id != curr_info.u_id){
            act_pairs[count] = { prev_info, curr_info}
            prev_info = activities[i]; count++; 
          }
        }
        const pairsCount = act_pairs.length
        if(this.run_plan[run_index].run_type_id == 1){ //LOCAL
          for (let i = 0; i < pairsCount; i++) {
              let computeklms = {
                "from_lat"  : act_pairs[i].prev_info.location_lat,
                "from_lng"  : act_pairs[i].prev_info.location_lng,
                "to_lat"    : act_pairs[i].curr_info.location_lat,
                "to_lng"    : act_pairs[i].curr_info.location_lng,
              }
              await this.dispatchService.getTotalKlmsHours(computeklms).toPromise().then(data => {
                if(data['error_message'] == ''){
                  t_dhours= t_dhours + data['total_driving_hours']; t_klms= t_klms + data['total_klms'];
                } else console.log(data['error_message'], JSON.stringify(computeklms));
              })
          }
        } else {
          for (let i = 0; i < pairsCount; i++) {
            let computeklms = {
              "from_lat"  : Number, "from_lng"  : Number,
              "to_lat"    : Number, "to_lng"    : Number,
            }
            let start_action = Number(act_pairs[i].prev_info.run_action_id)
            let end_action = Number(act_pairs[i].curr_info.run_action_id)
            if(start_action != end_action && (start_action != 3 || end_action != 4)){
              if(act_pairs[i].prev_info.isAddedTask == false && act_pairs[i].curr_info.isAddedTask == false){
                
                computeklms.from_lat = act_pairs[i].prev_info.location_lat
                computeklms.from_lng = act_pairs[i].prev_info.location_lng
                computeklms.to_lat = act_pairs[i].curr_info.location_lat
                computeklms.to_lng = act_pairs[i].curr_info.location_lng
              } else if(act_pairs[i].prev_info.isAddedTask == true && act_pairs[i].curr_info.isAddedTask == true){
                computeklms.from_lat = act_pairs[i].prev_info.location_lat
                computeklms.from_lng = act_pairs[i].prev_info.location_lng
                computeklms.to_lat = act_pairs[i].curr_info.location_lat
                computeklms.to_lng = act_pairs[i].curr_info.location_lng
              } else {
                if(act_pairs[i].prev_info.isAddedTask == true){
                  computeklms.from_lat = act_pairs[i].prev_info.location_lat
                  computeklms.from_lng = act_pairs[i].prev_info.location_lng
                  computeklms.to_lat = act_pairs[i].curr_info.location_lat
                  computeklms.to_lng = act_pairs[i].curr_info.location_lng
                }
                if(act_pairs[i].curr_info.isAddedTask == true){
                  computeklms.from_lat = act_pairs[i].prev_info.location_lat
                  computeklms.from_lng = act_pairs[i].prev_info.location_lng
                  computeklms.to_lat = act_pairs[i].curr_info.location_lat
                  computeklms.to_lng = act_pairs[i].curr_info.location_lng
                }
              }
  
              if(start_action == 15 && end_action == 1){
                if(act_pairs[i].curr_info.id != pickups[pickups.length-1].id){
                  let lastPickup = pickups[pickups.length-1];
                  computeklms.to_lat = lastPickup.location_lat;
                  computeklms.to_lng = lastPickup.location_lng;
                }
              }

              if(computeklms.from_lat != null && computeklms.from_lng != null && computeklms.to_lat != null && computeklms.to_lng != null){
                await this.dispatchService.getTotalKlmsHours(computeklms).toPromise().then(data => {
                  if(data['error_message'] == '') t_dhours= t_dhours + data['total_driving_hours']; t_klms= t_klms + data['total_klms'];
                });
              } else {console.error('Failed to compute distance', computeklms);}
            }
          }
        }
        this.run_plan[run_index].totaldrivinghours  = Number(t_dhours.toFixed(2));
        this.run_plan[run_index].totalklms = Number(t_klms.toFixed(2));
        console.log('run plan #', run_index+1, ', total driving hours: ', t_dhours.toFixed(2),', total klms: ', t_klms.toFixed(2));
      }
    } else {
      this.run_plan[run_index].totaldrivinghours = 0;
      this.run_plan[run_index].totalklms = 0;
    }
  }
  //END OF GET SERVICES

  public resetDispatch(key) {
    switch (key) {
      case 'category_reset': {
        this.job_Type = null;
        this.service_Type = null;
      } case 'clear_newTask': {
        this.finalTasks = []
        this.addedTasks = []
        this.taskCount = 0;
      } case 'dispatch_area_reset': {
        this.activitiesList = [];
        this.initAddRouteForm();
        this.initAddTaskFormv2();
        break;
      } case 'all': {
        this.loadingIndicator = true;
        while(this.run_plan.length) {this.run_plan.pop(); this.run_errors.pop()  } 
        this.planCount = 1;
        this.run_plan[0] = {
          run_type_id             : null,
          service_type_id         : null,
          check_trl_dups:          false,
          isStandardApplicable    : true,
          isLicenceApplicable     : true,
          isFleetTypeApplicable   : true,
          routeselected_id        : null,
          isRouteApplicable       : true,
          check_Driver            : true,
          check_Driver_Licence    : true,
          check_conflict_drv      : true,
          check_conflict_trk      : true,
          check_conflict_trl      : true,
          check_Truck             : true,
          check_regoExpiry        : false,
          check_regoTrailerExpiry : false,
          check_ServiceType       : 0,
          checkAtrailer           : false,
          checkActivities         : true,
          checkER                 : true,
          checkLoad               : 0,
          checkChangeover         : true,
          checkTaskTime           : true,
          totalklms               : 0,
          totaldrivinghours       : 0,
          is_excluded_saturday    : 1,
          is_excluded_sunday      : 1,
          is_excluded_holiday_no  : 0,
          excluded_holiday_dates  : [],
          other_work_hour         : 1,
          other_work_min          : 30,
          other_rest_hours        : null,
          min_long_rest_hours     : null,
          min_short_rest_hours    : null,
          is_changeover           : false,
          manifest_changeover     : null,
          admin_notes             : null,
          dispatch_notes          : this.dispatchNotes,
          RTacts                  : [],
          selectedPhases: [{
            selectedActivities    : [],
            selectedDriver        : [],
            selectedFleet         : [],
            selectedTrailer       : [],
          }]
        }
        this.run_errors[0] = {
          timeError: false,
          timeErrorString: '',
          combinationError: false,
          combinationErrorString: '',
          startingError: false,
          warehouseErrorString: '',
          warehouseError: false,
          eq_warehouseString: '',
          eq_warehouseError: false,
          trailerErrors: '',
          phaseCheck: true,
          warehouseActivityCheck: false,
          warehouseActivityError: '',
        }
        this.showOtherWork[0] = false;
        this.trailerList = [], this.trucksList = [];
        this.driverList = [], this.activitiesList = [];
        this.fullActivities = [];
        this.getPairing();
        this.initAddRouteForm();
        this.initAddTaskFormv2();

        if(this.addedTasks.length > 0){
          this.addedTasks.forEach(x => {
            x.order_number = 0;
          });
        }
        this.taskCount = this.addedTasks.filter(obj => obj.order_number == 0).length;
        this.taskReleaseCount = this.addedTasks.filter(x => (x.run_action_id == 3 || x.run_action_id == 9) && x.order_number == 0).length
        this.taskCollectCount = this.addedTasks.filter(x => (x.run_action_id == 4 || x.run_action_id == 10) && x.order_number == 0).length
        break;
      } default: { break; }
    }
  } //end resetDispatch

  public checkLoad_per_run(run_index){
    let load: number, activities = [], cons = [], run = this.run_plan[run_index], service = run.service_type_id

    run.selectedPhases.forEach(phases =>{
      phases.selectedActivities.forEach(act => {
        activities.push(act);
      });
    })
    activities.forEach(x => {
      if(x.connote_id !=undefined) cons.push(x.connote_id);
    });
    let arrayTemp = cons.filter((element, i) => i === cons.indexOf(element))
    
    let currentLoad = [];
    arrayTemp.forEach((el, i:number) => {
      let details = {
        'connote_id': activities.find(x=>x.connote_id == arrayTemp[i]).connote.id,
        'run_type_id': activities.find(x=>x.connote_id == arrayTemp[i]).run_type_id,
        'service_type' : activities.find(x=>x.connote_id == arrayTemp[i]).connote.service_type_id,
        'linehaul_type_id' : activities.find(x=>x.connote_id == arrayTemp[i]).connote.linehaul_type_id
      }
      currentLoad.push(details)
    });

    const curr = currentLoad.length;
    const curr_ftl = currentLoad.filter(x=>x.linehaul_type_id == 1)
    const curr_ltl = currentLoad.filter(x=>x.linehaul_type_id == 2)
    //checkload values 
    // 0 - no action (for runs with LTLs)     1 - full load
    // 2 - more than trukload                 3 - incorrect equipment type
    // 4 - multiple LTLS
    
    if(run.service_type_id != null && activities.length > 0){
      if(run.run_type_id == 6 || (run.run_type_id == 2 && this.isServiceTypeMatch(this.service_Type, ServiceTypeAbbreviations.RoadTrain))){
        //WAREHOUSE run type/ ROAD TRAIN - full load
        if(curr == curr_ftl.length + curr_ltl.length) load = 1;
        return load; // full load
      } else if(run.run_type_id == 1 || run.run_type_id == 4){
        // LOCAL and TOWHAUL - always full load and only 1 connote per run
        let connote = activities.find(x=>x.connote_id == arrayTemp[0]).connote
        load = 1;
        if(this.getAbbreviationById(run.service_type_id) != this.getAbbreviationById(connote.service_type_id) && connote.service_type_id != null) load = 3;
        if(activities.filter(x=>x.run_action_id == 5).length > 1) load = 2; // if more than 1 local start

        return load
      } else {
        if(curr == 0){ 
          load = 0
        } else if(curr == 1 && curr_ftl.length == 1) {
          const c_service = curr_ftl[0].service_type; load = 1; 
          
          if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.UTE)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.Rigid) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne4P) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne8P) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne14P)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TenPalletRigid)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne6P)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne10P)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.EightTonne12P)
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne12P)){ // ute and rigids
            if(this.getAbbreviationById(c_service) != this.getAbbreviationById(service)) load = 3;
          }
          if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMOnly) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMWithTrailers)){ // semi
            if((this.getAbbreviationById(c_service) != this.getAbbreviationById(service))
              ||(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMOnly) 
              && this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.SemiPMWithTrailers))) load = 3;
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMWithTrailers) 
                && (this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.SemiPMWithTrailers) 
                  || this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.ATrailer) 
                  || this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BTrailer))) load = 1;
          }
          if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMOnly) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithTrailers) 
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithATrailer)  
            || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithBTrailer) ){ // bdbl prime movers
            if(this.getAbbreviationById(c_service) != this.getAbbreviationById(service)) load = 3;
            if((this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithATrailer)
                && this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.ATrailer))
              ||(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithBTrailer) 
                && this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BTrailer))) load = 1;
            if(this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BDoublePMOnly) 
              && (this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithTrailers)
                || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
                || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithBTrailer))) load = 0;
            if((this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BDoublePMWithATrailer)  
              || this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BDoublePMWithBTrailer)  
              || this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.BTrailer)  
              || this.isServiceTypeMatch(c_service, ServiceTypeAbbreviations.ATrailer)) 
              && this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithTrailers)) load = 0;
          }
        } else { //LTL
          load = 0;
          if(curr == curr_ftl.length){ //if there are more than 1 FTLs
            let empty_true = false; load = 3;
            if((curr_ftl.find(x=> x.run_type_id == 3) !=undefined) && curr_ftl.length >= 2 ) empty_true = true;

            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithTrailers)  && curr_ftl.length != 0){ //need 2 trailers 1A-1B
              let full = curr_ftl.filter(x=> this.isServiceTypeMatch(x.service_type, ServiceTypeAbbreviations.BDoublePMWithTrailers) && x.run_type_id == 2)
              let empty_run = curr_ftl.filter(x=> x.run_type_id == 3)
              if(full !=undefined && full.length == 1){
                empty_run.length == 1 && curr_ftl.length == 2? load = 1: load = 2;
              }else{
                let countA = curr_ftl.filter(x=> this.isServiceTypeMatch(x.service_type, ServiceTypeAbbreviations.BDoublePMWithATrailer) || this.isServiceTypeMatch(x.service_type, ServiceTypeAbbreviations.ATrailer)).length
                let countB = curr_ftl.filter(x=> this.isServiceTypeMatch(x.service_type, ServiceTypeAbbreviations.BDoublePMWithBTrailer) || this.isServiceTypeMatch(x.service_type, ServiceTypeAbbreviations.BTrailer)).length
                if(countA == 1 && countB == 1){
                  if(curr_ftl.length == 2){
                    load = 1;
                  } else if (curr_ftl.length > 2){
                    if (empty_run != undefined) load = 1;
                  } else load = 2;
                } else {
                  if(this.run_plan[run_index].manifest_changeover != null){ //changeover
                    load = 1;
                  } else {
                    load = 2;
                    if(empty_true == true && curr_ftl.length <= 2 ) load = 0;
                  }
                }
              }
            }
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMWithTrailers) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithBTrailer)){ //semi w/ Trailer, BDBL A ,BDBL B
              if(empty_true == true && curr_ftl.length == 2){
                if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMWithTrailers) 
                  && (this.getAbbreviationById(curr_ftl[1].service_type) == this.getAbbreviationById(service) 
                  || this.isServiceTypeMatch(curr_ftl[1].service_type, ServiceTypeAbbreviations.ATrailer)  
                  || this.isServiceTypeMatch(curr_ftl[1].service_type, ServiceTypeAbbreviations.BTrailer))) load = 1;
                if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithATrailer) 
                  && (this.getAbbreviationById(curr_ftl[1].service_type) == this.getAbbreviationById(service) 
                  || this.isServiceTypeMatch(curr_ftl[1].service_type, ServiceTypeAbbreviations.ATrailer))) load = 1;
                if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithBTrailer) 
                  && (this.getAbbreviationById(curr_ftl[1].service_type) == this.getAbbreviationById(service) 
                  || this.isServiceTypeMatch(curr_ftl[1].service_type, ServiceTypeAbbreviations.BTrailer))) load = 1;
                if(this.getAbbreviationById(curr_ftl[0].service_type) != this.getAbbreviationById(service)) load = 3;
              } else {
                curr_ftl.length >=2 && curr_ftl.length != 0? load = 2: load = 3
              }
            }
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.UTE) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.Rigid) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne4P) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne8P) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne14P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TenPalletRigid)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne6P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne10P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.EightTonne12P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne12P)){ // ute and rigids
              if(empty_true == true && this.getAbbreviationById(curr_ftl[1].service_type) == this.getAbbreviationById(service)){
                load = 1; 
              } else if (this.getAbbreviationById(curr_ftl[1].service_type) != this.getAbbreviationById(service)){
                load = 3;
              } else load = 2; 
            }
            
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SemiPMOnly) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMOnly)) load = 3;
          } else if(curr == curr_ltl.length){ //all LTLs - requirement is more than one lts for now
            if(curr_ltl.length >= 2) load = 1
          } else { //combos
            //requires - 1 ftl and 1 ltl
            // > 1 ftl and > 1 ltl is always full load 
            //for linehaul - warehouse combinations

            let empty_true = false; //empty run - always FTL but will not be included for full load in combinations
            if(curr_ftl.length == 1){
              if(curr_ftl[0].run_type_id == 3 && this.getAbbreviationById(curr_ftl[0].service_type) == this.getAbbreviationById(service)) empty_true = true;
            }
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.UTE) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.Rigid)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne4P) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne8P) 
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne14P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TenPalletRigid)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwoTonne6P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.SixTonne10P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.EightTonne12P)
              || this.isServiceTypeMatch(service, ServiceTypeAbbreviations.TwelveTonne12P)){ // ute and rigids
              if(empty_true == true){
                if(curr_ltl.length >=1) load = 1; //only one req
              } else {
                if(curr_ftl.length >= 2 && curr_ltl.length != 0) load = 2;
                if(curr_ftl.length == 0 && curr_ltl.length != 0 && curr_ltl.length >= 1) load = 1;
                if(curr_ftl.length == 1 && this.getAbbreviationById(curr_ftl[0].service_type) != this.getAbbreviationById(service)) load = 3;
              }
            }
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.BDoublePMWithTrailers)){ //BDBL
                if(empty_true == true){ //with emptyrun
                  if(curr_ftl.length <= 2 && curr_ltl.length >= 1) load = 1;
                  else if(curr_ltl.length != 0 && curr_ltl.length >= 1) load = 1;
                } else {
                  //multiple ftls and ltls combination
                  if(curr_ftl.length <=2 && curr_ltl.length >= 1) load = 1;
                  else if(curr_ltl.length != 0 && curr_ltl.length >= 1) load = 1;
                }          
            }
            if(this.isServiceTypeMatch(service, ServiceTypeAbbreviations.RoadTrain)){ //Road Train
              let empty_run = curr_ftl.find(x => x.run_type_id == 3);
              if(empty_run != undefined){
                if(curr_ftl.length == 0 && curr_ltl.length >=2) load = 1;
                else if(curr_ftl.length != 0 && curr_ltl.length >=2) load = 1;
              } else load = 0;
            }
          }
        } return load
      }
    } else return load = 0;
  }

  public allowSubmit(){
    let final_allow = [], tba_count, runType, allowcheck, allow, allowDriver, allActivities;
    this.run_plan.forEach((run, count:number) => {
      run.checkLoad = this.checkLoad_per_run(count)
      run.isRouteApplicable = true; allow = false; allowcheck= true;
      this.run_plan[count].checkActivities = true;
      this.run_errors[count].timeError = false;

      if (run.run_type_id != null && run.service_type_id != null) {
        if (run.run_type_id == 2 || run.run_type_id == 3 || run.run_type_id == 4) runType = 'Linehaul';
        if (run.run_type_id == 1) runType = 'Local';
        if (run.run_type_id == 6) runType = 'Warehouse';

        allActivities = [], tba_count = 0;
        run.selectedPhases.forEach(phases =>{
          phases.selectedActivities.forEach(act => {
            allActivities.push(act);
            if(act.run_action_id == 1){
              let connote = this.fullConnotes.find(x=>x.id == act.connote_id)
              if (connote?.connote_sites.filter(obj => obj.run_action_id == 1).length == connote?.connote_sites.length) tba_count++;
            }
          });
        })

        switch(runType){
          case 'Linehaul':{
            let driv_check=[], equipment_check=[], activity_check= [], trailer_check = [], aChecker = []
            let trk_conflict = 0, trl_conflict = 0, check

            //resetting warehouse validations
            this.run_errors[count].phaseCheck = true;
            this.run_errors[count].warehouseError = false;
            this.run_errors[count].eq_warehouseError = false; 
            this.run_errors[count].trailerErrors = '';
            run.selectedPhases.forEach((phase, index:number) => {
              let conflict_check=0; run.checkTaskTime = true;
               
              if(index == 0){
                run.isStandardApplicable = true; run.isLicenceApplicable = true;  
                if (phase.selectedDriver.length != 0 && phase.selectedDriver.length <= 2) {    
                  driv_check[index] = true;

                  phase.selectedDriver.forEach((driver, i:number)=>{
                    driver.isLicenceApplicable = this.dispatchService.checkDriverLicence(run.service_type_id, driver.license_class_id)
                    if(driver.assignmentConflict == true) conflict_check ++;
                  })

                  if(conflict_check != 0) this.run_plan[count].check_conflict_drv = false; else this.run_plan[count].check_conflict_drv = true;
                  if(phase.selectedDriver.length == 2){
                    if(phase.selectedDriver[0].driver_standard_id != phase.selectedDriver[1].driver_standard_id) run.isStandardApplicable = false;
                    if(phase.selectedDriver[0].isLicenceApplicable != true || phase.selectedDriver[1].isLicenceApplicable != true){
                      run.isLicenceApplicable = false;
                      driv_check[index] = false;
                    }
                  } else {
                    if(phase.selectedDriver[0].isLicenceApplicable != true){
                      driv_check[index] = false;
                      run.isLicenceApplicable = false;
                    } 
                  }
                } else {
                  this.run_plan[count].check_conflict_drv = true; 
                  driv_check[index] = false;
                }

                if(run.service_type_id != null && phase.selectedFleet.length == 1){
                  let fleet_type = phase.selectedFleet[0].fleet_type_id, fleet_subtype = phase.selectedFleet[0].fleet_subtype_id
                  equipment_check[index] = true;

                  phase.selectedFleet[0].isTypeApplicable = this.dispatchService.checkFleet_EquipmentType(run.service_type_id, fleet_type, fleet_subtype)
                  this.run_plan[count].isFleetTypeApplicable = phase.selectedFleet[0].isTypeApplicable;

                  let check = this.dispatchService.checkTrailer_EquipmentType(run.service_type_id, phase.selectedTrailer,false)
                  this.trailerErrors = check.error
                  this.run_errors[count].trailerErrors = check.error;

                  if(run.selectedPhases[0].selectedFleet[0].isTypeApplicable != true || check.result != true) equipment_check[count] = false;
                } else this.run_plan[count].isFleetTypeApplicable = true;

                let trk_conflict = phase.selectedFleet.filter(val=> val.assignmentConflict == true).length
                let trl_conflict =  phase.selectedTrailer.filter(val => val.assignmentConflict == true).length

                trk_conflict != 0? this.run_plan[count].check_conflict_trk = false: this.run_plan[count].check_conflict_trk = true;
                trl_conflict != 0? this.run_plan[count].check_conflict_trl = false: this.run_plan[count].check_conflict_trl = true;

              } else {
                if(phase.selectedActivities.length != 0){
                  equipment_check[index] = true;
                  driv_check[index] = true;
                  conflict_check=0;


                  //driver validations other phase
                  if (phase.selectedDriver.length != 0 && phase.selectedDriver.length <= 2) {
                    driv_check[index]=false;
                    this.run_errors[count].warehouseError = true;
                    this.run_errors[count].warehouseErrorString = 'Assigned Drivers can only be placed at Phase 1.'
                  } else {
                    this.run_errors[count].warehouseError = false;
                    // this.run_plan[count].check_conflict_drv = true; 
                  }

                  //truck validations other phase
                  if(run.service_type_id != null && phase.selectedFleet.length == 1){
                    equipment_check[index]=false;
                    this.run_errors[count].eq_warehouseError = true;
                    this.run_errors[count].eq_warehouseString = 'Assigned Truck run can only be placed at Phase 1.'
                  } else {
                    this.run_errors[count].eq_warehouseError = false; 
                  }
                  phase.selectedFleet.forEach(trk => { if(trk.assignmentConflict == true) trk_conflict ++});
                }
              }

              //trailer validations
              check = this.dispatchService.checkTrailer_EquipmentType(run.service_type_id, phase.selectedTrailer,false)
              phase.selectedTrailer.forEach(trl => { if(trl.assignmentConflict == true) trl_conflict ++ });
              trailer_check[index] = check

              trk_conflict != 0? this.run_plan[count].check_conflict_trk = false: this.run_plan[count].check_conflict_trk = true;
              trl_conflict != 0? this.run_plan[count].check_conflict_trl = false: this.run_plan[count].check_conflict_trl = true;

              //trailer check
              let C = trailer_check.filter(function (val) { return val.result == true;}).length;

              if(C != 0 && C == trailer_check.length){
                this.run_errors[count].trailerErrors = '';
              } else {
                let tError = trailer_check.find(x=>x.result == false);
                this.run_errors[count].trailerErrors = tError.error;
              }

              //Checking changeover validity
              if(run.manifest_changeover != null){
                let task_release = allActivities.filter(x=>x.run_action == "release");
                let task_collect = allActivities.filter(x=>x.run_action == "collect");

                if(task_release.length > 0 && task_collect.length > 0){
                  task_release.forEach(el => {
                    let collect = task_collect.filter(x=>x.connote_id == el.connote_id);
                    (collect.length > 0)? run.checkChangeover = false: run.checkChangeover = true;
                  });

                  //check time
                  if(new Date(task_release[task_release.length-1].closing_datetime) > new Date(task_collect[0].opening_datetime)){
                    run.checkTaskTime = false;
                  } else run.checkTaskTime = true;
                } else run.checkChangeover = false;
              }
              //start of route checking
              if(allActivities.length > 1 && tba_count != allActivities.length){
                run.isRouteApplicable = false
                if(allActivities[0].run_action_id == 2 || allActivities[0].run_action_id == 15){
                  this.run_errors[count].startingError = true
                } else this.run_errors[count].startingError = false
                if(run.routeselected_id != null){
                  let first = allActivities[0] 
                  let end = allActivities[allActivities.length - 1]
                  if ((first.run_action_id == 1 || first.run_action_id == 4 || first.run_action_id == 5 || first.run_action_id == 10 || first.run_action_id == 14) &&
                    (end.run_action_id == 2 || end.run_action_id == 3 || end.run_action_id == 6 || end.run_action_id == 9 || end.run_action_id == 15)) {
                      let route = this.routes.find(x => x.id == run.routeselected_id);          
                    if (route.changeover_state_id != undefined) {
                      let changeover = allActivities.find(x => x.run_action_id == 3 || x.run_action_id == 4)
                      if(changeover != undefined){
                        if (first.state_id == route.start_state_id && (end.state_id == route.end_state_id || end.is_tba == true) && 
                        changeover.state_id == route.changeover_state_id) {        
                          run.isRouteApplicable = true;
                        } else run.isRouteApplicable = false;
                      } else run.isRouteApplicable = false;        
                    } else if (first.state_id == route.start_state_id && (end.state_id == route.end_state_id || end.is_tba == true)) {     
                      run.isRouteApplicable = true;
                    } else {
                      run.isRouteApplicable = false;}
                  } else {run.isRouteApplicable = false; }
                }
              } else if (allActivities != 0 && tba_count == allActivities.length){
                run.isRouteApplicable = true;
                if(run.routeselected_id != null){
                  let start = this.routes.find(x => x.id == run.routeselected_id).start_state_id
                  allActivities[0].state_id == start? run.isRouteApplicable = true: run.isRouteApplicable = false;
                }
              } else run.isRouteApplicable = false;
              this.run_plan[count].isRouteApplicable = run.isRouteApplicable


              //time checking - not roadtrain
              if(!this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){
                let first_act = allActivities[0]
                let suffixes = ['th','st','nd','rd'];
                if(allActivities.length > 1){
                  for (let i = 0; i < allActivities.length; i++) {
                    if(i != 0){
                      let startTime = new Date(first_act.closing_datetime)
                      let endTime = new Date(allActivities[i].opening_datetime)
                      if(endTime < startTime){
                        let bridge = " starts earlier than ";
                        let string = ((i+1) + (suffixes[i+1] || suffixes[0])) +" task ("+ new Date(endTime).toLocaleString() +
                            ")"+ bridge + ((i) + (suffixes[i] || suffixes[0]))+ " task ("+ new Date(startTime).toLocaleString() +").";
                        this.run_errors[count].timeError = true;
                        this.run_errors[count].timeErrorString = string;
                        break;
                      } else { 
                        if((endTime.toISOString() == startTime.toISOString()) && (first_act.run_action_id != allActivities[i].run_action_id)){
                          this.run_errors[count].timeError = true;
                          this.run_errors[count].timeErrorString = ((i+1) + (suffixes[i+1] || suffixes[0])) +" task ("+ new Date(endTime).toLocaleString() +
                          ") has same time as " + ((i) + (suffixes[i] || suffixes[0]))+ " task ("+ new Date(startTime).toLocaleString() +").";;
                          break;
                        } else {
                          this.run_errors[count].timeError = false;
                          this.run_errors[count].timeErrorString = '';
                          first_act = allActivities[i];
                          break;
                        }
                      } 
                    }
                  }
                } else {
                  this.run_errors[count].timeError = false;
                  this.run_errors[count].timeErrorString = '';
                }
              }

              //special job case checking
              let checker = false;
              let checkerString = "";
              if(allActivities.length > 0){
                let t_R = allActivities.filter(x=>x.run_action_id == 9);
                let t_C = allActivities.filter(x=>x.run_action_id == 10);
                if(t_R.length == 1 && t_C.length == 1){
                  if(allActivities.length == 2){
                    if(t_R[0].connote_id == t_C[0].connote_id){
                      if(allActivities[0].run_action_id != 10 && 
                        allActivities[allActivities.length-1].run_action_id != 9){
                        checker = true;
                        checkerString = 'Allowed combination for this is Trailer Collect - Trailer Release.'
                      }
                    } else {
                      checker = true;
                      checkerString = 'Job combination not allowed.'
                    }
                  } else {
                    let acts = allActivities.filter(x=>{
                        return ((x.run_action_id == 1 || x.run_action_id == 2) && x.connote_id == t_R[0].connote_id) 
                    })
                    if(acts.length > 0){
                      checker = true;
                      checkerString = 'Job combination not allowed.'
                    }
                  }
                } else if(t_R.length > 0){ 
                  let first = t_R[0];
                  let acts = allActivities.filter((x, i:number)=>{
                    return ((x?.run_action_id == 2 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                  })
                  if(acts.length > 0){
                    checkerString = 'Multiple trailer release/runs with both deliver and trailer release not allowed.'
                    checker = true;
                  } 

                } else if(t_C.length > 0){
                  let first = t_C[0];
                  let acts = allActivities.filter((x, i:number)=>{
                    return ((x?.run_action_id == 1 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                  })
                  if(acts.length > 0){
                    checkerString = 'Multiple trailer collect/runs with both pickup and trailer collect not allowed.'
                    checker = true;
                  }
                }
              }
              this.run_errors[count].combinationError = checker
              this.run_errors[count].combinationErrorString = checkerString

              //ER + LH condition
              // added condition ER changeover
              let erCount = allActivities.filter(obj => obj.run_action_id == 14 || obj.run_action_id == 15)
              if(run.manifest_changeover == null){
                if(erCount.length == 2){
                  if(allActivities.length == 2 && (allActivities[0].run_action_id == 14 && allActivities[1].run_action_id == 15)){
                    allow = true; this.run_plan[count].checkER = true;
                  } else if (allActivities.length > 2 && allActivities[0].run_action_id == 14 && allActivities[1].run_action_id == 15){
                    if(allActivities[allActivities.length-1].run_action_id == 2 || allActivities[allActivities.length-1].run_action_id == 3 || allActivities[allActivities.length-1].run_action_id == 9)
                    { allow = true; this.run_plan[count].checkER = true;} else {allow = false; this.run_plan[count].checkER = false;}
                  } else {
                    allow = false; this.run_plan[count].checkER = false;
                  }
                } else if(erCount.length == 1 || erCount.length > 0){
                  allow = false; this.run_plan[count].checkER = false;
                } else { this.run_plan[count].checkER = true;}
              } else this.run_plan[count].checkER = true;

              let A = driv_check.filter(function (val) { return val == true;}).length;
              if(A != 0 && A == driv_check.length) allowDriver = true; else allowDriver = false;
              
              let B = equipment_check.filter(function (val) { return val == true;}).length;
              if(B != 0 && B == equipment_check.length) allow = true; else allow = false;

              //Road Train Checker
              if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){
              //activities per phase checking - uses aChecker
              let activities = phase.selectedActivities
              let act_count = phase.selectedActivities.length
              if(act_count > 0){
                aChecker[index] = {'error': false, 'errString': ''};

                let start = activities[0]; let end = activities[act_count - 1];
                if((start.run_action_id == 1 || start.run_action_id == 10) && (end.run_action_id == 2 || end.run_action_id == 9)){
                  activity_check[index] = true;
                  let t_R = activities.filter(x=>x.run_action_id == 9);
                  let t_C = activities.filter(x=>x.run_action_id == 10);

                  if(t_R.length == 1 && t_C.length == 1){
                    if(activities.length == 2){
                      if(t_R[0].connote_id == t_C[0].connote_id){
                        if(activities[0].run_action_id != 10 && 
                          activities[activities.length-1].run_action_id != 9){
                            // aChecker[index] = {'error': true, 'errString': 'Allowed combination for this is Trailer Collect - Trailer Release.'}
                          aChecker[index]['error'] = true;
                          aChecker[index]['errString'] = 'Phase '+(index+1)+': Allowed combination for this is Trailer Collect - Trailer Release.'
                        }
                      } else {
                        aChecker[index]['error'] = true;
                        aChecker[index]['errString']  = 'Phase '+(index+1)+': Job combination not allowed.'
                      }
                    } else {
                      let acts = activities.filter(x=>{
                          return ((x.run_action_id == 1 || x.run_action_id == 2) && x.connote_id == t_R[0].connote_id) 
                      })
                      if(acts.length > 0){
                        aChecker[index]['error'] = true;
                        aChecker[index]['errString']  = 'Phase '+(index+1)+': Job combination not allowed.'
                      }
                    }
                  } else if(t_R.length > 0){ 
                    let first = t_R[0];
                    let acts = activities.filter((x, i:number)=>{
                      return ((x?.run_action_id == 2 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                    })
                    if(acts.length > 0){
                      aChecker[index]['errString']  = 'Phase '+(index+1)+': Multiple trailer release/runs with both deliver and trailer release not allowed.'
                      aChecker[index]['error'] = true;
                    } 
  
                  } else if(t_C.length > 0){
                    let first = t_C[0];
                    let acts = activities.filter((x, i:number)=>{
                      return ((x?.run_action_id == 1 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                    })
                    if(acts.length > 0){
                      aChecker[index]['errString']  = 'Phase '+(index+1)+': Multiple trailer collect/runs with both pickup and trailer collect not allowed.'
                      aChecker[index]['error'] = true;
                    }
                  }
                } else {
                  activity_check[index] = false;
                  aChecker[index]['error'] = true;
                  aChecker[index]['errString'] = 'Phase '+(index+1)+': Activity sequence is incorrect.'
                }
              } else activity_check[index] = false;
                
              // //time checking --allow same time for activities same as linehaul with removed time checking
              // let first_act = allActivities[0]
              // if(allActivities.length > 1){
              //   for (let i = 0; i < allActivities.length; i++) {
              //     if(i != 0){
              //       let startTime = new Date(first_act.closing_datetime)
              //       let endTime = new Date(allActivities[i].opening_datetime)
              //       if(endTime <= startTime){
              //         let suffixes = ['th','st','nd','rd'];
              //         let bridge = ((endTime.getDate() === startTime.getDate()) && (endTime.getTime() === startTime.getTime()))? " has same time as ": " starts earlier than ";
              //         let string = ((i+1) + (suffixes[i+1] || suffixes[0])) +" task ("+ new Date(endTime).toLocaleString() +
              //             ")"+ bridge + ((i) + (suffixes[i] || suffixes[0]))+ " task ("+ new Date(startTime).toLocaleString() +").";
              //         this.run_errors[count].timeError = true;
              //         this.run_errors[count].timeErrorString = string;
              //         break;
              //       } else { 
              //         this.run_errors[count].timeError = false;
              //         this.run_errors[count].timeErrorString = '';
              //         first_act = allActivities[i];
              //       } 
              //     }
              //   }
              // } else {
              //   this.run_errors[count].timeError = false;
              //   this.run_errors[count].timeErrorString = '';
              // }

              //warehouse combination checker
              let allErrors = aChecker.filter(x=>x.error == true)
              if(allErrors.length>0){
                this.run_errors[count].combinationError = true
                this.run_errors[count].combinationErrorString = allErrors[0].errString; //should be multi phase
              }
              // checks phases
              let act_checker = activity_check.filter(function (val) { return val == true;}).length;
                if(act_checker != 0 && act_checker == activity_check.length){
                  this.run_errors[count].phaseCheck = true;} else {this.run_errors[count].phaseCheck = false;
                  }

                if(this.run_errors[count].phaseCheck == true && allow == true) allow = true; else allow = false;
              }

            });
            
            // if(run.service_type_id == 10){
            //   let trailers =  this.getPlanTrailers(count);
            //   if(trailers.length < 6){
            //     this.run_errors[count].RTtrailerErrors = "Minimum of six (6) Trailers for Road Train."
            //   } else {
            //     this.run_errors[count].RTtrailerErrors = '';
            //   }
            // } else this.run_errors[count].RTtrailerErrors = '';
            break;
          } case 'Local':{
            let conflict_check=0;
            run.isRouteApplicable = true;
            run.isStandardApplicable = true; run.isLicenceApplicable = true;

            //resetting warehouse validations
            this.run_errors[count].phaseCheck = true;
            this.run_errors[count].warehouseError = false;
            this.run_errors[count].eq_warehouseError = false; 
            this.run_errors[count].trailerErrors = '';
            this.run_errors[count].combinationError = false; //used for local host error
            this.run_errors[count].combinationErrorString = ''; //used for local host error

            if (run.selectedPhases[0].selectedDriver.length != 0 && run.selectedPhases[0].selectedDriver.length <= 2){
              allowDriver = true;
              run.selectedPhases[0].selectedDriver.forEach((driver, i:number)=>{
                driver.isLicenceApplicable = this.dispatchService.checkDriverLicence(run.service_type_id, driver.license_class_id)
                if(driver.assignmentConflict == true) conflict_check ++;
              })

              if(conflict_check != 0) this.run_plan[count].check_conflict_drv = false; else this.run_plan[count].check_conflict_drv = true;
              if(run.selectedPhases[0].selectedDriver.length == 2){
                  if(run.selectedPhases[0].selectedDriver[0].driver_standard_id != run.selectedPhases[0].selectedDriver[1].driver_standard_id) run.isStandardApplicable = false;
                  if(run.selectedPhases[0].selectedDriver[0].isLicenceApplicable != true || run.selectedPhases[0].selectedDriver[1].isLicenceApplicable != true){
                    run.isLicenceApplicable = false;
                    allowDriver = false;
                    }
              } else {
                if(run.selectedPhases[0].selectedDriver[0].isLicenceApplicable != true){
                  run.isLicenceApplicable = false;
                  allowDriver = false;
                  }
              }
            } else allowDriver = false;

            if(run.service_type_id != null && run.selectedPhases[0].selectedFleet.length == 1){
              allow = true;
              // parameters
              let fleet_type = run.selectedPhases[0].selectedFleet[0].fleet_type_id, fleet_subtype = run.selectedPhases[0].selectedFleet[0].fleet_subtype_id

              run.selectedPhases[0].selectedFleet[0].isTypeApplicable = this.dispatchService.checkFleet_EquipmentType(run.service_type_id, fleet_type, fleet_subtype)
              this.run_plan[count].isFleetTypeApplicable = run.selectedPhases[0].selectedFleet[0].isTypeApplicable;

              let check = this.dispatchService.checkTrailer_EquipmentType(run.service_type_id, run.selectedPhases[0].selectedTrailer,false)
              this.trailerErrors = check.error
              this.run_errors[count].trailerErrors = check.error;

              if(run.selectedPhases[0].selectedFleet[0].isTypeApplicable != true || check.result != true) allow = false;
            } else this.run_plan[count].isFleetTypeApplicable = true;

            if(allActivities.length != 0){
              if(allActivities.filter(x=>x.run_action_id == 5).length != 0){ //local start
                let localstart_count = allActivities.filter(x=>x.run_action_id == 5).length
                if((localstart_count > 1) || (allActivities.length != 1)){
                  this.run_errors[count].combinationError = true;
                  this.run_errors[count].combinationErrorString = 'Only one Local Start is allowed';
                   allow = false;
                }
              } else if(allActivities[0].run_action_id == 1 || allActivities[0].run_action_id == 10){
                if(allActivities[allActivities.length-1].run_action_id != 2) allow = false;
              } else allow = false;
            }

            let trk_conflict = 0, trl_conflict= 0
            run.selectedPhases[0].selectedFleet.forEach(trk => { if(trk.assignmentConflict == true) trk_conflict ++});
            run.selectedPhases[0].selectedTrailer.forEach(trl => { if(trl.assignmentConflict == true) trl_conflict ++ });

            trk_conflict != 0? this.run_plan[count].check_conflict_trk = false: this.run_plan[count].check_conflict_trk = true;
            trl_conflict != 0? this.run_plan[count].check_conflict_trl = false: this.run_plan[count].check_conflict_trl = true;
            break;
          } case 'Warehouse':{
            let activity_check = [], driv_check=[], equipment_check=[], trailer_check=[], check
            let trk_conflict = 0, trl_conflict= 0, aChecker=[];
            this.run_errors[count].combinationError = false
            this.run_errors[count].combinationErrorString = ''

            this.run_plan[count].selectedPhases.forEach((phase, p_index:number)=>{
              let conflict_check=0; run.checkTaskTime = true;
              run.isStandardApplicable = true; run.isLicenceApplicable = true;

              if(p_index == 0){
                //driver validations first phase
                if (phase.selectedDriver.length != 0 && phase.selectedDriver.length <= 2) {    
                  driv_check[p_index] = true;
    
                  phase.selectedDriver.forEach((driver, i:number)=>{
                    driver.isLicenceApplicable = this.dispatchService.checkDriverLicence(run.service_type_id, driver.license_class_id)
                    if(driver.assignmentConflict == true) conflict_check ++;
                  })
    
                  if(conflict_check != 0) this.run_plan[count].check_conflict_drv = false; else this.run_plan[count].check_conflict_drv = true;
                  if(phase.selectedDriver.length == 2){
                    if(phase.selectedDriver[0].driver_standard_id != phase.selectedDriver[1].driver_standard_id) run.isStandardApplicable = false;
                    if(phase.selectedDriver[0].isLicenceApplicable != true || phase.selectedDriver[1].isLicenceApplicable != true){
                      run.isLicenceApplicable = false;
                      driv_check[p_index] = false;
                    }
                  } else {
                    if(phase.selectedDriver[0].isLicenceApplicable != true){
                      driv_check[p_index] = false;
                      run.isLicenceApplicable = false;
                    } 
                  }
                } else {
                  this.run_plan[count].check_conflict_drv = true; 
                  driv_check[p_index] = false;
                }
                //truck validations first phase
                if(run.service_type_id != null && phase.selectedFleet.length == 1){
                  let fleet_type = phase.selectedFleet[0].fleet_type_id, fleet_subtype = phase.selectedFleet[0].fleet_subtype_id
                  equipment_check[p_index] = true;

                  phase.selectedFleet[0].isTypeApplicable = this.dispatchService.checkFleet_EquipmentType(run.service_type_id, fleet_type, fleet_subtype)
                  this.run_plan[count].isFleetTypeApplicable = phase.selectedFleet[0].isTypeApplicable;

                  phase.selectedFleet.forEach(trk => { if(trk.assignmentConflict == true) trk_conflict ++});

                } else this.run_plan[count].isFleetTypeApplicable = true;
              } else {
                //driver validations other phase
                if (phase.selectedDriver.length != 0 && phase.selectedDriver.length <= 2) {
                  driv_check[p_index]=false;
                  this.run_errors[count].warehouseError = true;
                  this.run_errors[count].warehouseErrorString = 'Drivers for warehousing can only be placed at Phase 1.'
                } else {
                  this.run_errors[count].warehouseError = false;
                }
                //truck validations other phase
                if(run.service_type_id != null && phase.selectedFleet.length == 1){
                  equipment_check[p_index]=false;
                  this.run_errors[count].eq_warehouseError = true;
                  this.run_errors[count].eq_warehouseString = 'Trucks for warehousing can only be placed at Phase 1.'
                } else {
                  this.run_errors[count].eq_warehouseError = false; 
                }

                phase.selectedFleet.forEach(trk => { if(trk.assignmentConflict == true) trk_conflict ++});
              }

              //trailer validations
              check = this.dispatchService.checkTrailer_EquipmentType(run.service_type_id, phase.selectedTrailer,false)
              phase.selectedTrailer.forEach(trl => { if(trl.assignmentConflict == true) trl_conflict ++ });
              trailer_check[p_index] = check

              trk_conflict != 0? this.run_plan[count].check_conflict_trk = false: this.run_plan[count].check_conflict_trk = true;
              trl_conflict != 0? this.run_plan[count].check_conflict_trl = false: this.run_plan[count].check_conflict_trl = true;

              //activities per phase checking - uses aChecker
              let activities = phase.selectedActivities
              let act_count = phase.selectedActivities.length
              if(act_count > 0){
                aChecker[p_index] = {'error': false, 'errString': ''};

                let start = activities[0]; let end = activities[act_count - 1];
                if((start.run_action_id == 1 || start.run_action_id == 10) && (end.run_action_id == 2 || end.run_action_id == 9)){
                  activity_check[p_index] = true;
                  let t_R = activities.filter(x=>x.run_action_id == 9);
                  let t_C = activities.filter(x=>x.run_action_id == 10);

                  if(t_R.length == 1 && t_C.length == 1){
                    if(activities.length == 2){
                      if(t_R[0].connote_id == t_C[0].connote_id){
                        if(activities[0].run_action_id != 10 && 
                          activities[activities.length-1].run_action_id != 9){
                          aChecker[p_index]['error'] = true;
                          aChecker[p_index]['errString'] = 'Phase '+(p_index+1)+': Allowed combination for this is Trailer Collect - Trailer Release.'
                        }
                      } else {
                        aChecker[p_index]['error'] = true;
                        aChecker[p_index]['errString']  = 'Phase '+(p_index+1)+': Job combination not allowed.'
                      }
                    } else {
                      let acts = activities.filter(x=>{
                          return ((x.run_action_id == 1 || x.run_action_id == 2) && x.connote_id == t_R[0].connote_id) 
                      })
                      if(acts.length > 0){
                        aChecker[p_index]['error'] = true;
                        aChecker[p_index]['errString']  = 'Phase '+(p_index+1)+': Job combination not allowed.'
                      }
                    }
                  } else if(t_R.length > 0){ 
                    let first = t_R[0];
                    let acts = activities.filter((x, i:number)=>{
                      return ((x?.run_action_id == 2 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                    })
                    if(acts.length > 0){
                      aChecker[p_index]['errString']  = 'Phase '+(p_index+1)+': Multiple trailer release/runs with both deliver and trailer release not allowed.'
                      aChecker[p_index]['error'] = true;
                    } 
  
                  } else if(t_C.length > 0){
                    let first = t_C[0];
                    let acts = activities.filter((x, i:number)=>{
                      return ((x?.run_action_id == 1 && x.connote_id == first.connote_id)||(x?.run_action_id == first.run_action_id && x.connote_id == first.connote_id && x.u_id != first.u_id)) 
                    })
                    if(acts.length > 0){
                      aChecker[p_index]['errString']  = 'Phase '+(p_index+1)+': Multiple trailer collect/runs with both pickup and trailer collect not allowed.'
                      aChecker[p_index]['error'] = true;
                    }
                  }
                } else {
                  activity_check[p_index] = false;
                  aChecker[p_index]['error'] = true;
                  aChecker[p_index]['errString'] = 'Phase '+(p_index+1)+': Activity sequence is incorrect.'
                }
              } else activity_check[p_index] = false;
            })

            this.checkInfo('drivers');
            this.checkInfo('truck');
            this.checkInfo('trailer');
            
            //trailer check
            let C = trailer_check.filter(function (val) { return val.result == true;}).length;
            if(C != 0 && C == trailer_check.length){
              this.run_errors[count].trailerErrors = '';
            } else {
              let tError = trailer_check.find(x=>x.result == false);
              this.run_errors[count].trailerErrors = tError.error;
            }

            let B = equipment_check.filter(function (val) { return val == true;}).length;
            if(B != 0 && B == equipment_check.length && this.run_errors[count].trailerErrors == '') allow = true; else allow = false;

            //driver check
            let A = driv_check.filter(function (val) { return val == true;}).length;
            if(A != 0 && A == driv_check.length) allowDriver = true; else allowDriver = false;
            

            // checks phases
            let act_checker = activity_check.filter(function (val) { return val == true;}).length;
            if(act_checker != 0 && act_checker == activity_check.length){
              this.run_errors[count].phaseCheck = true;} else {this.run_errors[count].phaseCheck = false;}
            
            if(this.run_errors[count].phaseCheck == true && allow == true) allow = true; else allow = false;

            //start of route checking
            if(allActivities.length > 1 && tba_count != allActivities.length){
              run.isRouteApplicable = false
              if(allActivities[0].run_action_id == 2 || allActivities[0].run_action_id == 15){
                this.run_errors[count].startingError = true
              } else this.run_errors[count].startingError = false
              if(run.routeselected_id != null){
                let first = allActivities[0] 
                let end = allActivities[allActivities.length - 1]
                if ((first.run_action_id == 1 || first.run_action_id == 4 || first.run_action_id == 5 || first.run_action_id == 10 || first.run_action_id == 14) &&
                  (end.run_action_id == 2 || end.run_action_id == 3 || end.run_action_id == 6 || end.run_action_id == 9 || end.run_action_id == 15)) {
                    let route = this.routes.find(x => x.id == run.routeselected_id);          
                  if (route.changeover_state_id != undefined) {
                    let changeover = allActivities.find(x => x.run_action_id == 3 || x.run_action_id == 4)
                    if(changeover != undefined){
                      if (first.state_id == route.start_state_id && (end.state_id == route.end_state_id || end.is_tba == true) && 
                      changeover.state_id == route.changeover_state_id) {        
                        run.isRouteApplicable = true;
                      } else run.isRouteApplicable = false;
                    } else run.isRouteApplicable = false;        
                  } else if (first.state_id == route.start_state_id && (end.state_id == route.end_state_id || end.is_tba == true)) {     
                    run.isRouteApplicable = true;
                  } else {
                    run.isRouteApplicable = false;}
                } else {run.isRouteApplicable = false; }
              }
            } else if (allActivities != 0 && tba_count == allActivities.length){
              run.isRouteApplicable = true;
              if(run.routeselected_id != null){
                let start = this.routes.find(x => x.id == run.routeselected_id).start_state_id
                allActivities[0].state_id == start? run.isRouteApplicable = true: run.isRouteApplicable = false;
              }
            } else run.isRouteApplicable = false;
            this.run_plan[count].isRouteApplicable = run.isRouteApplicable

            //time checking --allow same time for activities same as linehaul with removed time checking
            // let first_act = allActivities[0]
            // if(allActivities.length > 1){
            //   for (let i = 0; i < allActivities.length; i++) {
            //     if(i != 0){
            //       let startTime = new Date(first_act.closing_datetime)
            //       let endTime = new Date(allActivities[i].opening_datetime)
            //       if(endTime <= startTime){
            //         let suffixes = ['th','st','nd','rd'];
            //         let bridge = ((endTime.getDate() === startTime.getDate()) && (endTime.getTime() === startTime.getTime()))? " has same time as ": " starts earlier than ";
            //         let string = ((i+1) + (suffixes[i+1] || suffixes[0])) +" task ("+ new Date(endTime).toLocaleString() +
            //             ")"+ bridge + ((i) + (suffixes[i] || suffixes[0]))+ " task ("+ new Date(startTime).toLocaleString() +").";
            //         this.run_errors[count].timeError = true;
            //         this.run_errors[count].timeErrorString = string;
            //         break;
            //       } else { 
            //         this.run_errors[count].timeError = false;
            //         this.run_errors[count].timeErrorString = '';
            //         first_act = allActivities[i];
            //       } 
            //     }
            //   }
            // } else {
            //   this.run_errors[count].timeError = false;
            //   this.run_errors[count].timeErrorString = '';
            // }

            //warehouse combination checker
            let allErrors = aChecker.filter(x=>x.error == true)
            if(allErrors.length>0){
              this.run_errors[count].combinationError = true
              this.run_errors[count].combinationErrorString = allErrors[0].errString; //should be multi phase
            }
            break;
          } default: break;
        }

        if(this.run_plan[count].checkLoad == 0 || this.run_plan[count].checkLoad == 2 || this.run_plan[count].checkLoad == 3 ) allow = false; 
        if(run.isStandardApplicable == false || run.isFleetTypeApplicable == false) allow = false;
        let allowcount = 0; 
        if(allActivities.length != 0){
          allActivities.forEach(act => { 
            if(run.run_type_id == 2){
              if(act.run_type_id == 2 || act.run_type_id == 3) allowcount++;
            } else if(run.run_type_id == 1){
              if(act.run_type_id == 1) allowcount++;
            } else if(run.run_type_id == 4){
              if(act.run_type_id == 4) allowcount++;
            } else if(run.run_type_id == 6){
              if(act.run_type_id == 2 || act.run_type_id == 6) allowcount++;
            }
          });
          if(allActivities.length != allowcount){
            allow = false;
            this.run_plan[count].checkActivities = false;
          } else this.run_plan[count].checkActivities = true;

        } else run.isRouteApplicable = true;
      } else allow = false;
      if( this.run_plan[count].checkTaskTime == false || this.run_plan[count].checkChangeover == false || 
          this.run_plan[count].checkAtrailer == true || this.run_plan[count].check_Driver == false ||
          this.run_plan[count].check_Truck == false || this.run_plan[count].check_regoExpiry == true || 
          this.run_plan[count].check_regoTrailerExpiry == true ||
          this.run_errors[count].startingError == true || this.run_errors[count].combinationError == true || 
          this.run_plan[count].checkER == false || this.run_plan[count].check_trl_dups == true ||
          this.run_errors[count].trailerErrors != '') allow = false;
      
      this.run_plan[count].isRouteApplicable = run.isRouteApplicable
       allowDriver == true && allow == true && run.isRouteApplicable == true? final_allow[count]= true: final_allow[count] = false;
      });

    allowcheck = final_allow.filter(function (val) { return val == true;}).length;
    if(allowcheck == final_allow.length) return true; else return false;
  }

  public compareDates(startDate, endDate) {
    let formattedStartDate = formatDate(startDate, 'yyy-MM-dd', 'en_US');
    let formattedEndDate = formatDate(endDate, 'yyyy-MM-dd', 'en_US');

    return formattedStartDate < formattedEndDate;
  }

  public checkLocations(){
    const run_action = this.addTaskForm.controls.run_action_id.value;
    const FormCtrl = <FormArray>(<any>this.addTaskForm.controls);
    const ReleaseCtrl = FormCtrl['releasePoint'].controls;
    const CollectCtrl = FormCtrl['collectPoint'].controls;
    
    let final = false;
    let tba = (FormCtrl['site_source'].value).is_tba;
  
    if(run_action == 0){ //two locations
      if(ReleaseCtrl.location_id.value != null && ReleaseCtrl.state_id.value != '' && 
        CollectCtrl.location_id.value != null && CollectCtrl.state_id.value != ''){
          final = true
        }

      } else { //one location
        if(tba == false){
          if (ReleaseCtrl.location_id.value != null && ReleaseCtrl.state_id.value != '' && ReleaseCtrl.state.value != '' && ReleaseCtrl.suburb.value != '' && ReleaseCtrl.postal_code.value != '') final = true; 
        } else final = true; //if TBA location is not required
      
      }
    if(this.checkDateTime && this.checkCollectRelease && final) return true; else return false;
  }

  public checkDates(){
    this.checkWeekend = true;
    this.checkDateTime = false;
    this.checkCollectRelease = false;

    let date1 = { // default date/release date
      "date": this.addTaskForm.controls.releasePoint.get('date').value,
      "starttime": this.addTaskForm.controls.releasePoint.get('start_time').value,
      "endtime": this.addTaskForm.controls.releasePoint.get('end_time').value
    }
    let date2 = { // collect date
      "date": this.addTaskForm.controls.collectPoint.get('date').value,
      "starttime": this.addTaskForm.controls.collectPoint.get('start_time').value,
      "endtime": this.addTaskForm.controls.collectPoint.get('end_time').value
    }

    let collect_start, collect_end, con_col
    if(date1.date !=null){

      let check_start = new Date(date1.date + ' ' + date1.starttime.hour + ":" + date1.starttime.minute + ":00");
      let selectedStart = new Date(this.selectedTimeDate.start);
      
      switch(this.selectedTimeDate.set){
        case 'no_pickup':{ //greater than pickup/tc datetime
          this.checkCollectRelease = true;
          break;
        } case 'no_delivery':{ //less than delivery/tr datetime
          if(check_start > selectedStart) this.checkDateTime = true;
          this.checkCollectRelease = true;
          break;
        } case 'paired': {
            if(check_start > selectedStart){
              this.selectedTimeDate.start_col = date1.date + ' ' + date1.starttime.hour + ":" + date1.starttime.minute + ":00";
              this.checkCollectRelease = false;
              this.checkDateTime = true;
              
              if(this.addTaskForm.get('run_action_id').value == 5 || this.addTaskForm.get('run_action_id').value == 0){
                if(date2.date != null){
                  collect_start = new Date(date2.date + ' ' + date2.starttime.hour + ":" + date2.starttime.minute + ":00");
                  collect_end = collect_start;
                  
                  con_col = new Date(this.selectedTimeDate.start_col)
                  if((collect_start > con_col)){
                    this.checkCollectRelease = true; 
                  }else this.checkCollectRelease = false;
                }
              } else {
                this.checkCollectRelease = true;
                collect_start = check_start;
              }
              let sat = false, sun = false;
              if(this.run_plan[this.selectedIndex[0]].is_excluded_saturday == 1){
                check_start.getDay() == 6 || collect_start.getDay() == 6? sat = true: sat = false;
              }

              if(this.run_plan[this.selectedIndex[0]].is_excluded_sunday == 1){
                check_start.getDay() == 0 || collect_start.getDay() == 0? sun = true: sun = false;
              }
              this.checkWeekend = (sat == false && sun == false);
            // }   
          }else this.checkTime = false;
          break;
        } default: { break;}
      }
    }
  }

  geometryValue: boolean = true;
  geometryValue2: boolean = true;

  public checkDatesEdit(){ //only checks if start time < end time
    this.checkTime = false;
    let date1 = { // default date/release date
      "date": this.addTaskForm.controls.releasePoint.get('date').value,
      "starttime": this.addTaskForm.controls.releasePoint.get('start_time').value,
      "endtime": this.addTaskForm.controls.releasePoint.get('end_time').value
    }

    let start = new Date(date1.date + ' ' + date1.starttime.hour + ":" + date1.starttime.minute + ":00");

    let sat = false, sun = false;
    if(this.run_plan[this.selectedIndex[0]].is_excluded_saturday == 1){
      start.getDay() == 6 ? sat = true: sat = false;
    }

    if(this.run_plan[this.selectedIndex[0]].is_excluded_sunday == 1){
      start.getDay() == 0 ? sun = true: sun = false;
    }

    this.checkCollectRelease = true;
    this.checkWeekend = (sat == false && sun == false);
  }

  public async pickupAddressCallback(selectedData: any) {
    const pickupCtrl = <FormArray>(<any>this.addTaskForm).controls.releasePoint;

    const latCtrl = pickupCtrl.controls["lat"];
    const longCtrl = pickupCtrl.controls["long"];
    const streetNoCtrl = pickupCtrl.controls["street_no"];
    const streetCtrl = pickupCtrl.controls["street"];
    const suburbCtrl = pickupCtrl.controls["suburb"];
    const stateCtrl = pickupCtrl.controls["state"];
    const stateIDCtrl = pickupCtrl.controls["state_id"];
    const postalCodeCtrl = pickupCtrl.controls["postal_code"];
    const locationIdCtrl = pickupCtrl.controls["location_id"];

    latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateCtrl.reset();
    postalCodeCtrl.reset();
    locationIdCtrl.reset();
    stateIDCtrl.reset();

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.parse(JSON.stringify(selectedData));
    
      this.geometryValue = true
    if (selectedData) {
      this.mapObj = JSON.parse(JSON.stringify(selectedData));
      this.mapObj = this.mapObj.data;
      if(selectedData.response == true){
        if(this.mapObj?.geometry){
          this.geometryValue = true;
          this.locationSpinner = true;
          let lat = this.mapObj.geometry.location.lat;
          let lng = this.mapObj.geometry.location.lng;
          let location = this.locations.filter(function (x) { return x.lat == lat && x.lng == lng;});
          if(location.length != 0){
            let temp = location[location.length-1];
            console.log('address exists in directory')
            locationIdCtrl.setValue(temp.id)
            latCtrl.setValue(temp.lat);
            longCtrl.setValue(temp.lng);
            streetNoCtrl.setValue(temp.street_no);
            streetCtrl.setValue(temp.street);
            suburbCtrl.setValue(temp.suburb);
            postalCodeCtrl.setValue(temp.postal_code);
            stateIDCtrl.setValue(temp.state_id);

            if(temp.state_id != null && temp.state_id != 0){
              let stateinfo = this.states.find(x => x.id === location[location.length-1].state_id)
              stateCtrl.setValue(stateinfo.abbreviation);
              console.log('address changed [existing]: ', location[location.length-1].lat, location[location.length-1].lng);
            } else {
              this.geometryValue = false;
              console.log('Location selected has missing state_id.');}
              setTimeout(() => { this.locationSpinner = false;}, 500);
          } else {
            this.mapLat = this.mapObj.geometry.location.lat;
            this.mapLng = this.mapObj.geometry.location.lng;
  
            latCtrl.setValue(this.mapLat);
            longCtrl.setValue(this.mapLng);
            console.log('address changed [new]: ', this.mapLat, this.mapLng);
  
            for (let result of this.mapObj.address_components) {
              if (result.types == "street_number")
                streetNoCtrl.setValue(result.short_name);
              if (result.types == "route")
                streetCtrl.setValue(result.short_name);
              if (result.types.includes("locality"))
                suburbCtrl.setValue(result.short_name);
              if (result.types.includes("administrative_area_level_1"))
                stateCtrl.setValue(result.short_name);
              if (result.types.includes("postal_code"))
                postalCodeCtrl.setValue(result.short_name);
              }

            if(stateCtrl.value != null || stateCtrl.value != '' || stateCtrl.value != 0){
              let stateinfo = this.states.find(x => x.abbreviation === stateCtrl.value)
              if(stateinfo == undefined) this.geometryValue = false; else pickupCtrl.controls['state_id'].setValue(stateinfo.id);
            } else this.geometryValue = false;

            if(this.geometryValue == true){
              await this.dispatchService.createLocation(this.addTaskForm.controls.releasePoint.value).toPromise().then(async data => {
                if(data['error'] == false ){
                  locationIdCtrl.setValue(data['location_id'])
                } else {
                  this.toastr.error(data['message'],'', {
                    timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
                  });
                  this.locationSpinner = false;
                }
              })
              await this.getLocation();
              setTimeout(() => { this.locationSpinner = false;}, 1000);       
            } else this.locationSpinner = false
          }
        } else this.geometryValue = false

      }
    }
    console.table({geometry:this.geometryValue,formvalue:this.addTaskForm.valid,datetime:this.checkDateTime,collectrelease:this.checkCollectRelease})
  }

  public async pickup2AddressCallback(selectedData: any) {
    const pickupCtrl = <FormArray>(<any>this.addTaskForm).controls.collectPoint;

    const latCtrl = pickupCtrl.controls["lat"];
    const longCtrl = pickupCtrl.controls["long"];
    const streetNoCtrl = pickupCtrl.controls["street_no"];
    const streetCtrl = pickupCtrl.controls["street"];
    const suburbCtrl = pickupCtrl.controls["suburb"];
    const stateCtrl = pickupCtrl.controls["state"];
    const postalCodeCtrl = pickupCtrl.controls["postal_code"];
    const locationIdCtrl = pickupCtrl.controls["location_id"];
    const stateIDCtrl = pickupCtrl.controls["state_id"];

    latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateCtrl.reset();
    postalCodeCtrl.reset();
    locationIdCtrl.reset();
    stateIDCtrl.reset();

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.parse(JSON.stringify(selectedData));
    
      this.geometryValue2 = true
    if (selectedData) {
      this.mapObj = JSON.parse(JSON.stringify(selectedData));
      this.mapObj = this.mapObj.data;
      if(selectedData.response == true){
        if(this.mapObj?.geometry){
          this.geometryValue2 = true;
          this.locationSpinner = true;
          let lat = this.mapObj.geometry.location.lat;
          let lng = this.mapObj.geometry.location.lng;
          let location = this.locations.filter(function (x) { return x.lat == lat && x.lng == lng;});

          if(location.length != 0){
            let temp = location[location.length-1];
            console.log('address exists in directory.')
            locationIdCtrl.setValue(temp.id)
            latCtrl.setValue(temp.lat);
            longCtrl.setValue(temp.lng);
            streetNoCtrl.setValue(temp.street_no);
            streetCtrl.setValue(temp.street);
            suburbCtrl.setValue(temp.suburb);
            postalCodeCtrl.setValue(temp.postal_code);
            stateIDCtrl.setValue(temp.state_id);

            if(temp.state_id != null && temp.state_id != 0){
              let stateinfo = this.states.find(x => x.id === location[location.length-1].state_id)
              stateCtrl.setValue(stateinfo.abbreviation);
              console.log('address changed [existing]: ', location[location.length-1].lat, location[location.length-1].lng);
            } else {
              this.geometryValue2 = false;
              console.log('Location selected has missing state_id.');}
              setTimeout(() => { this.locationSpinner = false;}, 500);
          } else {
            this.mapLat = this.mapObj.geometry.location.lat;
            this.mapLng = this.mapObj.geometry.location.lng;
  
            latCtrl.setValue(this.mapLat);
            longCtrl.setValue(this.mapLng);
            console.log('address changed [new]', this.mapLat, this.mapLng);
  
            for (let result of this.mapObj.address_components) {
              if (result.types == "street_number")
                streetNoCtrl.setValue(result.short_name);
              if (result.types == "route")
                streetCtrl.setValue(result.short_name);
              if (result.types.includes("locality"))
                suburbCtrl.setValue(result.short_name);
              if (result.types.includes("administrative_area_level_1"))
                stateCtrl.setValue(result.short_name);
              if (result.types.includes("postal_code"))
                postalCodeCtrl.setValue(result.short_name);
              }

            if(stateCtrl.value != null || stateCtrl.value != '' || stateCtrl.value != 0){
              let stateinfo = this.states.find(x => x.abbreviation === stateCtrl.value)
              pickupCtrl.controls['state_id'].setValue(stateinfo.id)
              if(stateinfo == undefined) this.geometryValue2 = false;
            } else this.geometryValue2 = false;
            
            if(this.geometryValue2 == true){
              await this.dispatchService.createLocation(this.addTaskForm.controls.collectPoint.value).toPromise().then(async data => {
                if(data['error'] == false ){
                  locationIdCtrl.setValue(data['location_id'])
                } else {
                  this.toastr.error(data['message'],'', {
                    timeOut: 4000, positionClass: 'toast-top-right', progressBar: true
                  });
                  this.locationSpinner = false;
                }
              })
              await this.getLocation();
              setTimeout(() => { this.locationSpinner = false;}, 1000);       
            } else this.locationSpinner = false
          }
        } else this.geometryValue2 = false

      }
    }
    console.table({geometry:this.geometryValue2,formvalue:this.addTaskForm.valid,datetime:this.checkDateTime,collectrelease:this.checkCollectRelease})
  }

  public setWHAddress(type){
    if(type == 'rp'){
      const pickupCtrl = <FormArray>(<any>this.addTaskForm.controls.releasePoint)
      
      let index = pickupCtrl.get('locationString').value;
      let location = this.warehouse_addresses[index];

      const latCtrl = pickupCtrl.controls["lat"];
      const longCtrl = pickupCtrl.controls["long"];
      const streetNoCtrl = pickupCtrl.controls["street_no"];
      const streetCtrl = pickupCtrl.controls["street"];
      const suburbCtrl = pickupCtrl.controls["suburb"];
      const stateCtrl = pickupCtrl.controls["state"];
      const stateIdCtrl = pickupCtrl.controls["state_id"];
      const postalCodeCtrl = pickupCtrl.controls["postal_code"];
      const locationIdCtrl = pickupCtrl.controls["location_id"];
      
      latCtrl.reset(); longCtrl.reset();
      streetNoCtrl.reset(); streetCtrl.reset();
      suburbCtrl.reset(); stateCtrl.reset();
      stateIdCtrl.reset(); postalCodeCtrl.reset();
      locationIdCtrl.reset(); stateIdCtrl.reset();

      if(location){
        latCtrl.setValue(location.lat);
        longCtrl.setValue(location.lng);
        streetNoCtrl.setValue(location.street_no);
        streetCtrl.setValue(location.street);
        suburbCtrl.setValue(location.suburb);
        postalCodeCtrl.setValue(location.postal_code);
        locationIdCtrl.setValue(location.location_id);
        let stateinfo = this.states.find(x => x.id === location.state_id)
        stateCtrl.setValue(stateinfo.abbreviation);
        stateIdCtrl.setValue(location.state_id);
      }

    } else {
      const pickupCtrl = <FormArray>(<any>this.addTaskForm.controls.collectPoint)
      let index = pickupCtrl.get('locationString').value;
      let location = this.warehouse_addresses[index];

      const latCtrl = pickupCtrl.controls["lat"];
      const longCtrl = pickupCtrl.controls["long"];
      const streetNoCtrl = pickupCtrl.controls["street_no"];
      const streetCtrl = pickupCtrl.controls["street"];
      const suburbCtrl = pickupCtrl.controls["suburb"];
      const stateCtrl = pickupCtrl.controls["state"];
      const stateIdCtrl = pickupCtrl.controls["state_id"];
      const postalCodeCtrl = pickupCtrl.controls["postal_code"];
      const locationIdCtrl = pickupCtrl.controls["location_id"];
      
      latCtrl.reset(); longCtrl.reset();
      streetNoCtrl.reset(); streetCtrl.reset();
      suburbCtrl.reset(); stateCtrl.reset();
      stateIdCtrl.reset(); postalCodeCtrl.reset();
      locationIdCtrl.reset(); stateIdCtrl.reset();

      if(location){
        latCtrl.setValue(location.lat);
        longCtrl.setValue(location.lng);
        streetNoCtrl.setValue(location.street_no);
        streetCtrl.setValue(location.street);
        suburbCtrl.setValue(location.suburb);
        postalCodeCtrl.setValue(location.postal_code);
        locationIdCtrl.setValue(location.location_id);
        let stateinfo = this.states.find(x => x.id === location.state_id)
        stateCtrl.setValue(stateinfo.abbreviation);
        stateIdCtrl.setValue(location.state_id);
      }
    }
  }

  public selectLocation(event, loc_point){
    if(loc_point == 'rp'){
      const pickupCtrl = <FormArray>(<any>this.addTaskForm.controls.releasePoint)

      const location_id = pickupCtrl.controls["location_id"];
      const latCtrl = pickupCtrl.controls["lat"];
      const longCtrl = pickupCtrl.controls["long"];
      const streetNoCtrl = pickupCtrl.controls["street_no"];
      const streetCtrl = pickupCtrl.controls["street"];
      const suburbCtrl = pickupCtrl.controls["suburb"];
      const stateCtrl = pickupCtrl.controls["state"];
      const stateIDCtrl = pickupCtrl.controls["state_id"];
      const postalCodeCtrl = pickupCtrl.controls["postal_code"];
      const locationStringCtrl = pickupCtrl.controls["locationString"];
      const locationTypeCtrl = pickupCtrl.controls["location_type"];

      location_id.reset(); latCtrl.reset();
      longCtrl.reset(); streetNoCtrl.reset();
      streetCtrl.reset(); suburbCtrl.reset();
      stateCtrl.reset(); stateIDCtrl.reset();
      postalCodeCtrl.reset();

      if(event == 'warehouse'){
        this.showDetails = false;
        locationStringCtrl.setValue('');
      }
      
      locationTypeCtrl.setValue(event);
    } else if(loc_point == 'cp'){
      const pickupCtrl = <FormArray>(<any>this.addTaskForm.controls.collectPoint)

      const location_id = pickupCtrl.controls["location_id"];
      const latCtrl = pickupCtrl.controls["lat"];
      const longCtrl = pickupCtrl.controls["long"];
      const streetNoCtrl = pickupCtrl.controls["street_no"];
      const streetCtrl = pickupCtrl.controls["street"];
      const suburbCtrl = pickupCtrl.controls["suburb"];
      const stateCtrl = pickupCtrl.controls["state"];
      const stateIDCtrl = pickupCtrl.controls["state_id"];
      const postalCodeCtrl = pickupCtrl.controls["postal_code"];
      const locationStringCtrl = pickupCtrl.controls["locationString"];
      const locationTypeCtrl = pickupCtrl.controls["location_type2"];

      location_id.reset(); latCtrl.reset(); longCtrl.reset();
      streetNoCtrl.reset(); streetCtrl.reset();
      suburbCtrl.reset(); stateCtrl.reset();
      stateIDCtrl.reset(); postalCodeCtrl.reset();

      if(event == 'warehouse'){
        this.showDetails2 = false;
        locationStringCtrl.setValue('');
      }
      locationTypeCtrl.setValue(event);
    }
  }
  public toggleSearch(type) {
    switch(type){
      case 'activity':{
        this.showActivitySearch ? this.showActivitySearch = false : this.showActivitySearch = true;
        break;
      } case 'driver':{
        this.showDriverSearch ? this.showDriverSearch = false : this.showDriverSearch = true;
        break;
      } case 'truck':{
        this.showTruckSearch ? this.showTruckSearch = false : this.showTruckSearch = true;
        break;
      } case 'trailer':{
        this.showTrailerSearch ? this.showTrailerSearch = false : this.showTrailerSearch = true;
        break;
      } default:{ break; } 
    }
  }

  public updateSearch(type){
    switch(type){
      case 'activity':{
        this.activitiesList = this.fullActivities;
        let keyActivity = this.fullActivities;
        if (this.searchActivity && this.searchActivity.length) {
          keyActivity = keyActivity.filter(data => {
            let street_no = data.location_street_no;
            let street = data.location_street;
            let suburb_city = "";
            data.location_suburb ? suburb_city = data.location_suburb : suburb_city = data.location_city;
            let state = data.state_abbrev;
            let postal_code = data.location_postal;

            let address = [street_no, street, suburb_city, state, postal_code].filter(Boolean).join(" ");
            return data.company_name?.toLowerCase().includes(this.searchActivity.toLowerCase()) 
              || data.control_no?.toLowerCase().includes(this.searchActivity.toLowerCase())
              || address?.toLowerCase().includes(this.searchActivity.toLowerCase());
          });
        }

        this.activitiesList = keyActivity;
        this.activitiesFilterChecking();
        break;
      }
      case 'driver':{
        this.complianceFilter();
        this.keyDriver = this.driverList;

        if (this.searchDriver && this.searchDriver.length) {
          this.keyDriver = this.keyDriver.filter(data => {
            if (data.first_name || data.last_name) return data.first_name?.toLowerCase().indexOf(this.searchDriver.toLowerCase()) !== -1 || !this.searchDriver.toLowerCase() || data.last_name?.toLowerCase().indexOf(this.searchDriver.toLowerCase()) !== -1;
          })
        }else if (this.checkFilters == true) return this.keyDriver.filter(data => data.is_expired == 0);
        else if (this.checkFilters == false) this.keyDriver = this.driverListArray;

        this.driverList = this.keyDriver;
        break;
      }
      case 'truck':{
        this.complianceFilter();
        this.keyTruck = this.trucksList;

        if (this.searchTruck && this.searchTruck.length) {
          this.keyTruck = this.keyTruck.filter(data => {
            if (data.rego){
              return data.rego.toLowerCase().indexOf(this.searchTruck.toLowerCase()) !== -1;
            }
          })
        }else if (this.checkFleetFilters == true) return this.keyTruck.filter(data => data.is_expired == 0);
        else if (this.checkFleetFilters == false) this.keyTruck = this.trucks;

        this.trucksList = this.keyTruck;
        break;
      }
      case 'trailer':{
        this.complianceFilter();
        this.keyTrailer = this.trailerList;

        if (this.searchTrailer && this.searchTrailer.length) {
          this.keyTrailer = this.keyTrailer.filter(data => {
            if (data.rego){
              return data.rego.toLowerCase().indexOf(this.searchTrailer.toLowerCase()) !== -1;
            }
          })
        }else if (this.checkTrailerFilters == true) return this.keyTrailer.filter(data => data.is_expired == 0);
        else if (this.checkTrailerFilters == false) this.keyTrailer = this.trailerList;
        
        this.trailerList = this.keyTrailer;
        break;
      }
      default:{ break; }
    }
  }

  gotoManifest(){
      this.modal.dismissAll();
      this.router.navigate(['dispatch/manifestlist/']);
    }

  reloadDispatch(){
    this.modal.dismissAll();
    this.loadingIndicator = true;
    this.resetDispatch('category_reset')
    this.resetDispatch('dispatch_area_reset')
    this.resetDispatch('all')
  }

  isTaskTypeHidden(typeID, run_type){
    let changeoverCheck = this.addedTasks.find(x=>(x.run_action_id == 3 || x.run_action_id == 4) && this.selectedConnote.id == x.connote_id)
    if((changeoverCheck != undefined || this.selectedTimeDate.set != "paired") && typeID == 5){
      return true; 
    } else if(run_type == 3 && (typeID == 9 || typeID == 10)){
      return true
    } else if(typeID == 3 || typeID == 4){
      return true;
    }else return false;
  }

  hideChangeoverOptions(){
    let actionValue = this.addTaskForm.get('run_action_id').value
    if(actionValue == 9 || actionValue == 10){
      return false } else return true
  }

  duplicateEquipment(from_runplan, to_run_plan){
    let tasks = [], tasks2=[], val
    this.run_plan[from_runplan].selectedPhases.forEach(x=>{
      let act = x.selectedActivities.find(tsk=>{ return tsk.run_action_id == 9 || tsk.run_action_id == 10})
      if(act!=undefined) tasks.push(act)
    })

    this.run_plan[to_run_plan].selectedPhases.forEach(x=>{
      let act = x.selectedActivities.find(tsk=>{return tsk.run_action_id == 9 || tsk.run_action_id == 10})
      if(act!=undefined) tasks2.push(act)
    })

    if(from_runplan == to_run_plan){
      val = true
    } else if(from_runplan != to_run_plan){
      tasks.length > 0 && tasks2.length > 0? val = false: val = true;
    }

    return val
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
		if (inDate && !inDate.includes('0000') ) {
			formatedDate = new Date(inDate.replace(/-/g, "/"));
			return formatedDate;
		}
		else return null;
	}

  closeEdit(){
    this.initAddTaskFormv2();
    this.modal.dismissAll();
  }

  showLocDetails(){ this.showDetails = !this.showDetails;}

  showLocDetails2(){ this.showDetails2 = !this.showDetails2;}

  autoSetLocation(i: number){
    let acts = this.getPlanActivities(i), start = acts[0], end = acts[acts.length-1], route;
    this.run_plan[i].routeselected_id = null;
    if(this.run_plan[i].run_type_id != 1 && acts.length > 1){
      if ((start.run_action_id == 1 || start.run_action_id == 4 || start.run_action_id == 5 || start.run_action_id == 10 || start.run_action_id == 14) &&
      (end.run_action_id == 2 || end.run_action_id == 3 || end.run_action_id == 6 || end.run_action_id == 9 || end.run_action_id == 15)) {
        let changeover = acts.find(x => x.run_action_id == 3 || x.run_action_id == 4);
        
        if(this.run_plan[i].manifest_changeover != null && changeover != undefined){ //changeover
          if(changeover){
            route = this.routes.find(x=>x.start_state_id == start.state_id && x.end_state_id == end.state_id && x.changeover_state_id == changeover.state_id);
          }
        } else route = this.routes.find(x=>x.start_state_id == start.state_id && x.end_state_id == end.state_id && x.changeover_state_id == null);
        
        if(route) this.run_plan[i].routeselected_id = route.id;
      }
    }
  }

  getPlanActivities(i: number){
    let allActivities = [];
        this.run_plan[i].selectedPhases.forEach((phases, index:number)=>{
          phases.selectedActivities.forEach(act => {
            act.phase_order_number = index+1;
            allActivities.push(act);
          });
        })

    return (allActivities);
  }

  getPlanTrailers(i: number){
    let planTrailers = [];
        this.run_plan[i].selectedPhases.forEach( phases =>{
          phases.selectedTrailer.forEach(trl => { planTrailers.push(trl)});
        })
    return (planTrailers);
  }

  sortRoadTrain(activities){
    let acts = activities;
    const startPoints = [1,4,5,10,14], endPoints = [2,3,6,9,15];
  
    let startActs  = acts.filter(obj => startPoints.includes(obj.run_action_id));
    let endActs    = acts.filter(obj => endPoints.includes(obj.run_action_id));
    
    let count = 1; 
    let finalActs = [...startActs, ...endActs];
    finalActs.map(x => { x.order_number = count; count ++;});

    return finalActs;
  }

  checkRoadTrains(){
    let result = [], final;
    
    this.run_plan.forEach(run => {
      if(this.isServiceTypeMatch(run.service_type_id, ServiceTypeAbbreviations.RoadTrain)){
        let start = run.RTacts[0].run_action_id;
        let end = run.RTacts[run.RTacts.length-1].run_action_id;

        if(start == 1 || start == 4 || start == 10 || start == 14){
          (end == 2 || end == 3 || end == 9 || end == 15)? result.push(false): result.push(true);
        } else result.push(true)
      } else result.push(false);
    });

    (result.filter(x=> x == true).length > 0)? final = true: final = false;
    return final;
  }
}